export default {
  // Botón «Ver historial» al lado de un campo (showHistory en la definición)
  fieldHistory: {
    button: "Ver historial",
    title: "Historial de {field}",
    loading: "Cargando historial…",
    empty: "Todavía no hay cambios guardados.",
    error: "No se pudo cargar el historial.",
    original: "Original",
    current: "Actual",
    empty_value: "(vacío)",
    system: "Sistema",
    days: "{n} días",
    sinceOriginal: "{diff} respecto del original",
  },
  Pay: "Pagar",
  "Edit payment details": "Editar datos del pago",
  // «En la web» de la ficha: contactos y productos (se busca una sola vez)
  webProfile: {
    title: "Más información",
    searching: "Buscando información en la web…",
    notFound: "No encontramos información confiable en la web.",
    noKey: "Para buscar información falta la API key de DeepSeek en Ajustes.",
    noName: "No tiene nombre: no hay qué buscar.",
    error: "No se pudo buscar la información.",
    founded: "Fundada en {year}",
    products: "Productos y servicios",
    markets: "Mercados",
    links: "Enlaces",
    otherNames: "Otros nombres",
    origin: "Origen",
    presentations: "Presentaciones",
    uses: "Usos",
    searched: "Buscado el {date}",
    sources: "{n} fuentes",
    searchAgain: "Volver a buscar",
    addAll: "Agregar todas",
    inProduct: "Ya está en el producto",
    addToProduct: "Agregar al producto",
    applyError: "No se pudo agregar al producto.",
  },
  // Pestaña «Análisis» de la ficha de un producto (widgets)
  productWidgets: {
    catalogTitle: "Widgets de la ficha de productos",
    catalogSubtitle: "Elegí qué ver en la ficha de los productos: vale para todos. Los montos solo aparecen con permiso de finanzas; los de «Mercado» buscan en la web solo si agregás alguno.",
    empty: "Elegí qué querés ver de este producto.",
    truncated: "Se muestran los primeros 5000 renglones por fuente.",
    resetConfirmText: "Se vuelven a mostrar los widgets de fábrica en la ficha de todos los productos.",
    noSources: "No hay operaciones que puedas ver con este producto.",
    noOperations: "Sin operaciones de este lado.",
    noData: "Sin datos para mostrar.",
    noUnit: "sin unidad",
    first: "Primera",
    last: "Última",
    buyersCount: "Compradores",
    sellersCount: "Proveedores",
    qty: "Cantidad",
    total: "Total",
    showingLast: "Últimas {n} de {total}.",
    others: "Otros",
    sources: { contract: "Contratos", shipping: "Embarques", proform: "Proformas" },
    kinds: { sale: "Venta", purchase: "Compra", trade: "Corretaje" },
    measure: { qty: "Cantidad", operations: "Operaciones" },
    menu: {
      source: "Operaciones",
      side: "Lado",
      period: "Período",
      months: "Últimos {n} meses",
      allTime: "Todo",
      show: "Mostrar",
      top: "Top {n}",
      measure: "Medir por",
      unit: "Unidad",
    },
    items: {
      product_summary: { title: "Resumen", description: "Operaciones, primera y última, compradores, proveedores, cantidad y total." },
      product_operations: { title: "Últimas operaciones", description: "Dónde aparece el producto, con quién, cuánto y por cuánto." },
      product_by_month: { title: "Por mes", description: "Cantidad u operaciones de cada mes." },
      product_buyers: { title: "Compradores", description: "A quién se vendió más, por cantidad u operaciones." },
      product_sellers: { title: "Proveedores", description: "A quién se compró más, por cantidad u operaciones." },
      product_volume: { title: "Volumen por mes", description: "Monto de cada mes, en una moneda." },
      product_price: { title: "Precio promedio", description: "Precio por unidad de cada mes: monto sobre cantidad." },
      product_market: { title: "Mercado: resumen", description: "Cómo está el mercado del producto, según la web. Busca solo si agregás algún widget de mercado." },
      product_market_exporters: { title: "Mercado: exportadores", description: "Principales países exportadores, con cifras cuando la web las da." },
      product_market_importers: { title: "Mercado: importadores", description: "Principales países importadores, con cifras cuando la web las da." },
      product_market_prices: { title: "Mercado: precios", description: "Precios publicados en la web, con fecha y moneda." },
      product_market_trends: { title: "Mercado: tendencias", description: "Qué está cambiando en el mercado del producto." },
      product_market_companies: { title: "Mercado: empresas", description: "Empresas que lo comercian, según la web." },
    },
    market: {
      searching: "Buscando datos de mercado en la web…",
      notFound: "No encontramos datos de mercado confiables para este producto.",
      emptySection: "La búsqueda no trajo datos para esta parte.",
      fromWeb: "Según la web, {date}: verificá en las fuentes",
    },
  },
  // Pestaña «Análisis» de la ficha de un contacto (widgets)
  contactWidgets: {
    catalogTitle: "Widgets de la ficha de contactos",
    catalogSubtitle: "Elegí qué ver en la ficha de los contactos: vale para todos. Los montos solo aparecen con permiso de finanzas.",
    tab: "Análisis",
    empty: "Elegí qué querés ver de este contacto.",
    truncated: "Se muestran las primeras 3000 operaciones.",
    resetConfirmText: "Se vuelven a mostrar los widgets de fábrica en la ficha de todos los contactos.",
    noSources: "No hay operaciones que puedas ver para este contacto.",
    noOperations: "Este contacto todavía no aparece en ninguna operación.",
    noData: "Sin datos para mostrar.",
    first: "Primera",
    last: "Última",
    productsCount: "Productos",
    counterpartsCount: "Contrapartes",
    total: "Total",
    showingLast: "Últimas {n} de {total}.",
    others: "Otros",
    with: "con {names}",
    sources: { contract: "Contratos", shipping: "Embarques", proform: "Proformas" },
    roles: {
      buyer: "Comprador",
      seller: "Vendedor",
      administrator: "Administración",
      client: "Cliente",
      supplier: "Proveedor",
      forwarder: "Forwarder",
      shippingLine: "Naviera",
    },
    measure: { qty: "Cantidad", operations: "Operaciones" },
    flow: { collected: "Cobrado", paid: "Pagado" },
    menu: {
      source: "Operaciones",
      period: "Período",
      months: "Últimos {n} meses",
      allTime: "Desde el principio",
      show: "Mostrar",
      top: "Los {n} primeros",
      measure: "Medir por",
      flow: "Movimientos",
    },
    items: {
      contact_summary: { title: "Resumen", description: "Cuántas operaciones, la primera y la última, productos y contrapartes." },
      contact_operations: { title: "Operaciones", description: "Las últimas operaciones del contacto, con su rol y con quién." },
      contact_by_month: { title: "Operaciones por mes", description: "Cuántas operaciones tuvo cada mes." },
      contact_by_role: { title: "Por rol", description: "En cuántas operaciones fue cliente, proveedor, comprador, vendedor…" },
      contact_products: { title: "Productos", description: "Qué productos opera, por cantidad o por cantidad de operaciones." },
      contact_counterparts: { title: "Con quién opera", description: "Las contrapartes con las que hizo más operaciones." },
      contact_volume: { title: "Volumen por mes", description: "Monto de las operaciones de cada mes, en una moneda." },
      contact_products_amount: { title: "Productos por monto", description: "Qué productos suman más plata, en una moneda." },
      contact_money_flow: { title: "Cobros y pagos", description: "Lo que se le cobró o se le pagó cada mes." },
    },
  },
  itemProfile: {
    tabProfile: "Datos",
    outgoing: "Pago saliente",
    incoming: "Cobro entrante",
    statusPaid: "Pagado",
    statusReceived: "Cobrado",
    partyMissing: "Sin asignar",
    files: "Archivos",
    noteGiving: "Nota emitida",
    noteReceiving: "Nota recibida",
    balances: "Saldos",
    copy: "Copiar",
    editHint: "Hacé clic en un campo para editarlo. Cada cambio se guarda al confirmarlo.",
    doneEditing: "Listo",
    addValue: "Agregar…",
    addRow: "Agregar fila",
    addAnother: "Agregar otro",
    moreInfo: "Más datos",
    unlockField: "Campo con candado: clic para editarlo",
    classicView: "Vista anterior",
    newView: "Vista nueva",
    classicViewHint: "Si no te gusta esta vista, podés volver a la anterior desde acá.",
    classicViewHintOk: "Entendido",
    generateNumber: "Generar número",
    general: "General",
    details: "Datos",
    saveError: "No se pudo guardar el campo",
  },
  // Obligatorios vacíos de un registro (listado y ficha, #473)
  missingRequired: {
    summary: "Faltan datos obligatorios",
    tooltip: "Faltan datos obligatorios: {fields}",
    field: "Obligatorio: falta completar",
  },
  calendarLegend: {
    fieldTooltip:
      "Sale del campo «{field}» del modelo {model} ({path}). El número cuenta los registros que tienen esa fecha en el mes que estás viendo. Qué fechas entran al calendario se elige en la definición del modelo (opción calendario del campo).",
    shippingStatusTooltip:
      "Embarques en estado «{status}»: el color es el estado del embarque, no el tipo de fecha. El número cuenta sus fechas de este mes que muestra el calendario.",
    groupCount: "{count} eventos",
    groupExpand: "{count} eventos de «{field}» este día. Click para verlos.",
    groupCollapse: "Click para agruparlos de nuevo.",
    toggleHide: "Click para ocultarlas del calendario.",
    toggleShow: "Ocultas: click para volver a mostrarlas.",
  },
  dateInput: {
    placeholder: "dd/mm/aaaa",
    openCalendar: "Abrir calendario",
    invalid: "Fecha inválida: usá dd/mm/aaaa",
  },
  listMerge: {
    button: "Unificar términos",
    buttonTitle: "Fundir términos repetidos o parecidos en uno solo, actualizando todos los registros que los usan",
    title: "Unificar términos",
    intro: "Armá grupos de términos que son lo mismo. En cada grupo queda un solo término: todos los registros que usan los demás pasan a usar ese, y los demás se eliminan del listado.",
    sameName: "Mismo nombre",
    similarName: "Nombres parecidos",
    similarityTitle: "Qué tan parecidos tienen que ser los nombres",
    pickByHand: "Elegir a mano",
    toolbarHint: "Las sugerencias solo agrupan términos con el mismo padre. Revisá cada grupo antes de seguir.",
    searchPlaceholder: "Buscar término…",
    createGroup: "Crear grupo ({count})",
    addToGroup: "Agregar al grupo ({count})",
    destinationNew: "Grupo nuevo",
    destinationGroup: "Grupo {n}: {label}",
    alreadyInGroup: "ya en un grupo",
    noTermsFound: "No hay términos que coincidan.",
    noGroups: "Todavía no hay grupos. Usá los botones de arriba para sugerir grupos o elegí los términos a mano.",
    groupN: "Grupo {n}",
    editGroup: "Editar",
    doneEditing: "Listo",
    removeFromGroup: "Sacar del grupo",
    editingHint: "Sacá términos con ⊖. Para sumar, elegilos arriba en «Elegir a mano»: este grupo ya quedó como destino.",
    discardGroup: "Descartar grupo",
    keeps: "Queda",
    include: "Incluir",
    term: "Término",
    uses: "Usos",
    keepsBadge: "queda",
    mergedBadge: "se funde",
    finalName: "Nombre final del término que queda (opcional)",
    groupNeedsTwo: "Este grupo no tiene ningún término para fundir: no se va a aplicar.",
    origin: {
      same: "Sugerido: mismo nombre",
      similar: "Sugerido: nombre parecido",
      manual: "Elegido a mano",
    },
    suggestionsAdded: "Se agregaron {count} grupos sugeridos.",
    noSuggestions: "No se encontraron grupos nuevos para sugerir.",
    buildFooter: "{groups} grupos listos, {terms} términos a fundir",
    review: "Revisar antes de unificar",
    confirmHeadline: "Vas a unificar <strong>{groups}</strong> grupos: se eliminan <strong>{terms}</strong> términos y se actualizan <strong>{records}</strong> registros. Revisá el detalle.",
    renamedFrom: "renombrado, antes «{label}»",
    legacyCopy: "copia vieja de la base, no se muestra en la app",
    nRecords: "1 registro | {count} registros",
    noRecords: "Ningún registro usa estos términos.",
    includesTrash: "Además hay {count} registros en la papelera que también se actualizan.",
    childrenMoved: "Pasan a colgar del término que queda: {children}",
    none: "ninguno",
    warnAccountingCode: "Código contable distinto. Queda el del término elegido ({target}); se pierde: {list}.",
    warnConversionRate: "Coeficiente de conversión distinto. Queda el del término elegido ({target}); se pierde: {list}.",
    warnColor: "Color distinto. Queda el del término elegido ({target}); se pierde: {list}.",
    warnParent: "Los términos tienen distinto padre. El que queda sigue bajo «{target}»; los demás estaban bajo: {list}.",
    warnDefinitionDefault: "Es el valor por defecto o el filtro de: {fields}. Se actualiza, pero quien tenga la app abierta sigue viendo la definición vieja hasta el próximo deploy: conviene hacerlo fuera de horario o elegir ese término como el que queda.",
    noteUndo: "Se puede deshacer con el botón «Deshacer unificación» mientras sea la última unificación de este listado.",
    noteOpenForms: "Un formulario que alguien tenga abierto ahora con un término que se elimina puede volver a guardarlo: conviene avisar antes.",
    acknowledge: "Entiendo que se eliminan {terms} términos y se modifican {records} registros.",
    back: "Volver",
    confirm: "Unificar",
    doneTitle: "Unificación hecha",
    doneBody: "Se eliminaron {terms} términos y se actualizaron {fields} campos.",
    doneSkipped: "{count} campos no se tocaron porque alguien los cambió mientras tanto.",
    doneUndoHint: "Si algo salió mal, usá «Deshacer unificación» en la página del listado.",
    close: "Cerrar",
    undoButton: "Deshacer unificación",
    undoTitle: "Deshacer la última unificación de este listado",
    undoConfirmTitle: "¿Deshacer la última unificación?",
    undoConfirmWho: "Hecha el {when} por {who}:",
    undoConfirmNote: "Los términos fundidos vuelven al listado y cada registro vuelve a su término anterior, salvo los que alguien haya cambiado después.",
    undoConfirmButton: "Sí, deshacer",
    undoDoneTitle: "Unificación deshecha",
    undoDone: "Se restauraron {restored} campos.",
    undoDoneWithConflicts: "Se restauraron {restored} campos. {conflicts} no se tocaron porque cambiaron después de la unificación.",
  },
  quickSearch: {
    placeholder: "Buscar en todo…",
    hint: "Escribí al menos 2 caracteres.",
    searching: "Buscando…",
    noResults: "Sin resultados.",
    error: "No se pudo buscar. Volvé a intentar.",
    current: "Actual",
  },
  myProfile: "Mi Perfil",
  billing: "Facturación",
  success: "Éxito",
  error: "Error",
  ok: "OK",
  accountStatementFilesCount: "{count} archivo | {count} archivos",
  accountStatementExpandAll: "Abrir todos",
  accountStatementCollapseAll: "Cerrar todos",
  Between: "Entre",
  "On or after": "En o después de",
  "On or before": "En o antes de",
  "Clear dates": "Borrar fechas",
  validationSaveFailedTitle: "Error de validación",
  validationSaveFailedIntro:
    "No se pudo guardar el registro debido a los siguientes errores:",
  validationSaveAnyway: "Guardar de todos modos",
  validationUnderstood: "Entendido",
  validationPendingAmountToApply: "Te queda un monto pendiente a aplicar",
  expenseFileMissingTitle: "Sin Related File adjunto",
  expenseFileMissingText:
    "Estás guardando sin adjuntar el Related File. ¿Querés proceder igual?",
  expenseFileMissingCancel: "Cancelar",
  contactOutsideOperationTitle: "Contacto fuera de la operación",
  shippingIncoherenceTitle: "Incoherencias en este embarque",
  contactOutsideOperationText:
    "{contact} no participa de {operations}: no es el cliente, el proveedor ni el contacto de ningún gasto. Si paga o cobra un tercero está bien; si no, revisá el contacto.",
  contactOutsideOperationCancel: "Revisar",
  contactOutsideOperationBanner:
    "Este registro está aplicado a {operations}, pero {contact} no participa de esa operación (no es el cliente, el proveedor ni el contacto de ningún gasto). Revisá que el contacto sea el correcto.",
  collectContactNotClientTitle: "El cobro no es del cliente",
  collectContactNotClientText:
    "{contact} no es el cliente de {operations}. Si paga un tercero por el cliente está bien; si no, revisá el contacto.",
  collectOverPendingTitle: "El cobro supera el pendiente",
  collectOverPendingLine:
    "Se aplican {applied} a {shipping}, que tiene pendiente {pending}: el excedente es {excess}.",
  collectOverPendingFooter:
    "Si guardás igual, se aplica hasta cubrir el pendiente y el excedente queda sin aplicar, como saldo a favor del contacto.",
  collectOverPendingAlsoNoFile: "Además, el cobro no tiene archivo.",
  collectContactNotClientBanner:
    "Este cobro está aplicado a {operations}, pero {contact} no es el cliente de esa operación. Revisá que el contacto sea el correcto.",
  validationForceSaveSessionTitle: "Sesión expirada",
  validationForceSaveSessionText:
    "No se pudo guardar de todos modos porque la sesión expiró. Recargá la página o volvé a iniciar sesión e intentá de nuevo.",
  validationForceSaveGenericText:
    "No se pudo completar el guardado forzado. Revisá la conexión e intentá de nuevo.",
  "Error accessing file.": "No se pudo abrir el archivo.",
  "Error accessing receipt file": "No se pudo abrir el comprobante",
  fileNotFoundInStorage:
    "El archivo no se encontró en el almacenamiento. Puede haber sido eliminado o no haberse subido correctamente.",
  routerNavLoading: "Cargando…",
  testEnvironmentBanner: "Versión de prueba — entorno local",
  testEnvironmentBannerHosted:
    "Versión de prueba — estás viendo una copia de test (no es producción)",
  "systemFeaturesPermissionDeniedTitle": "Sin permiso",
  "systemFeaturesPermissionDeniedText":
    "No tenés permiso para activar o desactivar características del sistema. Pedí a un administrador el permiso «Access system features» (systemfeatures.access) en tu rol.",
  "emailModulePermissionDeniedTitle": "Sin permiso",
  "emailModulePermissionDeniedText":
    "No tenés permiso para activar o desactivar el módulo de emails. Pedí a un administrador el permiso «Emails automáticos» (email.module.manage) en tu rol.",
  registerSuccessLogin: "Cuenta creada. Ya puede iniciar sesión.",
  registerConfirmEmailSent:
    "Le hemos enviado un link a su email ({email}) para confirmar su cuenta. Si no lo ha recibido revise su spam. Haga click en el link para confirmar la cuenta.",
  forgotPassword: "¿Olvidó su contraseña?",
  passwordResetEmail: "Ingrese su email y le enviaremos un link para crear una contraseña nueva.",
  passwordResetContinue: "Continuar",
  emailSent: "Restablecer contraseña",
  correctEmail: "Vamos a enviar el link para restablecer la contraseña a {email}. ¿Es correcto?",
  sendEmail: "Enviar email",
  pleaseinsertemail: "Ingrese el email con el que dio de alta la aplicación para ir a su aplicación.",
  goToMyApp: "Ir a mi aplicación",
  seeDemo: "Ver demo",
  incorrectUserOrPassword: "Usuario o contraseña incorrectos",
  loginLocked: "Demasiados intentos con contraseña incorrecta. La cuenta quedó bloqueada; probá de nuevo en {minutes} minutos.",
  accountconfirm: "Su cuenta fue confirmada, ya puede iniciar sesión.",
  getStarted: "Comenzar",
  register: "Registrarse",
  "Search fields...": "Buscar campos...",
  'No fields found for "{query}"': 'No se encontraron campos para "{query}"',
  "Type to search records...": "Escriba para buscar registros...",
  "Type to search a record...": "Escriba para buscar un registro...",
  "Manual stock calculation": "Cálculo manual de stock",

  // Register.vue (claves raíz para $t)
  name: "Nombre",
  email: "Correo electrónico",
  password: "Contraseña",
  businessName: "Nombre del negocio",
  login: "Iniciar sesión",
  confirmEmailText: "Revise su correo para confirmar la cuenta",
  nameAlreadyTaken: "Este nombre ya está en uso",
  errorCheckingRestaurantName:
    "Error al comprobar la disponibilidad del nombre",
  nameRequired: "El nombre es obligatorio",
  countryRequired: "El país es obligatorio",
  restaurantNameRequired: "El nombre del negocio es obligatorio",
  emailRequired: "El correo electrónico es obligatorio",
  emailInvalid: "El correo electrónico no es válido",
  passwordRequired: "La contraseña es obligatoria",
  userExists: "Ya existe una cuenta con este correo",
  registerCompanyLinkPlaceholder: "Link de tu negocio (opcional)",
  registerHelpBusinessUrl:
    "El nombre de tu negocio lo usaremos en la URL que tus clientes necesitarán para acceder a la aplicación.",
  registerHelpDedicatedDbConfirm:
    "Tras confirmar tu email, se creará la base de datos exclusiva para tu negocio (mismo usuario en esta instancia y en la nueva).",
  registerHelpDedicatedDbImmediate:
    "Se creará de inmediato la base de datos exclusiva para tu negocio (mismo usuario en esta instancia y en la nueva).",
  registerHelpCompanyLink:
    "Ingresa el link de instagram, facebook o sitio web de tu negocio para que podamos promocionarte en campañas de marketing.",
  registerHelpEmailConfirmBusiness:
    "Le enviaremos un email con un enlace para confirmar su cuenta; la base de datos de su negocio se crea al confirmar.",
  registerHelpEmailConfirmAny:
    "Le enviaremos un email con un enlace para confirmar su cuenta; hasta confirmarlo no podrá iniciar sesión.",
  registerConfirmSpamP1:
    "Si no encuentras el email verifica SPAM. Si no has recibido el email con el código no dudes en contactarnos para que podamos activar tu cuenta manualmente. Envíanos un email a contact@gotake.it o en nuestro Whatsapp de soporte técnico, pulse aquí:",
  registerConfirmWhatsapp: "Whatsapp",

  uiZoom: {
    title: "Zoom de pantalla",
    zoomIn: "Aumentar",
    zoomOut: "Reducir",
    reset: "Volver al 100%",
  },

  userMenu: {
    title: "Mi menú",
    intro:
      "Arrastra las entradas para reordenarlas o suéltalas dentro de contenedores. Puedes quitar del menú cualquier enlace (modelos, módulos activos, reportes); lo quitado no vuelve a aparecer solo: más abajo verás los que faltan respecto al menú del sistema y podrás incorporar cada uno con «Restaurar» cuando lo necesites. Puedes añadir enlaces propios (URL https, una ruta interna que empiece por /, mailto o tel). También puedes crear contenedores (carpetas). Los contenedores son solo de tu menú; no se comparten con otros salvo que un administrador use «Aplicar a todos los usuarios».",
    newContainer: "Nuevo contenedor",
    containerName: "Nombre",
    containerPlaceholder: "ej. Operaciones",
    addContainer: "Añadir contenedor",
    yourMenu: "Estructura del menú",
    dragHint:
      "Usa el asa para arrastrar. Puedes mover ítems entre la raíz y cualquier contenedor.",
    save: "Guardar menú",
    resetFromServer: "Recargar",
    saved: "Menú guardado",
    saveError: "No se pudo guardar el menú",
    loadError: "No se pudieron cargar los ajustes del menú",
    folderCreateError: "No se pudo crear el contenedor",
    deleteFolder: "Eliminar",
    deleteFolderHint: "Vacía el contenedor antes de eliminar",
    folderNotEmpty:
      "Quita todos los elementos de este contenedor antes de eliminarlo.",
    confirmDeleteFolder: "¿Eliminar este contenedor? Debe estar vacío.",
    deleteError: "No se pudo eliminar el contenedor",
    fixedTopNote:
      "Inicio (Dashboard) y Configuración siempre quedan arriba en el menú y no aparecen en esta lista.",
    reportsHint:
      "Los reportes aparecen como entradas sueltas: puedes reordenarlos, ponerlos en contenedores o arrastrarlos bajo su modelo (sangría) para que salgan en el menú desplegable del modelo.",
    modelSubmenuHint:
      "Arrastrá enlaces aquí para agruparlos bajo este modelo en el menú lateral (reportes, otros modelos, módulos, etc.). Si no ves la zona, abrí el bloque con la flecha.",
    reportsTag: "Reportes",

    editMenuLabel: "Editar título en el menú",
    editFolderName: "Renombrar contenedor",
    folderNamePlaceholder: "Nombre del contenedor",
    folderRenameError: "No se pudo renombrar el contenedor",
    menuLabelPlaceholder: "Vacío = nombre por defecto del sistema",
    menuLabelHint:
      "En cada modelo o enlace de módulo puedes poner un título distinto en el menú lateral sin tocar la definición del modelo. Los reportes siguen mostrando el nombre del reporte. Arrastra los enlaces de módulos (Stock, MEV, etc.) junto con los modelos para cambiar el orden.",
    removeFromMenu: "Quitar del menú",
    removeFromMenuHint:
      "Oculta esta entrada en tu barra lateral. Podés volver a incluirla con «Restaurar» junto a ese ítem en el bloque de abajo.",
    notInMenuTitle: "Fuera de tu menú",
    notInMenuHint:
      "Enlaces del sistema (módulos activos, modelos con permiso, reportes) que aún no están en tu estructura. Cada «Restaurar» incorpora solo ese enlace al final, sin cambiar el orden del resto.",
    notInMenuEmpty: "Nada pendiente: ya están todos en tu estructura.",
    notInMenuSearch: "Buscar en lo que falta…",
    notInMenuNoResults: "Nada coincide con la búsqueda.",
    groupModules: "Módulos",
    groupModels: "Modelos",
    groupReports: "Reportes",
    groupReportsOf: "Reportes de {model}",
    groupSettings: "Configuración",
    groupOther: "Otros",
    unknownReport: "Reporte eliminado o sin acceso",
    dropHere: "Suelta aquí para agrupar",
    restoreMissing: "Restaurar",
    restoreMissingOne: "Restaurar {name}",
    hideAddNew:
      "Ocultar «Añadir nuevo» para este modelo en el menú (el listado sigue igual).",
    hideAddNewShort: "Sin «Añadir nuevo»",
    modelSubmenuHintShort: "Soltá enlaces acá para agruparlos bajo este modelo.",
    applyToAllUsers: "Aplicar este menú a todos los usuarios",
    applyToAllConfirmTitle: "¿Sobrescribir el menú de todos los usuarios?",
    applyToAllConfirmHtml:
      '<p>Se reemplazará el menú guardado de <strong>todos los usuarios activos</strong> de esta instancia por la estructura que ves en el editor (tras la validación del servidor).</p><ul class="text-start small"><li>Cada usuario solo <strong>verá</strong> lo que sus permisos permiten (modelos, módulos, reportes).</li><li>Cada uno recibe su <strong>propia copia</strong> de tus contenedores (mismos nombres y estructura).</li><li>Las copias generadas en una aplicación anterior se sustituyen al volver a aplicar.</li></ul>',
    applyToAllConfirmYes: "Sí, aplicar a todos",
    applyToAllConfirmCancel: "Cancelar",
    applyToAllSuccess: "Menú aplicado a {count} usuarios.",
    applyToAllCustomizedHint:
      "<strong>{count} usuario(s) armaron su propio menú</strong> y lo perderían. Destildá a los que quieras dejar con el suyo.",
    applyToAllForbidden:
      "Necesitás el permiso de rol «Mi menú: aplicar a todos los usuarios» o ser administrador del sistema.",
    applyToAllError: "No se pudo aplicar el menú a todos los usuarios.",
    editUserMenuTitle: "Menú de otro usuario",
    editUserMenuHint:
      "Como administrador podés elegir a qué usuario le ordenás el menú. Lo que guardes se escribe en el menú de ese usuario, no en el tuyo.",
    editUserMenuField: "Usuario",
    editUserMenuOwn: "Mi propio menú",
    editUserMenuActive:
      "Estás editando el menú de {name}: guardar, crear contenedores y «Restaurar» afectan a ese usuario.",
    savedForUser: "Menú de {name} guardado",
    restoreForAll: "Restaurar para todos",
    restoreForAllHint:
      "Añade solo este enlace al final del menú de todos los usuarios, sin tocar el resto de su estructura.",
    restoreForAllOne: "Restaurar {name} para todos los usuarios",
    restoreForAllConfirmTitle: "¿Añadir «{name}» al menú de todos?",
    restoreForAllConfirmHtml:
      '<p>Se añade <strong>solo ese enlace</strong> al final del menú guardado de cada usuario activo. El orden y el resto de sus entradas quedan como están.</p><ul class="text-start small"><li>A quien ya lo tenga no se le duplica.</li><li>Quien nunca personalizó su menú ve el del sistema completo, así que no hace falta tocarlo.</li><li>Cada usuario solo lo verá si sus permisos se lo permiten.</li></ul>',
    restoreForAllConfirmYes: "Sí, añadirlo a todos",
    restoreForAllSuccess: "«{name}» añadido al menú de {count} usuarios.",
    restoreForAllSuccessHint:
      "A los demás ya les aparecía o usan el menú del sistema sin personalizar.",
    restoreForAllError: "No se pudo añadir el enlace al menú de todos.",
    applyLabelToAll: "Nombre a todos",
    applyLabelToAllHint:
      "Aplica solo este nombre a esa entrada en el menú de todos los usuarios, sin tocar el resto de su estructura.",
    applyLabelToAllConfirmTitle:
      "¿Renombrar esa entrada a «{name}» para todos?",
    applyLabelToAllResetConfirmTitle:
      "¿Devolver «{name}» a su nombre por defecto para todos?",
    applyLabelToAllConfirmHtml:
      '<p>Se cambia <strong>solo el nombre de esa entrada</strong> en el menú guardado de cada usuario activo. El orden y el resto de sus entradas quedan como están.</p><ul class="text-start small"><li>Se aplica al instante: no hace falta guardar el menú.</li><li>Quien no tenga esa entrada en su menú no se ve afectado.</li><li>Quien nunca personalizó su menú ve el del sistema, así que sigue con el nombre por defecto.</li></ul>',
    applyLabelToAllConfirmYes: "Sí, renombrar para todos",
    applyLabelToAllSuccess:
      "Nombre aplicado en el menú de {count} usuarios.",
    applyLabelToAllSuccessHint:
      "A los demás ya les figuraba así, no tienen esa entrada o usan el menú del sistema sin personalizar.",
    applyLabelToAllEmpty: "Escribí primero el nombre nuevo.",
    applyLabelToAllError:
      "No se pudo renombrar la entrada en el menú de todos.",
    customLinkSectionTitle: "Enlace personalizado",
    addCustomLink: "Añadir enlace",
    customLinkBadge: "Enlace propio",
    editCustomLink: "Editar enlace",
    removeCustomLinkHint: "Quitar este enlace del menú",
    customLinkLabelField: "Texto en el menú",
    customLinkLabelPlaceholder: "ej. Documentación",
    customLinkUrlField: "URL o ruta",
    customLinkUrlPlaceholder:
      "https://… , /ruta/interna , mailto:… o tel:…",
    customLinkIconField: "Icono (opcional)",
    customLinkInvalidUrl:
      "La URL no es válida. Usá https://, una ruta que empiece por /, mailto: o tel:",
  },

  migrations: {
    menu: "Migraciones",
    title: "Migraciones del sistema",
    description:
      "Cambios de estructura o de datos que trae una versión nueva y que hay que aplicar a esta base. Se ejecutan una sola vez: cuando una termina, deja de aparecer acá.",
    refresh: "Actualizar",
    run: "Ejecutar",
    runAll: "Ejecutar las {count}",
    confirm: "Se aplica sobre los datos de esta empresa. ¿Ejecutarla ahora?",
    confirmAll:
      "Se ejecutan una detrás de otra, en orden. Si alguna falla, las siguientes no se ejecutan.",
    nonePending: "No hay migraciones pendientes en esta base.",
    loading: "Cargando…",
    failed: "La migración falló.",
    stillRunning:
      "La migración sigue corriendo. Volvé a entrar en unos minutos para ver cómo terminó.",
    lastRunTitle: "Lo que se acaba de ejecutar",
    noChanges: "Terminó sin cambios para aplicar.",
    historyTitle: "Historial",
    show: "Ver",
    hide: "Ocultar",
    noHistory: "Todavía no se ejecutó ninguna migración en esta base.",
    colMigration: "Migración",
    colVersion: "Versión",
    colStatus: "Estado",
    colDate: "Fecha",
    colBy: "Ejecutada por",
  },
  refIntegrityAdmin: {
    menu: "Integridad referencias (appliedto)",
    title: "Limpieza OID (ModelDefinitions)",
    subtitle:
      "Genera objetivos desde todas las ModelDefinition: cada colección principal (referencia, lista, auditoría), cada subcolección de grupo y arrays embebidos con referencias. Convierte cadenas hex inválidas de 24 caracteres a ObjectId.",
    fieldsChecked: "Campos OID revisados en la colección",
    fallback: "Lista por defecto",
    modelDefs: "definiciones",
    targets: "objetivos",
    kindCollection: "Colección",
    kindArray: "Array embebido",
    embeddedPath: "Ruta en el array",
    sampleDocIds: "Ids de documento de ejemplo",
    showAllTargets: "Mostrar todos los objetivos (incl. sin problemas)",
    filteredEmpty:
      "No hay objetivos con problemas o colecciones ausentes en esta vista. Activa «Mostrar todos los objetivos» para listar todo lo escaneado.",
    docsUpdated: "Documentos actualizados",
    scan: "Escanear",
    fix: "Corregir",
    cancel: "Cancelar",
    ok: "Aceptar",
    totalDocsWithIssue: "Documentos con al menos una referencia en texto",
    missingCollection: "ausente",
    docsAffected: "Documentos afectados",
    noIssues: "No hay referencias en texto.",
    field: "Campo",
    count: "Cantidad",
    samples: "Muestras (_id → valor)",
    error: "No se pudo completar la operación.",
    fixConfirmTitle: "¿Convertir referencias de texto a ObjectId?",
    fixConfirmText:
      "Actualiza solo la base de datos del cliente actual. Haz copia de seguridad si no estás seguro.",
    fixDone: "Actualización completada",
    fixSummaryEmpty: "Sin cambios reportados.",
    skipped: "omitido (colección inexistente)",
    modified: "Documentos actualizados",
    collection: "Colección",
  },

  Containertrackingpricingtitle: "Cómo se calcula el precio",
  "Container tracking pricing description":
    "Se cobran 2,10 USD cada vez que se activa un seguimiento (cada búsqueda con éxito). Si el seguimiento se mantiene activo más de 24 horas, se cobra un 20% adicional. El total depende de cuántos seguimientos actives y cuántos se mantengan activos más de 24 h.",
  "System Features developments title": "Desarrollos",
  "System Features developments intro":
    "Los desarrollos nuevos solicitados por el Cliente serán facturados cuando cumplan al menos uno de los siguientes criterios:",
  "System Features developments 1.1 title": "1.1 Desarrollo específico",
  "System Features developments 1.1 text":
    "Que el pedido del Cliente no constituya una mejora de alcance general aplicable al conjunto de los usuarios del sistema.",
  "System Features developments 1.2 title": "1.2 Imposición de plazo",
  "System Features developments 1.2 text":
    "Que el Cliente requiera la realización del desarrollo dentro de un plazo determinado por una necesidad propia.",
  "System Features developments terms hint":
    " para consultar los términos completos.",
  "System Features developments current month": "Mes actual",
  "System Features developments current month hint":
    "Total por desarrollos resueltos este mes.",
  "System Features developments link support": "Ver desarrollos en Soporte",
  "System Features total current month": "Total del mes actual",
  "System Features developments label": "Desarrollos (este mes)",
  "System Features container tracking current month": "Mes actual",
  "System Features trackings": "seguimientos",
  "System Features container tracking activated": "activados",
  "System Features container tracking 24h": "activos ≥24h",
  "System Features container tracking current month hint":
    "2,10 USD por seguimiento cada vez que activas uno; se suma un 20% por cada seguimiento que se mantenga activo al menos 24 h.",
  "System Features container tracking plus 24h": "por ≥24h",
  "System Features container tracking link": "Ver Container Tracking",
  "System Features container tracking trial": "Prueba gratuita de 1 semana.",
  "System Features container tracking billing starts":
    "La facturación comienza el",
  "System Features container tracking activate trial":
    "Activar con 1 semana gratis",
  "System Features container tracking activated message":
    "Container Tracking activado. La facturación comienza después de la semana de prueba.",
  "System Features container tracking deactivated message":
    "Container Tracking desactivado.",
  "System Features container tracking swal title": "Activar Container Tracking",
  "System Features container tracking swal trial":
    "Durante 7 días puedes usar Container Tracking sin costo. No se cobra nada hasta la fecha de inicio de facturación.",
  "System Features container tracking swal pricing":
    "A partir de esa fecha se cobrarán 2,10 USD cada vez que actives un seguimiento, más un 20% por cada seguimiento que se mantenga activo más de 24 h. Puedes ver el cálculo exacto en este mismo bloque.",
  "System Features container tracking swal deactivate":
    "Si desactivas la función después, igual se cobrará el uso del mes en curso.",
  "System Features container tracking swal confirm": "Activar",
  "Search tickets by keywords":
    "Buscar tickets (título, descripción, notas, respuestas…)",
  "No tickets match your search": "Ningún ticket coincide con tu búsqueda.",
  "Assigned to": "Asignado a",
  "Unassigned": "Sin asignar",
  paymentCollectResponsable: {
    assignedSuccess: "Te has hecho cargo correctamente{name}.",
    alreadyAssigned: "Ya eres el responsable de este registro.",
    assignFailed: "No se pudo asignar el responsable.",
    claimLinkShortcode: "Enlace para hacerse cargo (responsableClaimLink)",
  },
  "All assignees": "Todos los asignados",
  "Board programmers": "Programadores del tablero",
  "Board programmers help":
    "Elige los usuarios que aparecen como columnas en el tablero de soporte. Define una tarifa ($/h) para calcular automáticamente el precio de developments según las horas estimadas. Las columnas vacías muestran un área punteada para asignar tickets arrastrando.",
  "Hourly rate": "Tarifa por hora",
  "Development price auto hint": "Calculado: {hours}h × ${rate}/h = ${price}",
  "Development price locked hint": "Precio fijado con tarifa de ${rate}/h al guardar",
  "Development price needs hours": "Indica las horas estimadas para calcular el precio.",
  "Development price needs assignee": "Asigna el ticket a un programador del tablero para calcular el precio.",
  "Development price needs programmer rate":
    "El asignado no tiene tarifa $/h. Configúrala en Programadores del tablero (pestaña Pending / In Progress / Resolved).",
  "Resolved tickets assignee locked":
    "Los tickets resueltos no se pueden reasignar. Reábrelo antes si necesitas cambiar el asignado.",
  "Tickets in progress or resolved cannot be deleted":
    "No se pueden eliminar tickets en progreso o resueltos.",
  Timeline: "Timeline",
  Category: "Categoría",
  Flags: "Banderas",
  "No category": "Sin categoría",
  "Pick one or more": "Podés elegir varias",
  "Details": "Ver detalle",
  migrationsPendingIntro:
    "Hay {count} actualizaciones pendientes. Se ejecutan todas, en este orden.",
  "Set category on selected": "Asignar categoría a seleccionados",
  "Apply category": "Aplicar categoría",
  "Flags are created and edited in the flags list": "Las banderas se crean y se editan en la lista de banderas",
  "Add ticket": "Añadir ticket",
  "Category name already exists": "Ya existe una categoría con ese nombre",
  "Saved successfully": "Guardado correctamente",
  "Filter by categories": "Filtrar por categorías",
  "Dashboard": "Dashboard",
  "dashboardRefresh": "Actualizar",
  "dashboardRetry": "Reintentar",
  "dashboardTicketLoadError": "No se pudo cargar el ticket",
  "dashboardLoadError": "No se pudo cargar el dashboard",
  "dashboardYourTurn": "Te toca a vos",
  "dashboardWaitingOnOthers": "Estás esperando a otros",
  "dashboardNothingPending": "No tenés nada pendiente",
  "dashboardNothingPendingHelp": "Cuando alguien te espere en un ticket, o vos estés esperando a alguien, lo vas a ver acá.",
  "dashboardWaitingForYou": "{name} espera una respuesta tuya en el ticket {ticket}",
  "dashboardWaitingForYouNoName": "Soporte espera una respuesta tuya en el ticket {ticket}",
  "dashboardTestForYou": "{name} dejó el ticket {ticket} listo para que lo pruebes",
  "dashboardTestForYouNoName": "El ticket {ticket} está listo para que lo pruebes",
  "dashboardUnanswered": "{name} escribió en el ticket {ticket} y todavía nadie le contestó",
  "dashboardUnansweredNoName": "Escribieron en el ticket {ticket} y todavía nadie contestó",
  "dashboardNewTicket": "{name} creó el ticket {ticket} y todavía nadie le contestó",
  "dashboardNewTicketNoName": "Se creó el ticket {ticket} y todavía nadie contestó",
  "dashboardMention": "Te mencionaron en el ticket {ticket} y todavía no respondiste",
  "dashboardYouAreWaiting": "Estás esperando una respuesta de {name} en el ticket {ticket}",
  "dashboardYouAreWaitingNoName": "Estás esperando una respuesta en el ticket {ticket}",
  "dashboardClientTesting": "Estás esperando que {name} pruebe el ticket {ticket}",
  "dashboardClientTestingNoName": "Estás esperando que prueben el ticket {ticket}",
  "dashboardWaitingForSupport": "Estás esperando que soporte te conteste en el ticket {ticket}",
  "dashboardOldest": "el más viejo {since}",
  "dashboardOpenTickets": "Tablero: {count} tickets abiertos",
  "dashboardYourTurnEmpty": "Nada que te toque ahora.",
  "dashboardWaitingOnOthersEmpty": "No estás esperando a nadie.",
  "dashboardKpiWaitingForYou": "Para responder",
  "dashboardKpiTestForYou": "Para probar",
  "dashboardKpiUnanswered": "Sin contestar",
  "dashboardKpiNewTicket": "Nuevos sin respuesta",
  "dashboardKpiMention": "Menciones sin responder",
  "dashboardKpiYouAreWaiting": "Esperando respuesta",
  "dashboardKpiClientTesting": "Esperando prueba",
  "dashboardKpiWaitingForSupport": "Esperando a soporte",
  "dashboardReadyTitle": "Tickets listos",
  "dashboardReadyHelp": "Tickets que ya están hechos pero, por las dudas, siguen abiertos a comentarios antes de cerrarlos definitivamente.",
  "dashboardReadyEmpty": "No hay tickets listos.",
  "dashboardReadyBy": "Lo pasó a listo {name}",
  "dashboardReadyForTestTitle": "Para probar",
  "dashboardReadyForTestHelp": "Tickets que esperan tu prueba. A la derecha, cuánto hace que están esperando.",
  "dashboardReadyForTestEmpty": "No hay tickets esperando prueba.",
  "dashboardReadyForTestBy": "Lo dejó para probar {name}",
  "Ticket categories": "Categorías de tickets",
  "Ticket categories help":
    "Definí nombres de categoría para el timeline y el board (p. ej. Módulo finanzas). Cualquier usuario puede crear categorías y asignarlas a los tickets.",
  "Category name": "Nombre de categoría",
  "Report comment": "Comentario reporte",
  "No categories configured": "Aún no hay categorías configuradas.",
  "No timeline categories yet": "Aún no hay datos en el timeline",
  "Timeline empty help":
    "Asigna una categoría a los tickets, o configura categorías con el botón de arriba.",
  "Bug resolved": "Bug resuelto",
  "Development resolved": "Development resuelto",
  "Filter by assignee": "Filtrar por asignado",
  "Drag to reorder": "Arrastrar para reordenar",
  "Select all on page": "Seleccionar todos en la página",
  "Select ticket": "Seleccionar ticket",
  "{count} tickets selected": "{count} tickets seleccionados",
  "Move selected to Development": "Mover seleccionados a Development",
  "Move selected to Bug": "Mover seleccionados a Bug",
  unread: "sin leer",
  "Unread mentions": "Menciones sin leer",
  "Private report": "Reporte privado",
  "You were mentioned in ticket {label}. Don't forget to reply.":
    "Te mencionaron en el ticket {label}. No te olvides de responder.",
  "You were mentioned in {count} tickets. Don't forget to reply.":
    "Te mencionaron en {count} tickets. No te olvides de responder.",
  "Next": "Siguiente",
  "Skip": "Saltear",
  "optional": "opcional",
  "ticketWizardStepOf": "Pregunta {current} de {total}",
  "ticketWizardTypeQuestion": "¿Qué tipo de ticket es?",
  "ticketWizardTypeBugHint": "Algo que funcionaba y dejó de funcionar, o da un error",
  "ticketWizardTypeDevelopmentHint": "Algo nuevo que el sistema todavía no hace",
  "ticketWizardTypeTutorialHint": "Una guía que explique cómo hacer una tarea",
  "ticketWizardProblemQuestion": "¿Cuál es el problema?",
  "ticketWizardProblemPlaceholder": "Contanos qué estabas haciendo y qué pasó.",
  "ticketWizardExpectedQuestion": "¿Cómo debería funcionar?",
  "ticketWizardExpectedPlaceholder": "Contanos qué tendría que pasar o qué resultado esperabas ver.",
  "ticketWizardNeedQuestion": "¿Qué necesitás que haga el sistema?",
  "ticketWizardNeedPlaceholder": "Describí la funcionalidad nueva o el cambio que querés.",
  "ticketWizardResultQuestion": "¿Qué resultado esperás ver?",
  "ticketWizardResultHint": "Podés marcar más de una opción.",
  "ticketWizardResultList": "Un listado",
  "ticketWizardResultScreen": "Una pantalla nueva",
  "ticketWizardResultButton": "Un botón nuevo",
  "ticketWizardResultField": "Un campo nuevo en un formulario",
  "ticketWizardResultCalculation": "Un cálculo automático",
  "ticketWizardResultReport": "Un reporte o gráfico",
  "ticketWizardResultFile": "Un archivo (Excel, PDF)",
  "ticketWizardResultNotification": "Un aviso o email",
  "ticketWizardResultRemoveSaved": "Quitar esta opción guardada",
  "ticketWizardResultRemoveError": "No se pudo quitar la opción",
  "ticketWizardResultOther": "Otro",
  "ticketWizardResultOtherPlaceholder": "Contanos qué resultado esperás",
  "ticketWizardResultRequired": "Elegí al menos una opción",
  "ticketWizardResultOtherRequired": "Contanos qué otro resultado esperás",
  "ticketWizardTaskQuestion": "¿Qué tarea querés que te expliquemos?",
  "ticketWizardTaskPlaceholder": "Por ejemplo: cómo cargar un cobro parcial de un embarque.",
  "ticketWizardLinkQuestionBug": "Link a la pantalla donde se presenta el problema",
  "ticketWizardLinkQuestion": "Link a la pantalla relacionada",
  "ticketWizardLinkHint": "Abrí la pantalla, copiá la dirección de la barra del navegador y pegala acá.",
  "ticketWizardScreenshotsQuestionBug": "Adjuntá capturas de pantalla que permitan entender el problema",
  "ticketWizardScreenshotsQuestionDevelopment": "Adjuntá capturas, planillas o ejemplos que ayuden a entender lo que necesitás",
  "ticketWizardScreenshotsQuestionTutorial": "Adjuntá capturas de la pantalla sobre la que querés el instructivo",
  "ticketWizardScreenshotsUrlWarning": "En cada captura se tiene que ver la dirección (URL) de la pantalla, para saber de qué pantalla se trata.",
  "ticketWizardPriorityQuestion": "¿Qué tan urgente es?",
  "ticketWizardTitleQuestion": "Por último, ponele un título corto",
  "ticketWizardSummary": "Revisá tus respuestas antes de enviar",
  "ticketWizardAnswerRequired": "Esta pregunta es obligatoria",
  "ticketWizardLinkRequired": "Pegá el link de la pantalla donde se presenta el problema",
  "ticketWizardScreenshotsRequired": "Adjuntá al menos una captura de pantalla",
  "ticketWizardPriorityRequired": "Elegí la urgencia",
  "Brief description of the issue": "Por ejemplo: error 500 al guardar el embarque",
  "Please enter a valid URL": "Ingresá un link válido (tiene que empezar con http)",
  "Title is required": "El título es obligatorio",
  "Title must be less than 200 characters": "El título tiene que tener menos de 200 caracteres",
  "Bug ticket created notice":
    "Tu pedido será tratado en función de la urgencia y la prioridad definidas. Si se detecta que esta tarea no es un bug, se enviará a desarrollo y se estimará su precio.",
  "Assign selected to": "Asignar seleccionados a",
  "Assign": "Asignar",
  "Clear selection": "Limpiar selección",
  Confirm: "Confirmar",
  "Drag files here to attach":
    "Arrastra y suelta archivos aquí para adjuntarlos",
  "or use the button to choose files from your device":
    "o usa el botón para elegir archivos en tu equipo",

  // System Features (página Settings/Features) - claves en raíz para que $t() las resuelva
  "System Features": "Características del sistema",
  "Base Features": "Características base",
  "Servers, Usage, Maintenance, Base Functionality":
    "Servidores, uso, mantenimiento y funcionalidad base",
  "Base features description":
    "Infraestructura en la nube que aloja tu base de datos y aplicación. Incluye gestión de servidores, copias de seguridad automáticas, actualizaciones de seguridad, certificados SSL y supervisión 24/7. Todo el mantenimiento técnico y los costes de infraestructura están incluidos.",
  "Included in base price": "Incluido en el precio base",
  Active: "Activo",
  month: "mes",
  "Email Features": "Funcionalidades de email",
  "Automatic Email Sending": "Envío automático de emails",
  "Automatic emails description":
    "Sistema de automatización de emails con disparadores y envíos programados. Crea plantillas con datos dinámicos de tus modelos, configura disparadores que envían emails al crear o actualizar documentos (p. ej. enviar factura al confirmar proforma), programa envíos recurrentes y consulta el historial en el registro de emails. Utiliza Brevo (Sendinblue) para el envío.",
  Included: "Incluido",
  "Included Modules": "Módulos incluidos",
  "Optional Features": "Automatizaciones",
  "Active extra modules": "Módulos extra activados",
  "Container Tracking": "Seguimiento de contenedores",
  "Container tracking description":
    "Seguimiento de contenedores, bookings o conocimientos de embarque. Registras número y tipo; el sistema recibe actualizaciones por webhook o bajo demanda. Vincula cada seguimiento a tus documentos (p. ej. Envío) y define el mapeo de campos. Al recibir datos, los documentos vinculados se actualizan y se ejecutan los hooks. La facturación es por seguimiento activo y mes.",
  "findTeu.supportedCarriers": "Navieras soportadas",
  Chat: "Chat",
  "Chat description":
    "Sistema de chat en tiempo real para que los usuarios se comuniquen. Consulta quién está en línea, envía mensajes, adjunta archivos y recibe notificaciones. El widget de chat está disponible en la esquina inferior derecha. Historial completo accesible desde el menú.",
  "Manual Document Email Sending": "Envío manual de documentos por email",
  "Smart Email": "Smart Email",
  "Smart Email description":
    "Smart Email amplía el envío de correos en el sistema con adjuntos y envíos en un clic. Incluye:\n\n- Adjuntar archivos en los emails en general (archivos ya subidos al sistema), no solo PDFs generados automáticamente\n- Enviar correos con esos adjuntos también desde el chat del Agente IA (pedilo en lenguaje natural)\n- Enviar documentos en PDF desde plantillas con un clic\n- Enviar listados y reportes exportados en Excel\n- Elegir destinatarios entre usuarios, referencias del documento o direcciones manuales\n- Usar plantillas de correo e idiomas\n- Registrar todos los envíos en el historial de emails",
  "Manual emails description":
    "Envía documentos PDF desde cualquier plantilla (proformas, facturas, etc.) por email con un clic. Elige destinatarios entre usuarios del sistema, extrae emails de referencias del documento o introduce direcciones. Personaliza asunto y cuerpo. Todos los envíos se registran con el PDF adjunto.",
  "Coming Soon": "Próximamente",
  "Total Monthly Price": "Precio mensual total",
  "Base price": "Precio base",
  "Billing month charges title": "Cobro del mes",
  "Billing month charges hint": "Lo que se cobra por este mes: base, módulos, consumo y desarrollos. Lo eximido es un regalo: no aparece en la factura ni en el saldo pendiente.",
  "Billing month charges provisional": "Mes en curso: el consumo es hasta hoy y va a seguir subiendo.",
  "Billing month charges empty": "No hay nada para cobrar en este mes.",
  "Billing month charges total": "Total del mes",
  "Billing month charges paid": "Pagado",
  "Billing month charges already paid": "Ya pagado",
  "Billing month charges due": "Falta cobrar",
  "Billing waive": "Eximir",
  "Base price change hint": "Vale desde este mes; los meses anteriores conservan el precio que tenían.",
  "Manual Document Emails": "Emails de documentos manuales",
  "More actions": "Más acciones",
  "Hide actions": "Ocultar acciones",
  "Send export by email": "Enviar export por email",
  "Save Changes": "Guardar cambios",
  "Error loading features": "Error al cargar las características",
  "Features updated successfully": "Características actualizadas correctamente",
  "Error saving features": "Error al guardar las características",
  Billing: "Facturación",
  "Billing tab intro":
    "Cargos por mes calendario. Descarga la factura en PDF de meses cerrados (disponible desde el día 1 del mes siguiente; lo incluido en prueba no se cobra hasta que termine). El mes en curso va al final con total provisional; imprimir/PDF solo cuando el mes cierre.",
  "Billing pending from period title":
    "Consumos del mes en curso (a facturar el mes siguiente)",
  "Billing pending from period hint":
    "Resumen orientativo de lo acumulado en el mes por conceptos que no van en la cuota mensual anticipada (por ejemplo correo inteligente, seguimiento de contenedores o desarrollos). No forma parte del total de la tabla de liquidación de más abajo; al cerrar el mes se factura y en la siguiente liquidación puede figurar como «Diferido». Cada fila muestra el importe íntegro, la parte del pago registrado en este mes que ya se aplicó a ese consumo (después de la liquidación principal) y lo que queda pendiente para el siguiente periodo.",
  "Billing pending from period col gross": "Importe íntegro",
  "Billing pending from period col paid": "Abonado este mes (diferido)",
  "Billing pending from period col remaining": "Pendiente (siguiente periodo)",
  "Billing pending from period footer totals": "Totales",
  "Billing pending from period footer explain":
    "Importe íntegro: cargo de lista de cada concepto diferido en el mes. Abonado este mes: parte de tu pago registrado que se imputó aquí tras liquidar las líneas de arriba. Pendiente: lo que pasará a la siguiente liquidación si sigue sin cubrirse.",
  "Billing pending from period subtotal": "Subtotal estimado de este recuadro",
  "Billing outstanding from prior": "Saldo pendiente de",
  "Billing carry brought forward total":
    "Total traído desde periodos anteriores (antes de los pagos de este mes)",
  "Billing carry payments applied this month":
    "Abonos registrados en este mes aplicados a ese saldo",
  "Billing carry remaining in settlement":
    "Remanente de ese saldo en esta liquidación",
  "Billing settlement concepts hint":
    "Impago de un mes: lo que quedó sin cubrir en la liquidación anterior, desglosado línea por línea. Diferido: consumo concreto de un mes con pago anticipado que se factura en el siguiente (p. ej. cada desarrollo).",
  "Billing unpaid from period title": "Impago de {period}",
  "Billing unpaid from period breakdown":
    "Desglose de lo que quedó sin pagar en la liquidación de ese mes:",
  "Billing advance group paid at": "Pago del {date}",
  "Billing outstanding balance line hint":
    "Remanente impago de la liquidación de ese mes, después de los pagos registrados. No es un consumo nuevo del mes en curso.",
  "Billing pending included in balance hint":
    "Ese saldo incluye el consumo estimado fuera de la cuota anticipada (recuadro «Consumos del mes en curso» más abajo). Si no se cubre, al cerrar el mes suele pasar a la liquidación siguiente.",
  "Billing future prepaid header note":
    "Pago adelantado de un mes futuro: la liquidación y el saldo pendiente se mostrarán cuando ese mes sea el mes en curso.",
  "Billing advance no prior deferred":
    "Nada diferido de meses anteriores en esta tarjeta.",
  "Billing overdue top alert message":
    "El sistema registra un retraso en el pago del servicio de {days} día(s) (día {dueDay} de cada mes). Por favor regularice el pago para reactivar la suscripción y evitar la suspensión del servicio dentro de {daysLeft} día(s).",
  "Billing overdue top alert message suspension":
    "{days} día(s) de retraso: el servicio puede suspenderse. Paga en Facturación.",
  "Billing overdue top alert link": "Ver facturación",
  "Billing suspension nag title":
    "Recordatorio: hay un atraso de más de 10 días en el pago del servicio.",
  "Billing suspension swal ok": "OK",
  "Billing overdue reminder title": "Recordatorios de deuda por email",
  "Billing overdue reminder enable":
    "Enviar email diario de recordatorio a las 14:00 si hay deuda vencida sin pagar",
  "Billing overdue reminder users placeholder": "Elegí los usuarios que recibirán el recordatorio",
  "Billing overdue reminder placeholders hint":
    "Marcadores: {{overdueDays}}, {{dueDay}}, {{daysLeft}}, {{year}}, {{month}}. Debajo se adjunta el HTML de la factura (misma liquidación que en Billing).",
  "Billing overdue reminder last sent": "Último recordatorio enviado",
  "Billing overdue reminder send now": "Enviar ahora",
  "Billing overdue reminder preview": "Vista previa",
  "Billing overdue reminder preview error": "No se pudo generar la vista previa",
  "Billing overdue reminder preview would not send":
    "Con el estado actual el envío real se omitiría (sin deuda vencida o sin destinatarios).",
  "Billing overdue reminder send now confirm title": "¿Enviar recordatorio ahora?",
  "Billing overdue reminder send now confirm text":
    "Se guardará la configuración actual y se enviará el email a los usuarios seleccionados (incluye el resumen del saldo pendiente en el cuerpo).",
  "Billing overdue reminder send now success": "Recordatorio enviado",
  "Billing overdue reminder send now success with invoice":
    "Recordatorio enviado con el resumen de saldo pendiente",
  "Billing overdue reminder send now error": "No se pudo enviar el recordatorio",
  "Billing overdue reminder send now skipped": "No se envió el recordatorio",
  "Billing overdue reminder send now no overdue":
    "No hay deuda vencida sin pagar; no se envió el email",
  "Billing overdue reminder send now no recipients":
    "Elegí al menos un usuario destinatario con email",
  "Email Subject": "Asunto del email",
  "Email Body": "Cuerpo del email",
  "Current month": "Mes en curso",
  "Billing provisional total hint":
    "Provisional: las líneas por uso reflejan la actividad hasta hoy.",
  "Billing overdue days":
    "En retraso: {days} día(s) después de la fecha de vencimiento mensual (día {dueDay} de cada mes, según inicio del servicio; sin registro en Meses pagados).",
  "Billing overdue due from first":
    "Sin registro de pago en Meses pagados. El vencimiento de este mes es el día {dueDay} (mismo día del mes que el inicio del servicio).",
  "Billing print after month closes":
    "Imprimir/PDF está disponible cuando el mes haya cerrado.",
  "No billing data yet": "Aún no hay datos de facturación.",
  "Download invoice PDF": "Descargar factura PDF",
  "View invoice": "Ver factura",
  "Print or export": "Imprimir o exportar",
  "Use the browser print dialog to save as PDF":
    "Usa el diálogo de impresión del navegador para guardar como PDF.",
  "Please allow popups to print the invoice":
    "Permite ventanas emergentes para imprimir la factura.",
  Description: "Descripción",
  Amount: "Importe",
  Total: "Total",
  "Error loading billing": "Error al cargar la facturación",
  "Error downloading invoice": "Error al descargar la factura",
  "Invoice downloaded": "Factura descargada",
  Admin: "Admin",
  "Admin settings for billing and invoicing":
    "Configuración de administración para facturación",
  "Service start date": "Fecha de inicio del servicio",
  "Service start date hint":
    "Fecha en que el cliente comenzó a usar el sistema (para historial de facturación).",
  "Feature prices (USD/month)": "Precios de características (USD/mes)",
  "Admin feature prices hint":
    "El precio de Container Tracking se configura en la configuración de Container Tracking.",
  "Billing excluded developers title": "Excluir developers de la facturación",
  "Billing excluded developers hint":
    "Si marcas Exclude, las tasks de desarrollo de ese developer no se incluyen en facturas no pagadas. Los meses ya pagados no se modifican.",
  "Billing excluded developers empty": "No hay programadores del tablero configurados.",
  "Billing exclude checkbox": "Exclude",
  Developer: "Developer",
  "Paid months": "Meses pagados",
  "Paid months hint":
    'Marca los meses como pagados cuando el cliente pague. En "Pagado por adelantado" marca lo que el cliente ya prepagó (base y/o módulos de pago). Lo no marcado de ese mes, más seguimiento de contenedores y desarrollos, se factura en el mes siguiente. Podés agregar varias filas para el mismo mes (por ejemplo prepago + un abono); el sistema suma montos y combina los datos para facturación. En meses con adelanto, los abonos en "Pagado" primero bajan el saldo de la tabla de liquidación (p. ej. saldo traído de meses anteriores); lo que quede se aplica al recuadro de consumos del mes (desarrollos antes que otros ítems de ese bloque).',
  "Advance add month defer hint":
    "Lo no marcado de ese mes, más el uso (Container Tracking, desarrollos), aparece en el mes siguiente.",
  "Paid in advance (items)": "Pagado por adelantado (conceptos)",
  "What client paid in advance": "Qué pagó el cliente por adelantado",
  Base: "Base",
  "Already paid for this month": "Ya pagado de este mes",
  "Billing punctual payments subtotal": "Pagos puntuales / abonos",
  "Already paid month grand total": "Total ya pagado este mes",
  "Paid in advance total": "Total pagado por adelantado",
  Year: "Año",
  Month: "Mes",
  Type: "Tipo",
  "Paid date": "Fecha de pago",
  Paid: "Pagado",
  "Fully collected": "Cobrado",
  "Applied / requested": "Aplicado / pedido",
  "Bank payment date": "Fecha pago (banco)",
  Unpaid: "Sin pagar",
  "Paid in advance": "Pagado por adelantado",
  "Billing to pay type": "A pagar",
  "Billing to pay items label": "Conceptos en la factura",
  "Billing to pay add hint":
    "Lo marcado entra en el total a pagar. Lo no marcado se difiere al mes siguiente. Para registrar un pago, agrega otra fila Pagado con el monto.",
  "Billing to pay received col": "Pagado (conceptos)",
  "Billing to pay admin hint":
    "«A pagar» define qué entra en la factura. Cuando el cliente pague, agrega otra fila del mismo mes con tipo Pagado y el monto abonado; el sistema descuenta del saldo. Si el monto supera ese mes, el resto se aplica automáticamente a los meses siguientes (en orden).",
  "Paid amount hint":
    "Monto abonado en esa fecha. Si supera el saldo del mes, el excedente se aplica a los meses posteriores en orden cronológico.",
  "Billing invoice settlement section": "Liquidación",
  "Billing invoice current period charges title": "Desarrollos de {period}",
  "Billing invoice monthly to pay title": "Cuota mensual (a pagar)",
  "Billing invoice extra lines title": "Conceptos extra en factura",
  "Billing invoice extra lines hint":
    "Líneas manuales por mes (descripción y monto). Aparecen en la factura de ese mes y no están ligadas al consumo del sistema. Un descuento resta su monto de lo que hay que pagar ese mes; si supera el saldo, el sobrante no pasa al mes siguiente.",
  "Billing invoice extra lines empty": "Sin conceptos extra registrados.",
  "Billing invoice extra lines section": "Conceptos adicionales",
  "Billing invoice extra line kind": "Tipo",
  "Billing invoice extra line kind charge": "Cargo",
  "Billing invoice extra line kind discount": "Descuento",
  "Billing invoice discounts section": "Descuentos",
  "Remaining amount (depends on usage)": "Importe restante (según consumo)",
  "PDF not available for advance-paid months":
    "PDF no disponible para meses pagados por adelantado.",
  "Billing advance PDF monthly only hint":
    "La factura imprimible incluye solo el servicio mensual prepago (no cargos por uso).",
  "Billing advance print two docs hint":
    "Factura (a pagar) = solo liquidación; Recibo anticipo = constancia del prepago y abonos.",
  "Billing advance no PDF hint":
    "Imprimir/PDF incluye solo el servicio mensual prepago; el consumo aparece en el resumen de abajo.",
  "Billing advance remaining hint":
    "Base prepagada. Abajo: importes arrastrados de meses anteriores y/o uso de este periodo.",
  "Billing advance lines hint":
    "Esta tabla es la liquidación vigente: saldo traído de meses anteriores y, si corresponde, otros cargos. El recuadro de arriba solo muestra consumos del mes en curso que se facturan el mes siguiente.",
  "Billing print settlement invoice": "Factura (a pagar)",
  "Billing print payment receipt": "Recibo",
  "Billing print prepaid receipt": "Recibo anticipo",
  "Billing payment receipt title": "Recibo de pago",
  "Billing payment receipt intro":
    "Constancia de pagos recibidos. La factura emitida conserva el importe original.",
  "Billing payment receipt line": "Pago recibido",
  "Billing standard invoice doc title": "Factura",
  "Billing settlement invoice doc title": "Factura — liquidación",
  "Billing settlement invoice doc intro":
    "Documento por el importe adeudado en esta liquidación. La cuota mensual cubierta por anticipo y otros abonos se acreditan en el recibo aparte («Recibo anticipo»).",
  "Billing settlement receipt pointer":
    "Anticipo y abonos registrados: imprima también el «Recibo anticipo» si necesita constancia de esos pagos.",
  "Billing prepaid receipt doc title": "Recibo — anticipo y abonos",
  "Billing prepaid receipt doc intro":
    "Constancia de pagos ya registrados (anticipo del servicio y abonos en cuenta). No es un cargo adicional ni sustituye la factura de liquidación si hubiera saldo pendiente.",
  "Billing prepaid receipt total paid": "Total abonado en el período",
  "Billing invoice prepaid reference section title":
    "Ya pagado — solo referencia",
  "Billing invoice prepaid reference section hint":
    "Constancia de lo cubierto por el anticipo y los abonos registrados; no aumenta el importe a pagar de la sección anterior.",
  "Billing invoice subtotal prepaid reference":
    "Subtotal (referencia, ya abonado)",
  "Billing invoice settlement section title": "Importe a pagar",
  "Billing invoice settlement section hint":
    "Esta es la parte de la factura que indica el saldo pendiente (por ejemplo de meses anteriores). Debe coincidir con el total de la tabla de liquidación en Facturación.",
  "Billing invoice total due": "Total a pagar",
  "Billing invoice no settlement lines":
    "Sin saldo pendiente en esta liquidación.",
  "Billing invoice provisional settlement":
    "Liquidación provisional según datos a la fecha de emisión.",
  "Remaining total": "Total restante",
  Upcoming: "Próximo",
  "No paid months": "Ningún mes pagado",
  Add: "Añadir",
  "Invoice company data": "Datos de la empresa para facturación",
  "Invoice company data hint":
    "Datos de tu empresa para la futura generación de facturas.",
  "Billing invoice start number": "Número inicial de factura",
  "Billing invoice start number placeholder": "p. ej. 1001",
  "Billing invoice start number hint":
    "Primer número de factura. Cada mes de facturación suma 1 en orden cronológico.",
  "Billing invoice period fixed charges title": "Cuota del período (importe bruto)",
  "Billing invoice period usage charges title": "Uso del período — {period}",
  "Company name": "Nombre de la empresa",
  "VAT number": "CIF/NIF",
  Address: "Dirección",
  "Address line 2": "Dirección línea 2",
  City: "Ciudad",
  "Postal code": "Código postal",
  Country: "País",
  "Admin settings updated successfully":
    "Configuración de admin actualizada correctamente",
  "Accounting Module": "Módulo contable",
  "Template PDF Module": "Módulo plantillas PDF",
  "Finance Module": "Módulo financiero",
  "Excel Export": "Exportar a Excel",
  "Calendar Sync": "Sincronización de calendario",
  "Support technical AI module": "Soporte técnico IA",
  "Support technical AI module description":
    "Asistente de soporte técnico en el chat web (y Telegram si tenés Agente IA activo). Las reglas con palabras clave se comparten entre todos los usuarios. Gestioná «Mis reglas» aquí cuando el módulo Soporte esté activo.",
  "Support technical AI module inactive hint":
    "Activá el módulo Soporte en Módulos del sistema para usar el chat de soporte y editar las reglas.",
  "Accounting module description":
    "Sistema de contabilidad por partida doble. Crea asientos con débitos y créditos, genera balances de situación, cuenta de resultados e informes financieros. Todos los asientos se vinculan a tus documentos (facturas, pagos, gastos) para conciliación automática.",
  "Template PDF module description":
    "Generación de documentos PDF desde plantillas HTML personalizables. Diseña plantillas para proformas, facturas, envíos, etc. con datos dinámicos, cálculos y formato condicional. Exporta a PDF para imprimir o enviar por email.",
  "Finance module description":
    "Sistema de gestión financiera. Control de cobros y pagos, gastos por categoría, extractos bancarios y de cuenta, resúmenes por contacto/cliente, análisis de flujo de caja e informes. Todo vinculado a tus documentos de negocio.",
  "Excel export description":
    "Exporta listas dinámicas o informes a Excel (.xlsx). Mantiene formato, columnas y filtros, soporta grandes volúmenes y tipos de datos. Útil para análisis externo o informes personalizados.",
  "Calendar sync description":
    "Sincronización bidireccional con Google Calendar, Outlook, iCal, etc. Sincroniza plazos, eventos y fechas desde tus documentos al calendario. Gestiona la agenda desde tu aplicación de calendario.",
  "Dashboard widgets": "Tablero con widgets",
  "Dashboard widgets description":
    "Tablero personalizable con widgets: cada usuario arma su propia grilla con listas, totales e indicadores financieros, y puede compartir tableros con el resto del equipo.",
  "Change history and trash": "Historial de cambios y papelera",
  "Change history description":
    "Cada documento guarda el historial de quién cambió qué y cuándo. Una vista diaria resume las altas y ediciones, y lo borrado pasa a la papelera, desde donde se puede restaurar.",
  "Users, roles and permissions": "Usuarios, roles y permisos",
  "Roles and permissions description":
    "Usuarios con roles. Definí por rol qué pantallas, listas y campos puede ver o editar cada persona, y qué acciones puede realizar.",
  "Excel import": "Importar desde Excel",
  "Excel import description":
    "Cargá datos desde archivos Excel: asociá columnas y celdas de la planilla a los campos de tus formularios e importá muchos registros de una vez, sin tipearlos uno por uno.",
  "Exchange rates": "Tipos de cambio",
  "Exchange rates description":
    "Cotización oficial diaria de cada moneda contra el dólar, actualizada automáticamente (BCRA, con Frankfurter de respaldo), para convertir montos en documentos e informes.",
  "Notifications and alerts": "Notificaciones y avisos",
  "Notifications description":
    "Notificaciones dentro de la app cuando pasa algo que te concierne (documentos nuevos, asignaciones, vencimientos, tickets). Cada usuario elige qué avisos quiere recibir.",
  "Mobile version": "Versión para teléfono",
  "Mobile version description":
    "El sistema se adapta al teléfono: listas, formularios y menús pensados para pantallas chicas, para consultar y cargar datos desde cualquier lugar, sin instalar ninguna app.",
  "Multi-language": "Multi-idioma",
  "Multi-language description":
    "Cada usuario elige el idioma de la interfaz (español, inglés y otros). La traducción de los textos se puede ajustar para tu empresa.",
  "«On the web» for contacts and products": "«En la web» de contactos y productos",
  "Web lookup description":
    "Al abrir la ficha de un contacto o producto, el sistema busca información pública en la web y completa el logo o la foto si faltan.",
  "Support tickets and meetings": "Tickets de soporte y reuniones",
  "Support tickets description":
    "Reportá errores o pedí cambios con tickets de soporte, seguí su estado y comentarios, y agendá reuniones por videollamada con el equipo de soporte desde el propio sistema.",
  "View Terms of Service": "Ver condiciones de servicio",
  "View Terms and Conditions": "Ver términos y condiciones",
  Loading: "Cargando",
  Saving: "Guardando",
  Cancel: "Cancelar",

  nothingtosee: "Nada que ver aquí",
  logout: "Cerrar Sesión",

  // Orphans (admin only)
  Orphans: "Huérfanos",
  "Orphans description":
    "Documentos de modelos grupo (ej. payment_appliedto) que no tienen padre o cuyo documento padre ya no existe.",
  "Clean all orphans": "Limpiar todos los huérfanos",
  "No orphans found": "No se encontraron huérfanos.",
  orphans: "huérfanos",
  "Parent model": "Modelo padre",
  "No parent": "Sin padre",
  "Failed to load orphans": "Error al cargar huérfanos.",
  "Failed to clean orphans": "Error al limpiar huérfanos.",
  "Are you sure you want to permanently delete all orphans?":
    "¿Estás seguro de que deseas eliminar permanentemente todos los huérfanos?",
  "Clean orphans": "Limpiar huérfanos",
  Deleted: "Eliminados",
  "Payment expense mismatch description":
    "Pago ↔ gasto: un payment_appliedto enlaza un pago con un shipping_expense, pero ese gasto no incluye el pago en payments[], o el gasto ya no existe.",
  "Payment expense link issues": "Inconsistencias pago / gasto de envío",
  issues: "incidencias",
  "Fix expense payment backlinks": "Corregir vínculos en gasto (payments[])",
  "Expense missing": "Gasto inexistente",
  "Payment not on expense": "Pago no listado en el gasto",
  "Orphans expense payment label Payment": "Pago",
  "Orphans expense payment label Expense": "Gasto",
  "Current expense payments ids": "payments[] actual del gasto",
  "View payment": "Ver pago",
  "View expense": "Ver gasto",
  "View applied row": "Ver fila aplicado",
  "Confirm fix expense payment links":
    "¿Añadir en shipping_expenses.payments el id de cada pago faltante para el gasto enlazado? Es el vínculo inverso que esperan los hooks.",
  "Orphans fixed label": "Corregidos",
  "expense payment links": "vínculos gasto-pago",
  "Failed to sync links": "Error al sincronizar vínculos gasto-pago.",

  // Tutorial translations

  // TutorialButton translations
  tutorialButton: {},

  // Calendar Tutorial translations
  calendarTutorial: {
    // Welcome step
    calendarWelcome: {
      title: "Bienvenido al Tutorial del Calendario",
      description:
        "Te guiaré a través del funcionamiento del calendario del sistema y te explicaré el significado de los colores de status de shipping.",
      details: [
        "Aprenderás a navegar por el calendario mensual",
        "Entenderás cómo se muestran los eventos y fechas importantes",
        "Conocerás el significado de cada color de status de shipping",
        "Sabrás cómo interactuar con los días y eventos del calendario",
      ],

      tip: "El calendario es tu herramienta principal para visualizar y gestionar todas las fechas importantes de tus operaciones de trading.",
    },

    // Calendar navigation step
    calendarNavigation: {
      title: "Navegación del Calendario",
      description:
        "Los botones de navegación te permiten moverte entre los meses para ver eventos en diferentes períodos.",
      details: [
        "Botón izquierdo: Retrocede al mes anterior",
        "Botón derecho: Avanza al mes siguiente",
        "El mes y año actual se muestran en el centro",
        "La navegación es instantánea y mantiene tu vista actual",
      ],

      tip: "Usa la navegación para planificar operaciones futuras o revisar eventos pasados.",
    },

    // Calendar days step
    calendarDays: {
      title: "Días del Calendario",
      description:
        "Cada día del calendario muestra información visual sobre eventos y fechas importantes.",
      details: [
        "Los días del mes actual se muestran en fondo blanco",
        "Los días de otros meses se muestran en gris",
        "El día actual se destaca con un borde azul",
        "Los días con eventos tienen un fondo azul claro",
      ],

      tip: "Los días con eventos son fáciles de identificar por su fondo azul claro.",
    },

    // Event display step
    eventDisplay: {
      title: "Visualización de Eventos",
      description:
        "Los eventos se muestran dentro de cada día del calendario con información relevante.",
      details: [
        "Cada evento muestra el campo y el nombre del item",
        "Los eventos de shipping muestran colores según su status",
        "Los eventos de proforma se muestran en azul estándar",
        "Puedes ver múltiples eventos en el mismo día",
      ],

      tip: "Los colores de los eventos te dan información rápida sobre el estado de tus operaciones.",
    },

    // Shipping colors step
    shippingColors: {
      title: "Colores de Status de Shipping",
      description:
        "Los eventos de shipping se muestran con colores específicos que indican su prioridad y estado.",
      details: [
        "Gris: Sin prioridad (estado inicial)",
        "Amarillo: Operación pendiente",
        "Naranja: Operación atrasada",
        "Azul: Fecha de salida alcanzada",
        "Rojo: Llegada próxima (20 días o menos)",
        "Verde: En puerto (estado final)",
      ],

      tip: "Los colores te permiten identificar rápidamente qué operaciones requieren atención inmediata.",
    },

    // Color meaning step
    colorMeaning: {
      title: "Significado de los Colores",
      description:
        "Cada color representa un estado específico calculado automáticamente por el sistema.",
      details: [
        "El sistema calcula automáticamente el status basado en fechas",
        "Los colores cambian automáticamente según el progreso de la operación",
        "El verde (en puerto) es el estado final deseado",
        "El rojo indica que la llegada está próxima y requiere atención",
      ],

      tip: "Mantén un ojo en los eventos rojos y naranjas, ya que requieren acción inmediata.",
    },

    // Day interaction step
    dayInteraction: {
      title: "Interacción con los Días",
      description:
        "Puedes hacer clic en cualquier día del calendario para ver más detalles de los eventos.",
      details: [
        "Haz clic en un día con eventos para ver la lista completa",
        "Si hay un solo evento, irás directamente a su detalle",
        "Si hay múltiples eventos, se abre un modal con la lista",
        "Desde el modal puedes navegar a cualquier evento",
      ],

      tip: "Usa los clics en los días para acceder rápidamente a la información detallada de tus operaciones.",
    },

    // Event details step
    eventDetails: {
      title: "Panel de Eventos del Día",
      description:
        "El panel derecho muestra los eventos del día seleccionado con opciones de navegación.",
      details: [
        "Muestra la fecha seleccionada en formato legible",
        "Lista todos los eventos del día con su tipo y nombre",
        "Cada evento tiene un botón para ver sus detalles completos",
        "Los eventos se agrupan por modelo (Proform, Shipping)",
      ],

      tip: "Este panel te da una vista rápida de todo lo que sucede en un día específico.",
    },

    // Completion step
    calendarCompletion: {
      title: "¡Tutorial del Calendario Completado!",
      description:
        "Ahora entiendes perfectamente cómo funciona el calendario y el sistema de colores de shipping.",
      details: [
        "Navegación: Sabes cómo moverte entre meses y días",
        "Eventos: Entiendes cómo se muestran y organizan los eventos",
        "Colores: Conoces el significado de cada color de status",
        "Interacción: Sabes cómo acceder a información detallada",
      ],

      tip: "¡El calendario es ahora tu herramienta principal para gestionar y visualizar todas tus operaciones de trading!",
    },
  },
  // Traducciones de campos de Duntower
  AccountNumber: "Número de Cuenta",
  "Additional costs": "Costos Adicionales",
  Address: "Dirección",
  Amount: "Monto",
  Applied: "Aplicado",
  "Applied to": "Aplicado a",
  "Auto load packing list": "Carga automática de lista de empaque",
  "Autoload expenses": "Gastos de carga automática",
  "Autoload invoice supplier": "Factura de proveedor carga automática",
  paymentOrderRequiresExpense:
    "Para generar un pedido de pago debe primero crear el invoice supplier / proforma supplier en Expenses. Puede utilizar el botón autoload expense.",
  paymentOrderRequiresExpenseTitle: "Atención",
  "BL Number": "Número de BL",
  Balance: "Saldo",
  "Bank account": "Cuenta Bancaria",
  "Bank account (from)": "Cuenta bancaria (origen)",
  "Bank account (to)": "Cuenta bancaria (destino)",
  "Bank account (from) and Bank account (to) cannot be the same":
    "Bank account (from) y Bank account (to) no pueden ser la misma cuenta",
  "Bank name": "Nombre del Banco",
  "Billing Address": "Dirección de Facturación",
  "Billing address": "Dirección de facturación",
  "Booking Number": "Número de Reserva",
  "Buyer refererence": "Referencia del Comprador",
  Cartons: "Cartones",
  Category: "Categoría",
  City: "Ciudad",
  Client: "Cliente",
  Responsable: "Responsable",
  "Collect from": "Recoger de",
  Collection: "Cobranza",
  "Collection Number": "Número de Cobranza",
  "Collection date": "Fecha de Cobranza",
  Collections: "Cobranzas",
  "Collect situation": "Situación de cobro",
  cases: "casos",
  "No collect situations found": "No hay situaciones de cobro",
  Collects: "Cobros",
  "All Collects": "Todos los cobros",
  "Add Collection": "Agregar cobro",
  Comment: "Comentario",
  deleteCommentPlaceholder: "Indica por qué debes borrar este registro",
  Comments: "Comentarios",
  Contact: "Contacto",
  Container: "Contenedor",
  "Containers Involved": "Contenedores Involucrados",
  Country: "País",
  "Country of final destination": "País de Destino Final",
  "Country of origin": "País de Origen",
  CountryOfOrigin: "País de Origen",
  Origin: "Origen",
  Presentation: "Presentación",
  Uses: "Usos",
  "Credit note": "Nota de Crédito",
  "Credit notes amount": "Monto de Notas de Crédito",
  Currency: "Moneda",
  "Currency IN": "Moneda IN",
  "Currency IS": "Moneda IS",
  "Currency PS": "Moneda PS",
  "Customer's commercial": "Comercial del Cliente",
  "Cut off documents": "Corte de Documentos",
  "Cut off physical": "Corte Físico",
  "DHL date": "Fecha DHL",
  "DHL number": "Número DHL",
  Date: "Fecha",
  "Date Released": "Fecha de Liberación",
  "Debit note": "Nota de Débito",
  "Debit notes amount": "Monto de Notas de Débito",
  Description: "Descripción",
  Documentation: "Documentación",
  "Done payments amount": "Monto de Pagos Realizados",
  Drafts: "Borradores",
  Emails: "Correos Electrónicos",
  "Estimated time of arrival (ETA)": "Tiempo Estimado de Llegada (ETA)",
  "Estimated time of departure (ETD)": "Tiempo Estimado de Salida (ETD)",
  Expense: "Gasto",
  Expenses: "Gastos",
  "Expiration of import permit": "Vencimiento del Permiso de Importación",
  "FR Comments": "Comentarios FR",
  File: "Archivo",
  Forwarder: "Agente de Carga",
  "Forwarding agent": "Agente de Envío",
  "Gate Out": "Salida de Puerta",
  "Gross weight": "Peso Bruto",
  Holder: "Titular",
  "IN Comments": "Comentarios IN",
  "IP applicable": "IP Aplicable",
  Iban: "IBAN",
  Imagen: "Imagen",
  "Import permit file": "Archivo de Permiso de Importación",
  "Import permit number": "Número de Permiso de Importación",
  "In stock": "En Stock",
  Incoterm: "Incoterm",
  "Incoterm IS": "Incoterm IS",
  "Incoterm PS": "Incoterm PS",
  "Instr Comments": "Comentarios de Instrucciones",
  "Instr Consignee": "Consignatario en Instrucciones",
  "Instr Consignee in certificate":
    "Consignatario en Instrucciones del Certificado",
  "Instr Invoice to": "Facturar a en Instrucciones",
  "Instr Labelling": "Etiquetado en Instrucciones",
  "Instr Notify": "Notificar en Instrucciones",
  "Instr Product": "Producto en Instrucciones",
  "Instr Shipper": "Embarcador en Instrucciones",
  "Intermediate port": "Puerto Intermedio",
  Invoice: "Factura",
  "See more columns": "Ver más columnas",
  "See fewer columns": "Ver menos columnas",
  "Invoice Date": "Fecha de Factura",
  "Invoice Number": "Número de Factura",
  "Invoice products": "Productos de Factura",
  Language: "Idioma",
  "Letter of credit": "Carta de Crédito",
  "Loading date": "Fecha de Carga",
  Logo: "Logo",
  "Means of Convey": "Medio de Transporte",
  "Means of convey": "Medio de transporte",
  Name: "Nombre",
  "Name of Vessel": "Nombre del Buque",
  "Naviera": "Naviera",
  "Número factura vendedor": "Número factura vendedor",
  "Factura del vendedor": "Factura del vendedor",
  "Fecha de pago": "Fecha de pago",
  "Peso neto": "Peso neto",
  "Cantidad de contenedores": "Cantidad de contenedores",
  "Toneladas por contenedor": "Toneladas por contenedor",
  "Net weight": "Peso Neto",
  Nombre: "Nombre",
  Notify: "Notificar",
  Observations: "Observaciones",
  "Offer validity": "Validez de Oferta",
  "Original documents": "Documentos Originales",
  "PF Number": "Número PF",
  "PL Comments": "Comentarios PL",
  "Packing List": "Lista de Empaque",
  Paid: "Pagado",
  "Applied / requested": "Aplicado / pedido",
  "Bank payment date": "Fecha pago (banco)",
  "Not paid yet": "No pagado aún",
  "Unpaid payment excluded hint":
    "No entra en el saldo ni en los totales hasta que el pago se marque como pagado.",
  "Excluded from totals hint":
    "No entra en el saldo ni en los totales (p. ej. pago no pagado o cobro sin «recibido»).",
  "Filtered by proforma": "Filtrado por proforma",
  "Exclude balance 0": "Ocultar saldo 0",
  accountStatementShowingRange: "Mostrando {from}–{to} de {total}",
  accountStatementGeneralTitle: "Cuenta Corriente General",
  accountStatementGeneralSubtitle: "Movimientos financieros de todos los contactos",
  accountStatementAllContacts: "Todos los contactos",
  accountStatementByContactSubtitle:
    "Saldo de cada contacto. Abra un contacto para ver sus operaciones.",
  accountStatementNoContacts: "No hay contactos con movimientos",
  accountStatementWithoutContact: "Sin contacto",
  contactBalanceAsOf: "Saldo al",
  contactShippingEtd: "ETD",
  contactShippingEta: "ETA",
  contactShippingDate: "Fecha de operación",
  listColumnAsOf: "al {date}",
  balanceDateRangeInvalid: "Desde tiene que ser anterior o igual a Hasta",
  contactBalanceFrom: "Desde",
  contactBalanceTo: "Hasta",
  accountStatementFromHint:
    "Con Desde se ven solo los movimientos del período: débitos, créditos y neto, sin el saldo anterior",
  accountStatementPeriodNet: "Neto del período",
  contactBalanceAsOfShort: "al",
  contactBalanceAsOfHint:
    "Saldo de cada contacto al cierre de este día (los movimientos sin fecha cuentan desde su alta)",
  accountStatementTabMovements: "Movimientos",
  accountStatementTabArchived: "Archivadas",
  accountStatementTabAll: "Todo",
  accountStatementActions: "Acciones",
  accountStatementArchiveOperation: "Archivar operación",
  accountStatementArchiveConfirmTitle: "¿Archivar operación de esta proforma?",
  accountStatementArchiveConfirmText:
    "Todas las líneas vinculadas a esta proforma dejarán de mostrarse en el estado de cuenta. Podrás verlas en la pestaña Archivadas.",
  accountStatementArchivedOk: "Operación archivada",
  accountStatementRestoreOperation: "Restaurar operación",
  accountStatementRestoreConfirmTitle: "¿Restaurar operación de esta proforma?",
  accountStatementRestoreConfirmText:
    "Todas las líneas vinculadas a esta proforma volverán a mostrarse en el estado de cuenta principal.",
  accountStatementRestoredOk: "Operación restaurada",
  accountStatementSelectInvoiceToPay:
    "Seleccione al menos una factura pendiente del listado.",
  accountStatementAlreadyRequestedHint: "Pago ya solicitado ({amount})",
  accountStatementHiddenByExcludeBalanceZero:
    "Excluir saldo 0 oculta todos los movimientos porque cada operación queda en cero. Desactive el switch para ver los pagos pendientes.",
  accountStatementProformSupplierTitle: "Proforma proveedor (provisorio)",
  accountStatementProformSupplierHint:
    "Todavía no son facturas: quedan fuera de débito, crédito y saldo. Se pueden marcar para pedir el pago del anticipo.",
  accountStatementProformSupplierRequestHint: "A pedir: {amount}",
  accountStatementProformAdvanceCoveredHint:
    "Anticipo ya pedido o pagado: el resto se pide con la factura.",
  accountStatementBalanceReadingHint:
    "Más reciente arriba: el Balance de la primera fila es el saldo actual; hacia abajo vuelve al saldo inicial.",
  "Pending prepayment": "Anticipo pendiente",
  "Sin prepayment asociado": "Sin prepayment asociado",
  "Invoice Client": "Factura cliente",
  "Invoice Shipper": "Factura shipper",
  "Initial Balance": "Saldo inicial",
  "Accumulated Balance": "Saldo acumulado",
  TOTALS: "TOTALES",
  Yes: "Sí",
  "No proforma linked for account statement":
    "No hay proforma vinculada a este registro; no se puede filtrar el estado de cuenta.",
  "Payment conditions": "Condiciones de Pago",
  "Payment date": "Fecha de Pago",
  "Payment supplier": "Pago a Proveedor",
  "Payment to": "Pago a",
  Payments: "Pagos",
  Payment: "Pago",
  "Add Payment": "Agregar pago",
  "Add Expense": "Agregar gasto",
  "Payment not found": "Pago no encontrado",
  "Invalid payment id": "Identificador de pago no válido",
  paymentAppliedToIncompleteLoad:
    "No se pudieron cargar todas las aplicaciones de este pago. Recargá la página y volvé a abrirlo antes de editarlas.",
  Copied: "Copiado",
  Copy: "Copiar",
  "Copy shareable link": "Copiar enlace",
  "Open shareable payment page": "Abrir página de pago (enlace para compartir)",
  "Link copied to clipboard": "Enlace copiado",
  "Could not copy share link": "No se pudo copiar el enlace",
  Attachments: "Adjuntos",
  "Pending payments amount": "Monto de Pagos Pendientes",
  Phone: "Teléfono",
  "Port Of Delivery": "Puerto de Entrega",
  "Port Of Origin": "Puerto de Origen",
  "Port of delivery": "Puerto de entrega",
  "Port of incoterm": "Puerto de Incoterm",
  "Port of incoterm IS": "Puerto de Incoterm IS",
  "Port of incoterm PS": "Puerto de Incoterm PS",
  "Port of origin": "Puerto de origen",
  "Postal code": "Código Postal",
  "Remove from stock": "Sacar del stock",
  "The proforma {name} will be marked as Remove from stock and will no longer count in stock.": "La proforma {name} queda marcada como Sacar del stock y deja de contar en el stock.",
  Price: "Precio",
  submittedby: "Subido por {name} el {date}",
  updatedby: "Actualizado por {name} el {date}",
  Product: "Producto",
  "Product and price": "Producto y Precio",
  Products: "Productos",
  Contracts: "Contratos",
  Proform: "Proforma",
  "Proform file": "Archivo de Proforma",
  "Proform number": "Número de Proforma",
  "Proform number Date": "Fecha de Número de Proforma",
  "Qty containers": "Cantidad de Contenedores",
  "Qty of Cont": "Cantidad de Cont",
  "Quantity of Containers": "Cantidad de Contenedores",
  "Raw Weight": "Peso en Bruto",
  "Reference number": "Número de Referencia",
  ReferenceNumber: "Número de Referencia",
  "Related file": "Archivo Relacionado",
  "Release Method": "Método de Liberación",
  "Release method": "Método de liberación",
  Remaining: "Restante",
  "Request Date of Payment": "Fecha de Solicitud de Pago",
  "Seal Number": "Número de Sello",
  "Shipper's commercial": "Comercial del Embarcador",
  Shipping: "Envío",
  "Shipping Line": "Línea de Envío",
  ShippingLine: "Línea de Envío",
  Signature: "Firma",
  "Sizing ref": "Referencia de Talla",
  Status: "Estado",
  Supplier: "Proveedor",
  "Supplier Invoice number": "Número de Factura del Proveedor",
  "Supplier invoice date": "Fecha de Factura del Proveedor",
  "Supplier products": "Productos del Proveedor",
  Swift: "SWIFT",
  Title: "Título",
  "To apply": "A Aplicar",
  Total: "Total",
  "Total (USD)": "Total (USD)",
  "Total Additional Cost": "Costo Adicional Total",
  "Total Net Weight": "Peso Neto Total",
  "Total Price": "Precio Total",
  "PRECIO por tonelada": "PRECIO por tonelada",
  Peso: "Peso",
  "Cantidad de Bolsas": "Cantidad de Bolsas",
  "Total Price Cont.": "Precio Total Cont.",
  "Total Products and price": "Total Productos y Precio",
  "Total Qty Cont.": "Cantidad Total Cont.",
  "Total Qty.": "Cantidad Total",
  "Total Qty. Cont.": "Cantidad Total Cont.",
  "Total Quantity": "Cantidad Total",
  "Total Raw Weight": "Peso en Bruto Total",
  "Total add cost": "Costo adicional total",
  "Total amount invoiced": "Monto total facturado",
  "Total amount": "Importe total",
  "Total billed": "Total facturado",
  "Total containers": "Total contenedores",
  "Total credit note": "Total nota de crédito",
  "Total debit note": "Total nota de débito",
  "Total expenses": "Total gastos",
  "Total invoice supplier": "Total factura proveedor",
  "Total net weight": "Peso neto total",
  "Total product price": "Precio total producto",
  "Total proform": "Total proforma",
  "Total qty": "Cantidad total",
  "Total quantity": "Cantidad total",
  TransitTime: "Tiempo de Tránsito",
  "Transit days": "Días de tránsito",
  "Certificate type": "Tipo de certificado",
  Type: "Tipo",
  "Type of Cont": "Tipo de Cont",
  "Type of cont": "Tipo de contenedor",
  "Type of container": "Tipo de contenedor",
  "Type of document": "Tipo de documento",
  TypeOfContainer: "Tipo de Contenedor",
  "Unit price": "Precio unitario",
  "Unit qty": "Cantidad unitaria",
  "Validation date": "Fecha de validación",
  Website: "Sitio web",

  shipping: "envío",
  etd: "ETD",
  eta: "ETA",
  shippingDate: "Fecha de operación",

  "unit price": "precio unitario",
  "unit qty": "cantidad unitaria",
  General: "General",
  "Import Permit": "Permiso de Importación",
  "Invoice (IN)": "Factura (IN)",
  "Invoice Supplier (IS)": "Factura Proveedor (IS)",
  Location: "Ubicación",
  "Packing List (PL)": "Lista de Empaque (PL)",
  "Proform Shipper": "Proforma Embarcador",
  "Proform Supplier (PS)": "Proforma Proveedor (PS)",
  Proforma: "Proforma",
  "Shipping Instructions": "Instrucciones de Envío",
  Shippings: "Envíos",
  Totals: "Totales",
  Freight: "Flete",
  "Freight Price": "Precio flete",
  "Freight Price 2": "Precio flete 2",
  Finance: "Finanzas",
  "Financial Overview": "Resumen Financiero",
  Concept: "Concepto",
  "Concept search placeholder": "Varias palabras separadas por espacios…",
  "Concept search hint":
    "Busca en el texto plano (textPlainVersion) de los registros relacionados; deben aparecer todas las palabras.",
  Remove: "Quitar",
  Documents: "Documentos",
  Expenses: "Gastos",
  "Credit/Debit notes": "Notas de Crédito/Débito",
  Location: "Ubicación",
  "Packing List (PL)": "Lista de Empaque (PL)",
  "Proform Shipper": "Proforma Embarcador",
  "Proform Supplier (PS)": "Proforma Proveedor (PS)",

  // Auto-save translations
  unsavedChanges: "Cambios sin guardar",
  unsavedChangesMessage:
    "Tienes modificaciones pendientes que no se han guardado",
  newRecordNotSavedYet:
    "Este formulario todavía no se guardó: apretá «Guardar» para crear el registro",
  savingIn: "Guardando en",
  saving: "Guardando",
  disableAutoSave: "Desactivar autosave",

  // Calendar translations
  calendar: {
    weekDays: {
      sunday: "Dom",
      monday: "Lun",
      tuesday: "Mar",
      wednesday: "Mié",
      thursday: "Jue",
      friday: "Vie",
      saturday: "Sáb",
    },
    todayEvents: {},

    noEventsForDate: "No hay eventos para esta fecha",
    createEvent: "Crear evento",
    // Ayuda (?) de cada ítem del engranaje del calendario del dashboard.
    fieldHelp: {
      shipping_etd: "Muestra cada embarque el día en que se estima que sale el buque (ETD).",
      shipping_eta: "Muestra los embarques que llegan en 20 días o menos y todavía no hicieron gate out, el día estimado de llegada (ETA).",
      shipping_shipping_date: "Muestra cada embarque el día en que se carga la mercadería.",
      shipping_gate_out: "Muestra cada embarque el día en que la carga salió del puerto (gate out).",
      payment_payment_date: "Muestra los pagos ya hechos, el día en que se pagaron.",
      collect_date: "Muestra los cobros de clientes, en su fecha de cobro.",
      shipping_status_1: "Embarques que todavía no tienen fecha de carga. Si lo destildás, se ocultan todas sus fechas.",
      shipping_status_2: "Embarques con fecha de carga para hoy o más adelante. Si lo destildás, se ocultan todas sus fechas.",
      shipping_status_3: "Embarques ya cargados que todavía no llegaron a su ETD. Si lo destildás, se ocultan todas sus fechas.",
    },
  },

  // Events Analyzer translations
  eventsAnalyzer: {
    today: {
      title: "Eventos de Hoy",
      noEvents: "No hay eventos para hoy",
      criteria:
        "Eventos que ocurren exactamente hoy: cargas, pagos, cobros, ETAs, Gate Out, etc.",
    },
    thisWeek: {
      title: "Esta Semana",
      noEvents: "No hay eventos esta semana",
      criteria:
        "Eventos de los próximos 7 días: todas las fechas importantes que vencen esta semana",
    },
    nextEvents: {
      title: "Próximos",
      noEvents: "No hay eventos próximos",
      criteria:
        "Eventos de los próximos 30 días (excluyendo esta semana): planificación a mediano plazo",
    },
    urgent: {
      title: "Urgentes",
      noEvents: "No hay eventos urgentes",
      criteria:
        "Eventos que requieren acción inmediata: ETAs próximos (3 días), pagos vencidos no pagados, ETAs/Gate Out vencidos no completados (status ≠ 6)",
    },
    criteria: {
      title: "Criterios de Clasificación",
      close: "Cerrar",
    },
    pendingPayment: "Pendiente de pago",
    viewDetails: "Ver Detalles",
  },

  // Operations Summary translations
  operationsSummary: {
    title: "Resumen de Eventos",
    noOperations: "No hay eventos próximos",
    help: "Ayuda sobre fechas de exportación",
    close: "Cerrar",
    helpText: {
      title: "Criterios de Clasificación",
      sections: {
        mainDates: {
          title: "Fechas Principales del Embarque",
          eta: "ETA (Estimated Time of Arrival): Fecha estimada de llegada de la nave/avión al puerto de destino. Importante para coordinar despacho de aduanas y retiro de mercadería.",
          etd: "ETD (Estimated Time of Departure): Fecha estimada de salida del buque/avión desde el puerto de origen. Marca el inicio del tránsito internacional.",
        },
        cutOffs: {
          title: "Cut Offs (Cierres)",
          documents:
            "Cut Off Documents: Fecha límite para presentar documentación de exportación. Si no se cumple, el embarque puede quedar fuera del viaje.",
          physical:
            "Cut Off Physical: Fecha límite para entregar físicamente la carga en la terminal. Después de este punto, el contenedor ya no puede ser aceptado.",
        },
        cargoMovements: {
          title: "Movimientos de Carga",
          loading:
            "Loading Date: Día en que la carga es cargada en el buque/avión. Coincide con la operación de estiba en puerto.",
          gateOut:
            "Gate Out: Fecha en que el contenedor sale del depósito hacia la terminal portuaria. Marca el inicio de la custodia por parte del transportista.",
        },
        documentation: {
          title: "Documentación Comercial",
          dateReleased:
            "Date Released: Fecha en que se liberan los documentos de embarque. A partir de aquí, el importador puede gestionar el retiro en destino.",
        },
        importPermits: {
          title: "Permisos de Importación",
          expiration:
            "Import Permit Expiration: Fecha de vencimiento del permiso. Si vence antes de la llegada de la carga, no se puede nacionalizar.",
        },
        payments: {
          title: "Fechas de Pago",
          paymentDate:
            "Payment Date: Fecha en que hay que pagar algo. Crítico para mantener el flujo de caja y evitar penalizaciones.",
        },
      },
    },
    messages: {
      eta: {
        today:
          "¡Llegada hoy! {count} {vessel} {verb} hoy al puerto de destino. Es momento de coordinar el despacho de aduanas y retiro de mercadería.",
        tomorrow:
          "Llegada mañana: {count} {vessel} {verb} mañana. Prepárate para el despacho de aduanas.",
        thisWeek:
          "Esta semana: {count} {vessel} {verb} esta semana. Coordina con el importador para el retiro.",
      },
      etd: {
        today:
          "Salida hoy: {count} {vessel} {verb} hoy del puerto de origen. El tránsito internacional ha comenzado.",
        tomorrow:
          "Salida mañana: {count} {vessel} {verb} mañana. Última oportunidad para completar la documentación.",
        thisWeek:
          "Esta semana: {count} {vessel} {verb} esta semana del puerto de origen.",
      },
      loading: {
        today:
          "Carga hoy: {count} {container} {verb} hoy en el buque. Operación de estiba en puerto.",
        tomorrow: "Carga mañana: {count} {container} {verb} mañana.",
        thisWeek: "Esta semana: {count} {container} {verb} esta semana.",
      },
      gateOut: {
        today:
          "Gate Out hoy: {count} {container} {verb} hoy del depósito hacia la terminal portuaria.",
        tomorrow:
          "Gate Out mañana: {count} {container} {verb} mañana hacia el puerto.",
        thisWeek:
          "Esta semana: {count} {container} {verb} esta semana hacia la terminal.",
      },
      payment: {
        today:
          "Pago hoy: {count} {payment} {verb} hoy. ¡Atención! Revisa el estado de los pagos pendientes.",
        tomorrow:
          "Pago mañana: {count} {payment} {verb} mañana. Prepárate para realizar los pagos.",
        thisWeek: "Esta semana: {count} {payment} {verb} esta semana.",
      },
      cutOffDocs: {
        today:
          "Cut Off documentos hoy: {count} {operation} {verb} cierre de documentos hoy. ¡Última oportunidad!",
        tomorrow:
          "Cut Off documentos mañana: {count} {operation} {verb} cierre de documentos mañana.",
        thisWeek:
          "Esta semana: {count} {operation} {verb} cierre de documentos esta semana.",
      },
      cutOffPhysical: {
        today:
          "Cut Off física hoy: {count} {operation} {verb} cierre física hoy. ¡Última oportunidad!",
        tomorrow:
          "Cut Off física mañana: {count} {operation} {verb} cierre física mañana.",
        thisWeek:
          "Esta semana: {count} {operation} {verb} cierre física esta semana.",
      },
      dateReleased: {
        today:
          "Documentos liberados hoy: {count} {document} {verb} hoy. El importador puede gestionar el retiro.",
        tomorrow: "Documentos mañana: {count} {document} {verb} mañana.",
        thisWeek: "Esta semana: {count} {document} {verb} esta semana.",
      },
      importPermit: {
        today:
          "Permisos vencen hoy: {count} {permit} {verb} hoy. ¡Crítico! Sin permiso no se puede nacionalizar.",
        tomorrow:
          "Permisos mañana: {count} {permit} {verb} mañana. Renueva urgentemente.",
        thisWeek: "Esta semana: {count} {permit} {verb} esta semana.",
      },
      payment_pending: {
        today:
          "⚠️ <strong>Pagos pendientes hoy:</strong> {count} {payment} {verb} hoy. ¡Urgente! Estos pagos necesitan ser procesados inmediatamente.",
        tomorrow:
          "⚠️ <strong>Pagos pendientes mañana:</strong> {count} {payment} {verb} mañana. Prepárate para procesar estos pagos.",
        thisWeek:
          "⚠️ <strong>Esta semana:</strong> {count} {payment} {verb} esta semana. Revisa y procesa los pagos pendientes.",
      },
    },
    words: {
      vessel: { single: "barco", plural: "barcos" },
      container: { single: "contenedor", plural: "contenedores" },
      payment: { single: "pago", plural: "pagos" },
      operation: { single: "operación", plural: "operaciones" },
      document: {
        single: "conjunto de documentos",
        plural: "conjuntos de documentos",
      },
      permit: { single: "permiso", plural: "permisos" },
      arrives: { single: "llega", plural: "llegan" },
      leaves: { single: "sale", plural: "salen" },
      loads: { single: "se carga", plural: "se cargan" },
      goesOut: { single: "sale", plural: "salen" },
      expires: { single: "vence", plural: "vencen" },
      has: { single: "tiene", plural: "tienen" },
      releases: { single: "se libera", plural: "se liberan" },
    },
  },

  "Financial Summary": "Resumen Financiero",

  // Financial Summary translations
  dashboardWidgets: {
    manage: "Widgets",
    reorder: "Ordenar",
    doneReordering: "Listo",
    moveUp: "Subir",
    moveDown: "Bajar",
    remove: "Quitar",
    refresh: "Actualizar",
    options: "Opciones del widget",
    dragHint: "Arrastrá para mover · esquina para cambiar el tamaño",
    saving: "Guardando…",
    saveError: "No se pudo guardar el dashboard",
    loadError: "No se pudieron cargar los datos.",
    emptyDashboard: "Tu dashboard está vacío.",
    resetConfirmTitle: "¿Restablecer el dashboard?",
    resetConfirmText: "Vuelve el dashboard predeterminado y se pierden tus widgets y notas.",
    cancel: "Cancelar",
    // Widgets «Productos» y «Contactos» (TradeWidget)
    trade: {
      noSources: "No hay operaciones que puedas ver.",
      noData: "Sin datos para mostrar.",
      noUnit: "sin unidad",
      others: "Otros",
      vsPrevious: "vs. período anterior",
      lastMonths: "Últimos {n} meses",
      allTime: "Todo",
      dormantFor: "Sin operaciones hace {n} meses",
      firstIn: "Primera: {month}",
      lastIn: "Última: {month}",
      opsCount: "{n} op.",
      concentrationText: "del total en los {n} principales, de {total} clientes",
      kpi: { products: "Productos", operations: "Operaciones", qty: "Cantidad", total: "Total", newProducts: "Productos nuevos" },
      empty: {
        newProducts: "Ningún producto nuevo en el período.",
        newClients: "Ningún cliente nuevo en el período.",
        dormant: "Todos los clientes compraron en ese plazo.",
      },
      sources: { contract: "Contratos", shipping: "Embarques", proform: "Proformas" },
      kinds: { sale: "Venta", purchase: "Compra", trade: "Corretaje" },
      measure: { qty: "Cantidad", amount: "Monto", operations: "Operaciones" },
      menu: {
        source: "Operaciones",
        side: "Lado",
        measure: "Medir por",
        unit: "Unidad",
        period: "Período",
        dormant: "Sin operaciones hace",
        months: "{n} meses",
        allTime: "Todo",
        show: "Mostrar",
        top: "Top {n}",
      },
    },
    categories: {
      all: "Todos",
      general: "Generales",
      finance: "Finanzas",
      products: "Productos",
      contacts: "Contactos",
      reports: "Reportes",
      containers: "Contenedores y stock",
      tracking: "Seguimiento",
      support: "Soporte",
      tools: "Herramientas",
      market: "Mercado",
      ai: "Inteligencia artificial",
    },
    catalog: {
      title: "Widgets del dashboard",
      subtitle: "Elegí qué ver en tu dashboard. Solo aparecen los de tus módulos y permisos.",
      search: "Buscar widget…",
      close: "Cerrar",
      loading: "Cargando widgets…",
      noResults: "No hay widgets que coincidan.",
      added: "Agregado",
      add: "Agregar",
      addAnother: "Agregar otra",
      remove: "Quitar",
      reset: "Restablecer",
      done: "Listo",
    },
    items: {
      products_summary: { title: "Productos: resumen", description: "Productos operados, operaciones, cantidades y total del período, comparado con el anterior." },
      products_top: { title: "Productos más vendidos", description: "Ranking de productos por cantidad, monto u operaciones, de venta o de compra." },
      products_by_month: { title: "Cantidad por mes", description: "Toneladas (o la unidad que elijas), monto u operaciones de cada mes." },
      products_new: { title: "Productos nuevos", description: "Productos que se operaron por primera vez en el período." },
      contacts_top_clients: { title: "Principales clientes", description: "Quién compró más, por cantidad, monto u operaciones." },
      contacts_top_suppliers: { title: "Principales proveedores", description: "A quién se compró más, por cantidad, monto u operaciones." },
      contacts_new_clients: { title: "Clientes nuevos", description: "Clientes con su primera operación en el período." },
      contacts_dormant: { title: "Clientes sin operaciones", description: "Clientes que compraron y no vuelven hace 3, 6 o 12 meses, los de más operaciones primero." },
      contacts_concentration: { title: "Concentración de clientes", description: "Qué parte del total se llevan los principales clientes." },
      shortcuts: { title: "Accesos rápidos", description: "Jurisprudencia y MEV a un click." },
      calendar: { title: "Calendario", description: "Las fechas de tus operaciones mes a mes." },
      recent_activity: { title: "Actividad reciente", description: "Lo último que se creó o modificó y quién lo hizo." },
      operations_summary: { title: "Resumen de operaciones", description: "Los eventos próximos de cada tipo de fecha." },
      containers_month: { title: "Contenedores por mes", description: "Embarcados en los últimos 12 meses y el acumulado del año." },
      containers_destination: { title: "Contenedores por destino", description: "Los países con más contenedores del año." },
      containers_client: { title: "Contenedores por cliente", description: "Los clientes con más contenedores del año." },
      containers_shipper: { title: "Contenedores por shipper", description: "Los shippers con más contenedores del año." },
      stock_health: { title: "Estado del stock", description: "Productos con stock, en cero y negativos." },
      support_tickets: { title: "Tickets de soporte", description: "Cuántos tickets hay pendientes, en curso o esperando respuesta." },
      finance_month: { title: "Finanzas del mes", description: "Cobrado, pagado y neto de este mes contra el anterior, por moneda." },
      finance_cashflow: { title: "Flujo de caja", description: "Entradas y salidas de los últimos 6 meses." },
      finance_payments_pending: { title: "Pedidos de pago pendientes", description: "Lo que falta pagar, los vencidos y los próximos." },
      finance_receivables: { title: "Por cobrar", description: "Saldo a cobrar de las operaciones y los clientes que más deben." },
      finance_payables: { title: "Por pagar a proveedores", description: "Saldo pendiente con proveedores, por moneda." },
      finance_bank_balances: { title: "Saldos de cuentas", description: "El saldo de cada cuenta bancaria, por moneda." },
      finance_margins: { title: "Margen proyectado", description: "Venta, margen y % por mes, sobre las proformas." },
      finance_margins_real: { title: "Margen real", description: "Venta, margen y % por mes, sobre los embarques con costos." },
      finance_low_margins: { title: "Menor margen", description: "Las operaciones de los últimos 90 días con el margen más bajo." },
      finance_advances: { title: "Adelantos pendientes", description: "Adelantos de proformas que todavía no se cobraron." },
      notifications: { title: "Últimas notificaciones", description: "Los avisos que te llegan por mail: pedidos de pago, cobros, tickets." },
      tracking_status: { title: "Estado del seguimiento", description: "Contenedores en tránsito, por zarpar, atrasados y con error." },
      tracking_alerts: { title: "Alertas de seguimiento", description: "Hitos vencidos, ETA pasada sin llegar y errores de la naviera." },
      tracking_arrivals: { title: "Próximos arribos", description: "Contenedores por fecha de llegada, con su ruta y su embarque." },
      tracking_routes: { title: "Rutas en curso", description: "Contenedores activos por origen y destino." },
      note: { title: "Nota", description: "Un recordatorio propio, solo lo ves vos." },
      client_questions: { title: "Dudas", description: "Lo que necesitamos que nos aclares sobre lo que estamos desarrollando. Respondé desde acá." },
      report: { description: "Reporte guardado de {model}." },
    },
    report: {
      empty: "El reporte no tiene filas.",
      seeAll: "Ver las {n} filas",
      rows: "filas",
      partial: "Calculado sobre las primeras {n} filas.",
      noValue: "(vacío)",
      others: "Otros",
      modeList: "Lista",
      modeKpi: "Total",
      open: "Abrir reporte",
      modeChart: "Gráfico",
      configure: "Configurar…",
      chartCaption: "{measure} por {by}",
    },
    settings: {
      title: "Configurar widget",
      showAs: "Mostrar como",
      modeList: "Lista",
      modeKpi: "Total",
      modeChart: "Gráfico",
      chartType: "Tipo de gráfico",
      type: { column: "Columnas", bar: "Barras", line: "Línea", area: "Área", pie: "Torta", donut: "Dona" },
      xAxis: "Eje X",
      yAxis: "Eje Y",
      slices: "Porciones",
      sliceSize: "Tamaño de cada porción",
      field: "Campo",
      date: "fecha",
      groupDateBy: "Agrupar la fecha por",
      bucket: { day: "Día", week: "Semana", month: "Mes", year: "Año" },
      measure: "Medida",
      ofField: "Del campo",
      agg: { count: "Cantidad de filas", sum: "Suma", avg: "Promedio", max: "Máximo", min: "Mínimo" },
      periods: "Períodos a mostrar",
      maxCategories: "Máximo de categorías",
      order: "Orden",
      sortValue: "Mayor valor primero",
      sortLabel: "Alfabético",
      rowTitle: "Título de cada fila",
      auto: "Automático",
      details: "Detalles (hasta {n})",
      kpiFields: "Columnas a sumar (hasta 4)",
      noNumeric: "El reporte no tiene columnas numéricas.",
      preview: "Vista previa",
      cancel: "Cancelar",
      save: "Guardar",
    },
    containers: {
      thisMonth: "Este mes",
      ytd: "En {year}",
      vsLastYear: "vs. año anterior",
      allYears: "Todos los años",
      empty: "Sin contenedores en el período.",
      open: "Abrir contenedores",
    },
    stats: {
      products: "productos",
      withStock: "Con stock",
      zeroStock: "En cero",
      negativeStock: "Negativo",
      openTickets: "tickets abiertos",
      pending: "Pendientes",
      progress: "En curso",
      waitingForAnswer: "Esperan respuesta",
      readyForTest: "Para probar",
      open: "Abrir",
    },
    finance: {
      noCurrency: "Sin moneda",
      denied: "No tenés permiso para ver estos datos.",
      noMovements: "Sin movimientos en el período.",
      collected: "Cobrado",
      paid: "Pagado",
      net: "Neto",
      prevMonth: "mes ant. {v}",
      in: "Entradas",
      out: "Salidas",
      requests: "{n} pedidos",
      overdue: "{n} vencidos · {v}",
      noPending: "No hay pedidos de pago pendientes.",
      nothingPending: "No hay saldos pendientes.",
      operations: "{n} operaciones",
      proformsWithAdvance: "{n} proformas",
      shippingsCount: "{n} embarques",
      expensesCount: "{n} gastos",
      accounts: "{n} cuentas",
      excluded: "{n} registros con saldo mayor que la venta no se cuentan (revisar).",
      noMargins: "Sin operaciones con margen en el período.",
      sales: "Venta",
      margin: "Margen",
      marginPct: "Margen %",
      marginPctByMonth: "Margen % por mes",
      last90: "Últimos 90 días; sin registros sin costos ni inconsistentes.",
      basis: "Calcular sobre",
      basisProforms: "Proformas (proyectado)",
      basisShippings: "Embarques (real)",
      currency: "Moneda",
      open: "Abrir finanzas",
    },
    tracking: {
      noActive: "No hay contenedores en seguimiento.",
      activeTrackings: "en seguimiento",
      stoppedCount: "{n} detenidos (no se cuentan)",
      state: {
        inTransit: "En tránsito",
        notSailed: "Por zarpar",
        delayed: "Atrasados",
        error: "Con error",
        completed: "Completados",
        noData: "Sin datos",
      },
      noAlerts: "Nada que mirar: todo según lo esperado.",
      syncError: "Error de la naviera ({code}): {text}",
      noArrivals: "No hay arribos con ETA.",
      today: "hoy",
      inDays: "en {n} d",
      daysLate: "hace {n} d",
      open: "Abrir seguimiento",
    },
    notifications: {
      empty: "Todavía no te llegó ningún aviso.",
      repeated: "Llegó {n} veces",
      justNow: "recién",
      minutesAgo: "hace {n} min",
      hoursAgo: "hace {n} h",
      daysAgo: "hace {n} d",
    },
    presets: {
      title: "Dashboards guardados",
      close: "Cerrar",
      saveCurrent: "Guardar el dashboard actual",
      saveCurrentShort: "Guardar este dashboard",
      createSubtitle: "Queda como un botón arriba; si lo compartís, queda disponible para todos.",
      editTitle: "Editar «{name}»",
      editOne: "Editar «{name}»",
      name: "Nombre",
      namePlaceholder: "Nombre (p. ej. «Operaciones del día»)",
      description: "Descripción",
      descriptionPlaceholder: "Descripción (opcional)",
      share: "Compartir con los demás usuarios",
      shareHint: "Lo verán todos los usuarios; cada uno solo ve los widgets que su rol permite. Las notas no se comparten.",
      save: "Guardar",
      saveChanges: "Guardar cambios",
      cancel: "Cancelar",
      by: "de {name}",
      widgetsCount: "{n} widgets",
      unsaved: "Cambiado desde que lo elegiste (sin guardar)",
      overwrite: "Reemplazar con el dashboard actual",
      overwriteHint: "Guarda en este dashboard cómo tenés armado el tuyo ahora.",
      overwriteTitle: "¿Reemplazar «{name}» con tu dashboard actual?",
      overwriteText: "Quien lo use después va a ver la disposición nueva.",
      delete: "Borrar",
      deleteTitle: "¿Borrar «{name}»?",
      deleteSharedText: "Está compartido: deja de estar disponible para los demás (a quien ya lo usa no le cambia nada).",
      saveError: "No se pudo guardar",
      deleteError: "No se pudo borrar",
      default: "Predeterminado",
      applyToAll: "Aplicar a todos los usuarios",
      applyToAllHint: "Reemplaza el dashboard de cada usuario y queda como predeterminado para los nuevos.",
      applyToAllTitle: "¿Aplicar «{name}» a todos los usuarios?",
      applyToAllText: "Reemplaza el dashboard de cada usuario (sus widgets y notas actuales se pierden) y queda como predeterminado para los nuevos. Cada uno ve solo los widgets que su rol permite.",
      appliedToAll: "Aplicado a {n} usuarios",
      clearDefault: "Dejar de usarlo como predeterminado",
      clearDefaultHint: "Los usuarios nuevos vuelven a arrancar con el dashboard de fábrica.",
      switchTitle: "¿Usar «{name}»?",
      switchTextDirty: "Los cambios que le hiciste a «{name}» no están guardados y se pierden.",
      switchTextUnsaved: "Tu dashboard actual no está guardado y se pierde. Para conservarlo, guardalo con el «+».",
      saveShort: "Guardar",
      saveChangesIn: "Guardar los cambios en «{name}»",
      saveAsNew: "No podés modificar este dashboard: guardá tus cambios como uno nuevo",
      discardTitle: "¿Descartar los cambios de «{name}»?",
      discardText: "Vuelve a como estaba guardado. Para conservar los cambios, usá «Guardar».",
      discard: "Descartar",
      foreignTitle: "Este dashboard no es tuyo",
      foreignText: "«{name}» es de {owner}: tus cambios no se pueden guardar en él. ¿Querés guardarlos como un dashboard nuevo, tuyo?",
      foreignTextNoOwner: "«{name}» es de otro usuario: tus cambios no se pueden guardar en él. ¿Querés guardarlos como un dashboard nuevo, tuyo?",
      saveAsNewShort: "Guardar como nuevo",
      keepWithoutSaving: "Seguir sin guardar",
      copyName: "{name} (copia)",
      switchConfirm: "Usar",
    },
    tour: {
      launcher: "Tutorial",
      launcherTitle: "Cómo usar el nuevo dashboard por widgets",
      hide: "Ocultar el tutorial",
      welcomeTitle: "Tu dashboard ahora es por widgets",
      welcomeBody: "Elegís qué ver, lo acomodás como quieras y lo guardás. Te mostramos cómo en un minuto.",
      addTitle: "Agregá o quitá widgets",
      addBody: "Tocá «Widgets» para ver todos los que tenés disponibles.",
      catalogTitle: "El catálogo",
      catalogBody: "Cada tarjeta es un widget con su vista previa: reportes, contenedores, finanzas, seguimiento y más. Tocá «Agregar» en los que quieras; solo ves los de tus módulos y permisos.",
      catalogBodyMobile: "Cada tarjeta es un widget con su vista previa. Tocá «Agregar» en los que quieras; solo ves los de tus módulos y permisos.",
      catalogDoneTitle: "Listo",
      catalogDoneBody: "Cuando termines, tocá «Listo» para volver al dashboard.",
      moveTitle: "Movelos",
      moveBody: "Arrastrá un widget desde su encabezado. Mientras lo llevás, todo el dashboard se achica para que lo puedas dejar en cualquier lugar.",
      resizeTitle: "Cambiales el tamaño",
      resizeBody: "Agrandalo o achicalo desde la esquina de abajo a la derecha. Si lo soltás al lado de otro y no entra, toma el ancho libre.",
      reorderTitle: "Ordenalos",
      reorderBody: "En el teléfono van uno debajo del otro: tocá «Ordenar» para subirlos, bajarlos o quitarlos.",
      menuTitle: "Opciones de cada widget",
      menuBody: "En «⋯»: actualizar, quitar y, en los reportes, verlos como lista, total o gráfico (con eje X y eje Y a elección).",
      presetsTitle: "Guardá tus dashboards",
      presetsBody: "Con «+» guardás cómo lo armaste, con un nombre. Podés tener varios y compartirlos: cada uno queda como un botón acá arriba.",
      endTitle: "¡Eso es todo!",
      endBody: "Este tutorial queda a mano unos días con el botón «Tutorial» de arriba, por si lo querés repasar.",
    },
    note: {
      placeholder: "Escribí algo para acordarte…",
    },
    clientQuestions: {
      pending: "Pendientes",
      answered: "Respondidas",
      new: "Nueva duda",
      reply: "Responder",
      correct: "Corregir respuesta",
      send: "Enviar respuesta",
      save: "Guardar",
      cancel: "Cancelar",
      edit: "Editar",
      delete: "Borrar",
      deleteConfirm: "¿Borrar esta duda?",
      reopen: "Volver a preguntar",
      markRead: "Marcar leída",
      newAnswer: "Respuesta nueva",
      answerPlaceholder: "Escribí tu respuesta…",
      questionPlaceholder: "La pregunta",
      contextPlaceholder: "Contexto: qué vimos, de dónde sale la duda",
      topicPlaceholder: "Tema (opcional)",
      answeredBy: "Respondió {name} · {date}",
      previousAnswers: "Respuestas anteriores ({n})",
      emptyPending: "No hay dudas pendientes. ¡Gracias!",
      emptyAnswered: "Todavía no hay dudas respondidas.",
      thanks: "¡Gracias por responder!",
      saveError: "No se pudo guardar",
      archived: "Archivadas",
      archive: "Archivar",
      unarchive: "Desarchivar",
      archivedBy: "Archivó {name} · {date}",
      emptyArchived: "No hay dudas archivadas.",
    },
  },
  tour: {
    step: "{n} de {total}",
    next: "Siguiente",
    back: "Atrás",
    done: "Listo",
    skip: "Saltar",
    clickToContinue: "Hacé click en lo resaltado para seguir",
  },
  recentActivity: {
    title: "Actividad reciente",
    reload: "Actualizar",
    empty: "Todavía no se movió nada.",
    error: "No se pudo cargar la actividad reciente.",
    createdByAt: "lo creó {who} el {when}",
    createdAt: "se creó el {when}",
    createdBy: "lo creó {who}",
    modifiedByAt: "(última modificación de {who} el {when})",
    modifiedAt: "(última modificación el {when})",
  },
  financialSummary: {
    title: "Panel operativo",
    summaryClientLabel: "Cliente:",
    summaryClientFallback: "Ver contacto",
    openContactNewTab: "Abrir contacto en nueva pestaña",
    loading: "Cargando datos financieros...",
    allGood: "Todos los aspectos financieros están en orden",
    helpTitle: "Entendiendo los Cobros",
    close: "Cerrar",
    pickShippingContainersTitle: "¿Qué contenedores?",
    pickShippingContainersHint:
      "Esta proforma tiene {total} contenedor(es). Elegí qué posición(es) corresponden a este embarque nuevo. Las ya usadas en otros embarques no aparecen.",
    pickShippingContainersNeedOne: "Seleccioná al menos una posición.",
    pickShippingContainersNoneLeft:
      "Todas las posiciones de contenedor de esta proforma ya están vinculadas a otros embarques.",
    pickShippingContainersNoneLeftTitle: "Sin cupos libres",
    pickShippingContainersConfirm: "Continuar",
    pickShippingContainersCancel: "Cancelar",
    totalProform: "Total Proforma",
    totalBilled: "Total Facturado",

    expectedAmount: "Monto Esperado",
    advanceDeducted: "adelanto descontado",
    shippingCollectionsApplied: "cobros aplicados al embarque",
    commercialNotesCreditDeducted: "notas de crédito",
    commercialNotesDebitAdded: "notas de débito",
    collected: "Cobrado",
    pending: "Pendiente",
    pendingAdvance: "Adelanto Pendiente",
    overCollectedWarning: "Cobró de más: {amount}",
    stages: {
      step1Short: "Adelanto (solo proforma)",
      step2Short: "Por embarque",

      stage1AdvanceSummaryLineAfterAmount:
        " de adelanto esperado ({pct}% de esta proforma {total})",
      stage1AssignAdvanceToShippingNamed: "Asignar este adelanto a —> {name}",
      stage1AssignAdvanceToShippingNamedHint:
        "Asignar al adelanto de este embarque (proforma + embarque), no al saldo de factura",
      stage1AssignAdvanceToShippingTitle: "Embarque {n}",

      collectedShort: "Cobrado",
      remainingShort: "Falta",
      overCollectedInvoiceHint:
        "Cobró de más en esta factura: {amount}. Reasigná el excedente arrastrando la pastilla de cobro a otro embarque.",
      overCollectedAdvanceHint:
        "Adelanto cobrado de más: {amount}. Reasigná el excedente a otro embarque o proforma.",
      notaImpactBoxCaption: "Notas comerciales (cliente)",
      notaImpactAdvanceMetaCaption: "Proforma — etapa adelanto",
      notaImpactAdvanceCreditRowTitle: "Notas de crédito (proforma)",
      notaImpactAdvanceDebitRowTitle: "Notas de débito (proforma)",
      notaImpactAdvanceCredit:
        "Crédito en proforma: {amount} — reduce lo pendiente de adelanto.",
      notaImpactAdvanceDebit:
        "Débito en proforma: {amount} — se suma a lo pendiente de cobro (con embarques, en la etapa 2).",
      notaImpactInvoiceCredit:
        "Crédito en factura (este embarque): {amount} — reduce lo pendiente de factura.",
      notaImpactInvoiceCreditRowTitle: "Notas de crédito (factura)",
      notaImpactInvoiceDebit:
        "Débito en factura (este embarque): {amount} — aumenta lo pendiente de factura.",
      notaImpactInvoiceDebitRowTitle: "Notas de débito (factura)",
      notaImpactSupplierPaymentsCredit:
        "Crédito proveedor en este embarque: {amount} — reduce lo a pagar al proveedor.",
      notaImpactSupplierPaymentsCreditRowTitle: "Notas de crédito proveedor (pagos)",
      notaImpactSupplierPaymentsDebit:
        "Débito proveedor en este embarque: {amount} — aumenta lo a pagar al proveedor.",
      notaImpactSupplierPaymentsDebitRowTitle: "Notas de débito proveedor (pagos)",
      notaImpactExpectedNet:
        "Impacto neto de notas sobre el monto esperado: {amount} (NC bajan, ND suben).",

      noAdvancePct: "Sin % de adelanto en esta proforma.",
      advancePctSetButton: "Cargar adelanto",
      advancePctEditHint: "Cambiar el adelanto de esta proforma",
      advanceModalEditTitle: "Cambiar adelanto",
      advanceModalSetTitle: "Cargar adelanto",
      advanceModePct: "Porcentaje",
      advanceModeAmount: "Monto",
      advancePreviewFromPct: "= {amount} de adelanto esperado",
      advancePreviewFromAmount: "= {pct}% de esta proforma",
      advancePayableLabel: "Condición de pago (cliente)",
      advancePayableNone: "— sin condición —",
      advanceValueInvalid: "Ingresá un número mayor a cero.",
      advanceAmountNoTotal: "Esta proforma todavía no tiene total, así que no se puede convertir un monto.",
      advanceAmountOverTotal: "El adelanto no puede superar el total de la proforma ({total}).",
      advancePctPlaceholder: "1–100",
      advancePctSave: "Guardar",
      advancePctSaving: "Guardando…",
      advancePctInvalidTitle: "Porcentaje no válido",
      advancePctInvalid: "Ingresá un número entero entre 1 y 100.",
      advancePctSaved: "Adelanto actualizado",
      advancePctSaveError: "No se pudo guardar el porcentaje de adelanto.",

      stage2ShippingCollectCompleteTitle: "Este embarque ya está al día",
      stage2ShippingCollectCompleteText:
        "Figura como Embarque OK: no queda pendiente de factura y el adelanto asignado cubre lo esperado. No se pueden registrar más cobros desde aquí.",
      noCollectPermissionHint: "No tenés permiso para registrar cobros.",

      shipStage2AdvanceBlockTitle: "Adelanto de proforma",
      shipStage2PaymentsBlockTitle: "Pagos (proveedor y gastos)",
      shipStage2OperationMarginCaption: "Margen operación (cobrado − pagado)",
      shipStage2CompactSummaryExpandHint:
        "Clic para ver cobros y pagos del embarque",
      shipStage2CompactSummaryCollapseHint: "Clic para ocultar el detalle",
      supplierAdvancePctInlineLabel: "Adelanto factura proveedor (%)",
      supplierAdvancePctSave: "Guardar",
      supplierAdvancePctSaving: "Guardando…",
      supplierAdvancePctInvalidTitle: "Porcentaje no válido",
      supplierAdvancePctInvalid: "Ingresá un número entero entre 1 y 100.",
      supplierAdvancePctSaved: "Adelanto proveedor actualizado",
      supplierAdvancePctSaveError:
        "No se pudo guardar el porcentaje de adelanto proveedor.",

      supplierAdvancePctReadOnlyBefore: "Adelanto factura proveedor: ",

      supplierInvoiceAdvanceSummaryLineAfterPct:
        " de la factura proveedor ({total}) → {expected} de adelanto esperado",
      shipPaymentsShipperLine: "Shipper: {name}",
      shipPendingAfterNotesHint: "Lo pendiente ya está neto de las notas comerciales aplicadas acá.",
      shipPaymentsLinkedForExpenseCaption: "Pagos vinculados a este gasto",
      shipPaymentsPillPaidBadge: "Pagado",

      shipPaymentsQuickPayButton: "Pagar",
      shipPaymentsQuickPayHint:
        "Marcar como pagado solo con fecha, cuenta bancaria, comentario y comprobante (monto solo lectura)",
      quickMarkPaymentPaidTitle: "Pago rápido — marcar como pagado",
      quickMarkPaymentPaidHint:
        "El importe del pago y las aplicaciones a gastos no se editan acá. Usá Pagar si necesitás la pantalla completa del pago.",
      quickMarkPaymentPaidAmountLabel: "Importe",
      quickMarkPaymentPaidAmountInvalid: "Ingresá un importe válido mayor a cero.",
      quickMarkPaymentPaidAmountMaxHint: "Tope según el gasto: {max}",
      quickMarkPaymentPaidAmountExceedsExpense:
        "El importe no puede superar el total del gasto ({max}).",
      quickMarkPaymentPaidDateLabel: "Fecha de pago",
      quickMarkPaymentPaidEstimatedDateLabel: "Fecha prevista de pago",
      quickMarkPaymentPaidNeitherDateError: "Indicá la fecha de pago o la fecha prevista.",
      quickMarkPaymentPaidCommentLabel: "Comentario",
      quickMarkPaymentPaidCommentPlaceholder: "Opcional",
      quickMarkPaymentPaidReceiptLabel: "Comprobante de pago",
      quickMarkPaymentPaidReceiptHint: "Imágenes, PDF o Word. Máx. 10 MB.",
      quickMarkPaymentPaidSave: "Guardar y marcar pagado",
      quickMarkPaymentPaidDateRequired: "La fecha de pago es obligatoria.",
      quickMarkPaymentPaidBankRequired: "La cuenta bancaria es obligatoria.",
      quickMarkPaymentPaidValidationTitle: "Revisá el formulario",
      quickMarkPaymentPaidFileTooBig: "El archivo debe pesar menos de 10 MB.",
      quickMarkPaymentPaidFileType:
        "Tipo de archivo no admitido. Usá imágenes, PDF o Word.",
      quickMarkPaymentPaidFileError: "No se pudo subir el archivo.",
      quickMarkPaymentPaidSuccessTitle: "Pago actualizado",
      quickMarkPaymentPaidSuccessText: "Guardado y marcado como pagado.",
      quickMarkPaymentPaidSuccessEstimated: "Guardado con fecha prevista de pago.",
      quickMarkPaymentPaidSaveError: "No se pudo guardar el pago.",
      quickMarkPaymentPaidDeleteConfirmTitle: "¿Eliminar pago?",
      quickMarkPaymentPaidDeleteConfirmText:
        "Este pago se eliminará de forma permanente de la operación.",
      quickMarkPaymentPaidDeleteLoadingTitle: "Eliminando el pago...",
      quickMarkPaymentPaidDeleteSuccessTitle: "Pago eliminado",
      quickMarkPaymentPaidDeleteError: "No se pudo eliminar el pago.",
      quickMarkPaymentPaidDeleteConfirmPaidText:
        "Este pago ya fue marcado como pagado. ¿Seguro que querés eliminarlo de forma permanente de la operación?",
      shipPaymentsDeletePaymentHint: "Eliminar pago",
      shipStage2CollectionsBlockTitle: "Cobros (cliente)",
      shipPaymentsTotalCosts: "Total costos",
      shipPaymentsEditShipperPricesButton: "Cargar precios shipper",
      shipPaymentsEditShipperPricesTitle:
        "Precios unitarios shipper (embarque)",
      shipPaymentsEditShipperPricesHint:
        "Ingresá el precio unitario de cada línea en «producto / precio shipper». Al guardar se actualiza el embarque y se recalculan totales proveedor. La columna de venta sale de «producto / precio» (factura al cliente) para comparar con el costo shipper.",
      shipPaymentsEditShipperPricesProduct: "Producto",
      shipPaymentsEditShipperPricesQty: "Cant.",
      shipPaymentsEditShipperPricesInvoiceUnitPrice:
        "Precio unit. venta (factura)",
      shipPaymentsEditShipperPricesUnitPrice: "Precio unit. shipper",
      shipPaymentsEditShipperPricesEmpty:
        "Este embarque no tiene líneas en producto/precio shipper. Agregalas en el embarque y después podés cargar precios acá.",
      shipPaymentsEditShipperPricesLoadError: "No se pudo cargar el embarque.",
      shipPaymentsEditShipperPricesSave: "Guardar en embarque",
      shipPaymentsEditShipperPricesSaved: "Embarque actualizado",
      shipPaymentsEditShipperPricesSaveError:
        "No se pudo guardar. Revisá los importes e intentá de nuevo.",
      shipPaymentsEditShipperPricesInvalidNumber:
        "Ingresá un número válido en cada precio unitario (o vacío para limpiar).",
      shipPaymentsEditShipperPricesInvalidTitle: "Revisá los precios",
      shipPaymentsEditShipperInvoiceQtyButton: "Cargar cantidades factura proveedor",
      shipPaymentsEditShipperInvoiceQtyTitle:
        "Cantidades factura proveedor (producto / precio shipper)",
      shipPaymentsEditShipperInvoiceQtyHint:
        "Ingresá la cantidad o el peso neto y el precio unitario shipper de cada línea en «producto / precio shipper» de este embarque. La primera columna de referencia muestra la cantidad de la factura cliente; la siguiente el precio unitario de venta del bloque factura cliente cuando existe. Al guardar se actualiza el embarque y se recalculan totales proveedor.",
      shipPaymentsEditShipperInvoiceQtyClientRef: "Cantidad o peso neto (factura cliente)",
      shipPaymentsEditShipperInvoiceQtySupplierCol: "Cantidad o peso neto (proveedor)",
      shipPaymentsEditShipperInvoiceQtyEmpty:
        "Este embarque no tiene líneas en producto/precio shipper. Agregalas en el embarque y después podés cargar cantidades acá.",
      shipPaymentsEditShipperInvoiceQtyLoadError: "No se pudo cargar el embarque.",
      shipPaymentsEditShipperInvoiceQtySave: "Guardar en embarque",
      shipPaymentsEditShipperInvoiceQtySaved: "Embarque actualizado",
      shipPaymentsEditShipperInvoiceQtySaveError:
        "No se pudo guardar. Revisá las cantidades y los precios unitarios e intentá de nuevo.",
      shipPaymentsEditShipperInvoiceQtyInvalidNumber:
        "Ingresá un número válido en cada cantidad (o vacío para limpiar).",
      shipPaymentsEditShipperInvoiceQtyInvalidTitle: "Revisá las cantidades",
      shipCollectionsEditInvoiceUnitQtyButton: "Cargar cantidades factura",
      shipCollectionsEditInvoiceUnitQtyTitle:
        "Cantidades factura cliente (producto / precio)",
      shipCollectionsEditInvoiceUnitQtyHint:
        "Ingresá la cantidad o el peso neto de cada línea en «producto / precio» (factura al cliente). Al guardar se actualiza el embarque y se recalcula el total factura. La columna de referencia muestra el mismo dato en la proforma vinculada para el producto que coincida.",
      shipCollectionsEditInvoiceUnitQtyProduct: "Producto",
      shipCollectionsEditInvoiceUnitQtyProformaQty: "Cantidad o peso neto (proforma)",
      shipCollectionsEditInvoiceUnitQtyLabel: "Cantidad o peso neto (factura)",
      shipCollectionsEditInvoiceUnitQtyEmpty:
        "Este embarque no tiene líneas en producto/precio. Agregalas en el embarque y después podés cargar cantidades acá.",
      shipCollectionsEditInvoiceUnitQtyLoadError: "No se pudo cargar el embarque.",
      shipCollectionsEditInvoiceUnitQtySave: "Guardar en embarque",
      shipCollectionsEditInvoiceUnitQtySaved: "Embarque actualizado",
      shipCollectionsEditInvoiceUnitQtySaveError:
        "No se pudo guardar. Revisá las cantidades e intentá de nuevo.",
      shipCollectionsEditInvoiceUnitQtyInvalidNumber:
        "Ingresá un número válido en cada cantidad (o vacío para limpiar).",
      shipCollectionsEditInvoiceUnitQtyInvalidTitle: "Revisá las cantidades",
      shipTimelineProformSupplier: "Proform supplier",
      shipTimelineClientInvoice: "Client invoice",
      shipTimelineInvoice: "Invoice",
      shipTimelinePackingList: "Packing list",
      shipTimelineInvoiceSupplier: "Invoice supplier",
      shipCollectionsAutoloadPackingListTitle: "Lista de empaque desde cantidades factura",
      shipCollectionsAutoloadPackingListHint:
        "Editá los campos de cada línea de producto en la lista de empaque y guardá para actualizar el embarque.",
      shipCollectionsAutoloadPackingListColLine: "Línea",
      shipCollectionsAutoloadPackingListColQuantity: "Quantity or Cartoons",
      shipCollectionsAutoloadPackingListColNetweight: "Peso neto",
      shipCollectionsAutoloadPackingListSaved: "Lista de empaque guardada",
      shipCollectionsAutoloadPackingListLoadError:
        "No se pudo cargar el embarque o armar la lista de empaque. Revisá producto/precio en el embarque e intentá de nuevo.",
      shipCollectionsAutoloadPackingListSaveError:
        "No se pudo guardar la lista de empaque. Revisá los campos e intentá de nuevo.",
      shipCollectionsAutoloadPackingListEmpty:
        "No se generaron líneas de empaque (faltan bloques «producto / precio» o la precarga devolvió vacío).",
      shipPaymentsAutoloadExpensesButton: "Autoload gastos",
      shipPaymentsAutoloadExpensesTitle: "Autoload de gastos del embarque",
      shipPaymentsAutoloadExpensesHint:
        "Estas líneas se generan igual que el «Autoload expenses» del embarque. Poné el importe en cada gasto que quieras crear, quitá los que todavía no correspondan (por ejemplo si no sabés el flete), y guardá.",
      shipPaymentsAutoloadExpensesType: "Tipo",
      shipPaymentsAutoloadExpensesAmount: "Importe",
      shipPaymentsAutoloadExpensesContact: "Contacto",
      shipPaymentsAutoloadExpensesNewBadge: "Nuevo",
      shipPaymentsAutoloadExpensesRemove: "Quitar esta línea",
      shipPaymentsAutoloadExpensesSave: "Guardar en embarque",
      shipPaymentsAutoloadExpensesSaved: "Gastos del embarque actualizados",
      shipPaymentsAutoloadExpensesLoadError:
        "No se pudieron cargar o precargar los gastos de este embarque.",
      shipPaymentsAutoloadExpensesSaveError:
        "No se pudieron guardar los gastos. Revisá los importes e intentá de nuevo.",
      shipPaymentsAutoloadExpensesEmpty:
        "No hay líneas nuevas para sugerir: ya existen todos los tipos de autoload en este embarque, o faltan totales/campos necesarios para el autoload.",
      shipPaymentsAutoloadExpensesInvalidNumber:
        "Ingresá un importe válido en cada línea que dejés (o vaciá el importe y quitá la fila).",
      shipPaymentsAutoloadExpensesInvalidTitle: "Revisá los importes",
      shipPaymentsAutoloadExpensesAddLine: "Agregar línea de gasto",
      shipPaymentsAutoloadExpensesPickType: "Elegí tipo…",
      shipPaymentsAutoloadExpensesMissingType:
        "Elegí el tipo de gasto en cada línea nueva que tenga importe.",
      shipPaymentsExpensesCaption: "Gastos (proveedor y otros)",
      shipPaymentsExpenseSupplierInvoice: "Factura proveedor",
      shipPaymentsExpenseSupplierInvoiceSplit: "Factura proveedor (dividida)",
      shipPaymentsSupplierExpenseTrashHint:
        "Esta factura proveedor está en la papelera (eliminación lógica). Restaurala para pedir pagos.",
      shipPaymentsSupplierExpenseInTrashLabel: "En papelera",
      shipPaymentsViewShippingExpense: "Ver gasto del embarque",
      shipPaymentsExpenseDueShort: "Debe",
      shipPaymentsExpensePaidRowShort: "Pag. / ped.",

      shipPaymentsExpensePendingShort: "Pendiente",
      shipPaymentsExpenseCoveredAwaitingBankHint:
        "Cubierto por solicitud: usá Pagar en el pago vinculado (rojo). No hace falta Pedir pago otra vez.",
      /** Mismo pago aplicado más de una vez al gasto: el número de arriba queda inflado. */
      shipPaymentsExpenseDuplicatedAppliedHint:
        "Dato repetido: «Pag. / ped.» está contando {amount} dos veces. El mismo pago quedó vinculado más de una vez a este gasto (marcado ×2 abajo). Abrí ese pago y borrá la línea repetida de «Applied to».",
      shipPaymentsPillDuplicatedBadgeHint:
        "Este pago está vinculado {times} veces al gasto. Abrilo y borrá la línea repetida de «Applied to».",
      shipPaymentsRequestPaymentButton: "Pedir pago",
      shipPaymentsPayNowButton: "Pagar",
      shipPaymentsDividePaymentButton: "Dividir pago",
      editShippingExpense: "Editar gasto del embarque",
      editShippingExpenseModalTitle: "Gasto del embarque",
      editShippingExpenseAmountLockedHint:
        "El monto no puede ser menor al total ya aplicado en pagos vinculados.",
      editShippingExpenseAmountFollowsPaymentHint:
        "El pago automático de este gasto se actualiza al nuevo importe.",
      editShippingExpenseDeleteBlockedHint:
        "No se puede borrar este gasto mientras tenga pagos vinculados.",
      editShippingExpenseLoadError: "No se pudo cargar el gasto.",
      editShippingExpenseInvalidAmount: "Ingresá un importe válido (0 o mayor).",
      shipPaymentsProgressCaption: "Pagado y pedido / total",
      shipPaymentsProgressAriaGroup:
        "Progreso de pagos: pagado vs solicitado pendiente",
      shipPaymentsProgressLegendPaid: "Pagado (marcado como pagado)",
      shipPaymentsProgressLegendRequested: "Solicitado (aún no pagado)",

      shipPaymentsNoBalance:
        "Aún no hay fila de balance para este embarque — actualizá el resumen financiero o abrí el registro del embarque.",
      shipAdvanceMetaCaption: "Meta (este embarque)",
      shipAdvanceAssignedLabel: "Asignado en cobros (proforma + embarque)",
      shipStage2InvoiceBlockTitle: "Factura de embarque",
      shipInvoiceMetaCaption: "Saldo (esta factura)",
      shipInvoiceTotalExpected: "{amount} — total factura (este embarque)",
      shipInvoiceNotesCreditLine: "− {amount} en notas de crédito",
      shipInvoiceNotesDebitLine: "+ {amount} en notas de débito",
      shipProformNotesCreditLine: "− {amount} en notas de crédito de la proforma",
      shipProformNotesDebitLine: "+ {amount} en notas de débito de la proforma",
      shipInvoiceNetToCollect: "{amount} a cobrar",
      shipInvoiceDueNetHint:
        "Total de factura {total}, ajustado por las notas comerciales aplicadas a este embarque.",
      shipInvoiceCollectedCaption: "Cobrado (solo factura embarque)",

      shipExpectedAdvanceAfterPct:
        " de adelanto en la proforma · por contenedores le tocan {amount} a este embarque",

      noShippingsYet: "Sin embarques — la etapa 2 listará cada uno aquí.",
      noShippingsYetZeroProformContainers:
        "Esta proforma no tiene cantidad total de contenedores (o es cero). Definila en la proforma primero; después aparecerán aquí Agregar embarque y Embarque rápido cuando haya cupo por asignar.",
      missingShippingPlaceholderTitle:
        "Contenedores sin asignar del todo a embarques",
      missingShippingPlaceholderBody:
        "Faltan asignar {remaining} contenedor(es) a un embarque.\nAgregá un embarque o cambiá las cantidades hasta que cierren.",
      missingShippingContainersCaption:
        "{shipped} de {total} contenedores en embarques",
      addShippingButton: "Agregar embarque",
      openCollectNewTab: "Ver cobro en nueva pestaña",
      openShippingNewTab: "Abrir embarque en nueva pestaña",
      openNotaComercialNewTab: "Ver nota comercial en nueva pestaña",
      quickEditCollectTitle: "Editar cobro",
      quickEditCollectHint: "Ajustá el importe de esta aplicación, fecha, recibido, cuenta bancaria, comentario o comprobante.",
      quickEditCollectLineAmountLabel: "Importe (esta aplicación)",
      quickEditCollectDateLabel: "Fecha de cobro",
      quickEditCollectBankPlaceholder: "—",
      quickEditCollectLoadFailed: "No se pudo cargar el cobro.",
      quickEditCollectDeleteConfirmTitle: "¿Eliminar este cobro?",
      quickEditCollectDeleteConfirmText:
        "El cobro se eliminará de forma permanente y se desvinculará de esta proforma/embarque.",
      quickEditCollectDeleteSuccessTitle: "Cobro eliminado",
      quickEditCollectDeleteSuccessText: "El cobro fue eliminado.",
      quickEditCollectDeleteBlockedTitle: "No se puede eliminar",
      quickEditCollectDeleteBlockedText: "Marcá el cobro como no recibido primero, o eliminá desde la pantalla completa del cobro.",
      quickEditCollectSaveSuccessTitle: "Cobro actualizado",
      quickEditCollectSaveSuccessText: "Los cambios se guardaron.",
      stage2AddCollectAdvanceHint:
        "Registrar cobro de adelanto en este embarque",
      stage2AddCollectInvoiceHint:
        "Registrar cobro de factura embarque (directo)",
      stage2AdvanceCollectBlockedTitle: "Adelanto de proforma ya cubierto",
      stage2AdvanceCollectBlocked:
        "No queda adelanto pendiente en la proforma para asignar con un cobro nuevo. Para pasar montos a este embarque, arrastrá una pastilla de cobro de la etapa 1 sobre esta tarjeta (drag and drop).",
      stage2ShippingAdvanceAlreadyCollectedTitle:
        "Adelanto de este embarque ya cobrado",
      stage2ShippingAdvanceAlreadyCollectedText:
        "El adelanto esperado para esta factura de embarque ya está asignado en cobros (proforma + embarque). No queda importe pendiente para registrar otro cobro de adelanto aquí.",
      stage2InvoiceNeedsAdvanceTitle:
        "Primero asigná el adelanto en este embarque",
      stage2InvoiceNeedsAdvanceText:
        "Para registrar un cobro de factura embarque (directo), antes tiene que estar asignado en esta tarjeta el adelanto esperado (Advance on this shipping). Esperado {expected}, asignado hasta ahora {assigned}. Usá el + en esa parte o arrastrá desde la etapa 1.",
      stage2InvoiceTotalMissingTitle: "Falta el total de la factura de embarque",
      stage2InvoiceTotalMissingText:
        "Cargá la información de la factura de embarque para poder calcular el total.",
      shipPaymentsSupplierInvoiceTotalMissingText:
        "Cargá la información de la factura proveedor para poder calcular el total.",
      dragChipsHint:
        "Cobros en proforma — arrastrá a un embarque para asignar parte del adelanto",
      stage1AllocatedAdvanceCaption:
        "Cobros de este adelanto, ya asignados a un embarque (se mueven desde la etapa 2)",
      stage1AllocatedAdvanceShipHint: "Asignado al embarque {name}",
      sendRowToProformHint: "Enviar este cobro a la proforma (etapa 1)",
      sendRowToProformAlreadyTitle: "Ya forma parte de la proforma",
      sendRowToProformAlreadyText:
        "Este cobro está aplicado a la proforma y a este embarque: ya cuenta dentro del adelanto de la etapa 1. Si querés sacarlo del embarque, arrastralo a la zona «Soltá aquí para volver el adelanto asignado solo a proforma» de la etapa 1.",
      shipInvoiceProductsHint: "Productos de la factura de este embarque",
      shipPortOfLoading: "Puerto de carga",
      shipPortOfDischarge: "Puerto de destino",
      containerMismatchTitle: "Contenedores inconsistentes",
      containerMismatchBody:
        "La proforma dice {proform} contenedor(es) y sus embarques suman {sum}. El adelanto esperado de cada embarque se reparte por contenedores, así que esto descuadra toda la operación.",
      containerMismatchDetailCaption: "Contenedores por embarque",
      containerMismatchFixNote:
        "«Corregir» pone {sum} en la cantidad de contenedores de la proforma. Los embarques no se tocan.",
      containerMismatchFix: "Corregir",
      containerMismatchLater: "Después",
      containerMismatchFixedTitle: "Proforma actualizada",
      containerMismatchFixedText: "La proforma quedó en {sum} contenedor(es).",
      containerMismatchFixError: "No se pudo guardar la cantidad de contenedores de la proforma.",
      advanceShortMoneyOnInvoicesTitle: "La plata ya está cobrada",
      advanceShortMoneyOnInvoicesBody:
        "Faltan {missing} de adelanto, pero esta operación ya tiene {onInvoices} cobrados contra la factura de los embarques. Es la misma plata, aplicada a la factura en lugar del adelanto: no hay nada que cobrar de nuevo ni ningún cobro que borrar.",
      reorderCollects: "Reordenar cobros",
      reorderCollectsHint:
        "Pasa esa plata al adelanto de los embarques que todavía tienen cupo. No borra ningún cobro ni cambia importes.",
      moveInvoiceMoneyToAdvanceTitle: "Reordenar cobros",
      moveInvoiceMoneyToAdvanceIntro:
        "Se mueven {total} de la factura de los embarques al adelanto. No se borra ningún cobro ni cambia ningún importe: solo cambia a qué se aplica cada uno:",
      moveInvoiceMoneyToAdvanceConfirm: "Reordenar",
      moveInvoiceMoneyToAdvanceOk: "Se pasaron {amount} al adelanto.",
      dropReturnProform:
        "Soltá aquí para volver el adelanto asignado solo a proforma",
      proformPocket: "Proforma (etapa 1)",
      redistributeTitle: "Redistribuir monto",
      redistributeNoRoomOnShip:
        "No queda cupo para asignar más adelanto en este embarque respecto del objetivo (expected).",
      redistributeNoRoomOnShipInvoice:
        "En la zona de factura de embarque no queda cupo según el pendiente de factura (y el adelanto disponible). Soltá sobre el bloque de adelanto si solo querés la meta de adelanto.",
      redistributeToShipHtml:
        "Mover a <strong>{ship}</strong>. Máximo <strong>{max}</strong>.",
      redistributeToShipInvoiceOnlyHtml:
        "Asignar a <strong>{ship}</strong> como cobro <strong>solo factura de embarque</strong> (sin ligar proforma en la línea). Pendiente de factura: {pending}. Máximo a mover: <strong>{max}</strong>.",
      redistributeToProformHtml:
        "Volver al saldo solo-proforma. Máximo <strong>{max}</strong>.",
      redistributeReturnToProformBlockedAdvanceComplete:
        "El adelanto de etapa 1 ya está cobrado por completo en esta proforma. No podés volver asignación al bolsillo solo-proforma.",
      redistributeNoRoomNoChange:
        "No hay cupo en el bolsillo solo-proforma; el cobro sigue en la línea de embarque (sin cambios).",
      redistributeNoRoomReasonNoAdvanceExpected:
        "Esta proforma no tiene adelanto esperado en etapa 1; no se puede mover al bolsillo solo-proforma.",
      redistributeNoRoomReasonPocketFull:
        "El bolsillo solo-proforma ya está completo respecto del adelanto esperado; no se puede mover más desde el embarque.",
      redistributeNoRoomReasonStage1Cap:
        "El adelanto de etapa 1 ya está cobrado por completo; este cobro solo-embarque no puede pasarse al bolsillo de proforma.",
      redistributeToProformRemainderNote:
        "Si la línea es mayor, solo esta parte entra al bolsillo proforma; el resto queda en el embarque.",
      redistributeCappedToProformaPocketToast:
        "Se aplicó solo la parte que cabe en el bolsillo solo-proforma: {moved}. El resto sigue en la línea de embarque.",
      observationsTitle: "Observaciones",
      observationsPlaceholder: "Notas de la operación (se guardan solas)",
      observationsSaving: "guardando…",
      observationsSaved: "guardado",
      observationsError: "no se pudo guardar",
      containerNumbersHint: "Números de contenedor cargados en la lista de empaque del embarque.",
      flagsTitle: "Flags de la operación",
      flagsPlaceholder: "Agregar flags…",
      flagsTagPlaceholder: "Enter para crear este flag",
      flagsNoOptions: "Todavía no hay flags en el catálogo",
      flagsSaving: "guardando…",
      flagsCreateOption: "Agregar flag nuevo…",
      flagsManageLists: "Configurar listados",
      flagsManageListsHint:
        "Abre la pantalla de listados para renombrar un flag, cambiarle el color o borrarlo.",
      flagColorTitle: "Color de «{name}»",
      flagColorHint:
        "El color es de la bandera: cambia en todas las pantallas donde se muestra.",
      flagColorApply: "Aplicar color",
      flagColorHintOnBadge: "Hacé clic en la bandera para cambiarle el color",
      flagCreateTitle: "Flag nuevo",
      flagCreateNameLabel: "Nombre del flag",
      flagCreateApply: "Crear flag",
      flagCreateNameRequired: "Escribí un nombre para el flag",
      flagCreateNameExists: "Ya hay un flag con ese nombre",
      flagsHint:
        "Etiquetá esta operación con un flag del catálogo (los mismos de la columna de banderas del listado) o creá uno nuevo.",
      flagNone: "Sin flag asignado",
      flagAssign: "Asignar flag",
      flagChange: "Cambiar flag",
      redistributeSplitHint:
        "El cobro ({total}) supera el adelanto pendiente de {ship} ({advanceMax}). Podés asignar el excedente al saldo de factura de ese embarque (pendiente {pending}).",
      redistributeSplitUnappliedNote:
        "Incluye {amount} de este cobro que todavía no estaba aplicado a nada.",
      redistributeSplitAdvanceLabel: "Al adelanto del embarque (máx. {max})",
      redistributeSplitAdvanceFull:
        "El adelanto de este embarque ya está completo: el monto va todo al saldo de factura.",
      redistributeSplitRemainderCheckbox:
        "Asignar el excedente al saldo de factura de {ship}",
      redistributeSplitRemainderLabel: "Excedente al saldo (máx. {max})",
      redistributeSplitRemainderTooMuch: "El excedente no puede superar {max}",
      redistributeSplitOk:
        "Asignación actualizada: {advance} al adelanto y {remainder} al saldo del embarque.",
      redistributeConfirm: "Aplicar",
      redistributeInvalid: "Ingresá un importe válido",
      redistributeTooMuch: "No puede superar {max}",
      redistributeOk: "Asignación actualizada",
      redistributeError: "No se pudo actualizar la asignación",
      quickCollectRemaining: "Cobro rápido",
      quickCollectRemainingHint:
        "Abre el alta de cobro con atajos opcionales por contenedor (etapa 1). «Agregar cobro» usa solo el formulario compacto, sin esa ayuda.",
    },
    messages: {
      noPaymentCondition:
        "⚠️ <strong>Sin condición de pago configurada.</strong> Esta proforma no tiene un porcentaje de adelanto establecido.",
      noPaymentConditionDetails:
        "Configura una condición de pago para hacer seguimiento correcto de los adelantos.",
      missingCurrencyRate:
        "Esta operación tiene importes en más de una moneda y falta la cotización de {currency}. Hasta que se cargue en Ajustes, el margen queda vacío: no se pueden comparar importes de monedas distintas.",
      advancePending:
        "💰 <strong>Adelanto pendiente:</strong> Se debe cobrar el {percentage}% de adelanto ({amount}).",
      advancePendingDetails:
        "No se han registrado cobros aún para esta proforma.",
      advancePartial:
        "⏳ <strong>Adelanto parcial cobrado:</strong> {collected} de {expected} ({percentage}% completado). <strong>Faltan {remaining}.</strong>",
      advancePartialDetails: "{count} cobro(s) registrado(s).",
      advanceComplete:
        "✅ <strong>Adelanto completamente cobrado:</strong> El adelanto previsto era el <strong>{percentage}%</strong> del total de la proforma (meta <strong>{expected}</strong>); consta <strong>{amount}</strong> en cobros.",
      advanceCompleteDetails: "{count} cobro(s) registrado(s).",
      shippingInvoicesPendingAfterAdvance:
        "📄 <strong>Facturas de embarque:</strong> queda por cobrar {total} en {count} embarque(s) (tras la parte de adelanto de proforma y notas de crédito aplicables).",
      hasShippings:
        "🚢 <strong>Esta proforma tiene {count} embarque(s).</strong>",
      hasShippingsDetails:
        "El adelanto ({advancePerShipping} por embarque) se descontará al cobrar cada embarque.",
      readyForShipping:
        "📦 <strong>Lista para embarcar:</strong> El adelanto ha sido cobrado.",
      readyForShippingDetails: "Ya puedes crear embarques para esta proforma.",
    },
    actions: {
      configure: "Configurar",
      addCollection: "Agregar Cobro",
      addCommercialNote: "Agregar nota comercial",
      notaComercialNoPendingTitle: "No se puede agregar la nota comercial",
      notaComercialNoPendingText:
        "No queda monto pendiente por cobrar en esta operación. La nota comercial se usa para ajustar lo que aún está por cobrar; si ya está todo cobrado, no se puede agregar desde aquí.",

      receivePayment: "Agregar Cobro",

      addShippingShipper: "Embarque rápido",
    },
    // Modal messages
    collectionCreatedSuccessfully: "Cobro creado exitosamente",
    failedToOpenCollectionModal: "Error al abrir el modal de cobro",
    failedToOpenAddShippingModal: "No se pudo abrir el alta de embarque.",
    shippingCreatedFromProformOk: "Embarque registrado. Actualizando datos…",
    failedToSaveShipping: "No se pudo guardar el embarque.",
    quickAddShippingShipperTitle: "Nuevo embarque — shipper y contenedores",
    quickAddShippingShipperHint:
      "Se crea un embarque vinculado a esta proforma. El resto se precarga por mapeo y valores por defecto; acá definís el shipper y la cantidad de contenedores (solo la cantidad). Las posiciones para «Contenedores involucrados» (ej. 1,2) se asignan a los próximos cupos libres de la proforma, no se deducen de la cantidad como 1…N. Si aparecen líneas de factura, la suma de contenedores por línea debe coincidir con ese total (o usá «Igualar al embarque»).",
    quickAddShippingShipperFieldLabel: "Shipper",
    quickAddShippingQtyContainersLabel: "Cantidad de contenedores",
    quickAddShippingContainersFieldLabel: "Contenedores involucrados (posiciones)",
    quickAddShippingContainersCsvInvalidTitle: "Posiciones de contenedores inválidas",
    quickAddShippingContainersCsvInvalidText:
      "Usá números de cupo libres en esta proforma (1–{total}), separados por coma, sin repetir. La cantidad debe coincidir con la cantidad de contenedores ({qty}).",
    quickAddShippingQtyContainersInvalidTitle:
      "Cantidad de contenedores no válida",
    quickAddShippingQtyContainersInvalidText:
      "Ingresá un número entero de contenedores (1 o más).",
    quickAddShippingContainersNotEnoughTitle:
      "No hay cupos libres de contenedor",
    quickAddShippingContainersNotEnoughText:
      "Este embarque necesita {needed} posición(es) de contenedor en la proforma, pero solo quedan {free} libres (de {total} en total). Aumentá contenedores en la proforma o ajustá otros embarques.",
    quickAddShippingInvoiceLinesTitle:
      "Líneas de factura (contenedores por línea)",
    quickAddShippingInvoiceLinesHint:
      "La suma de contenedores de cada línea debe coincidir con la cantidad de contenedores del embarque indicada arriba. Ajustá manualmente o usá «Igualar al embarque».",
    quickAddShippingInvoiceLineQtyLabel: "Cant.",
    quickAddShippingInvoiceLinesAutoSplit: "Igualar al embarque",
    quickAddShippingInvoiceLinesSum: "Suma en líneas: {sum} — embarque: {ship}",
    quickAddShippingInvoiceLinesMismatch:
      "Los totales deben coincidir para guardar.",
    quickAddShippingInvoiceLinesInvalidTitle: "Líneas de factura vs embarque",
    quickAddShippingInvoiceLinesInvalidText:
      "La suma de contenedores en las líneas ({sum}) debe ser igual a la cantidad del embarque ({ship}).",
    quickAddShippingInvoiceLineDefault: "Línea {n}",

    quickAddShippingInvoiceLineProductsCount: "{count} productos en esta línea",
    quickAddGenericRequiredTitle: "Campo obligatorio",
    quickAddGenericRequiredText:
      "Completá el campo obligatorio antes de guardar.",
    quickAddCollectTitle: "Registrar cobro",
    quickAddCollectHint:
      "El monto, aplicaciones y demás datos se toman del contexto (proforma/embarque). Solo indicá cuenta destino, comentario y archivo si aplica.",
    quickAddCollectHintEditable:
      "Indicá el monto a cobrar, la cuenta bancaria destino y, si querés, comentario o archivo. Si el monto supera el pendiente, el excedente queda sin aplicar, a favor del contacto.",
    quickAddCollectAmountLabel: "Monto a cobrar",
    quickAddCollectAmountInvalidTitle: "Monto no válido",
    quickAddCollectAmountInvalidText: "Ingresá un importe mayor a 0.",
    quickAddCollectAmountTooMuchTitle: "El monto supera el pendiente",
    quickAddCollectAmountTooMuchText:
      "El cobro ({amount}) supera el pendiente cobrable ({max}). Si guardás igual, se aplica hasta cubrir el pendiente y {excess} queda sin aplicar, como saldo a favor del contacto.",
    quickAddCollectAmountTooMuchMultipleShipsText:
      "No puede superar el adelanto pendiente en etapa 1 ({max}). Con más de un embarque, asigná el resto en etapa 2.",
    quickAddCollectAmountTooMuchCombinedText:
      "No puede superar {max} (adelanto etapa 1, adelanto en embarque y saldo de factura en {ship}).",
    quickAddCollectUnallocatedRemainder:
      "{amount} de este cobro no se aplicó a esta proforma (queda disponible para otras proformas o embarques).",
    quickAddCollectUnallocatedToContact:
      "{amount} de este cobro quedó sin aplicar, como saldo a favor del contacto.",
    quickAddCollectMissingFields:
      "No se pudieron cargar los campos del cobro. Probá de nuevo o usá el formulario completo desde el modelo.",
    quickAddCollectBankAccountLabel: "Cuenta bancaria ({tenant})",
    quickAddCollectBankRequiredTitle: "Falta la cuenta bancaria",
    quickAddCollectBankRequiredText:
      "Seleccioná la cuenta bancaria destino para este cobro.",
    quickAddCollectFileRequiredDuntowerTitle: "Falta el archivo del cobro",
    quickAddCollectFileRequiredDuntowerText:
      "Debés cargar el archivo del cobro antes de guardar.",
    quickAddCollectFileRequiredDuntowerSaveAnyway: "Guardar de todos modos",
    quickAddCollectAppliedtoRounding: "Redondeo (línea aplicada)",
    quickAddCollectAppliedtoCommission: "Comisión bancaria (línea aplicada)",
    quickAddCollectAmountPlusRoundingTotal: "Total (monto + redondeo)",
    quickAddCollectSave: "Guardar",

    quickAddCollectInfoTitle: "Información",
    quickAddCollectUnderstood: "Entendido",
    quickAddCollectHintWithCalc:
      "Indicá contenedores por línea: el monto se actualiza solo. Después elegí cuenta y guardá.",
    quickAddCollectCalcCompactTitle: "Contenedores",

    quickAddCollectCalcBadgePerC: "Por ct.",
    quickAddCollectCalcBadgeLine: "Total línea",
    quickAddCollectCalcModePerCTooltip:
      "Precio por contenedor: total de línea = precio unitario × cantidad de contenedores de la línea.",
    quickAddCollectCalcModeLineTooltip:
      "Precio para toda la línea: cada contenedor = total de línea ÷ cantidad de contenedores.",
    quickAddCollectCalcLineSub: "{each}/ctn · máx. {max}",
    quickAddCollectCalcCapShort:
      "Si hace falta, se limita al pendiente ({max}).",
    quickAddCollectCalcCapHintAdvancePct:
      "Monto del cobro = {pct}% de la subtotal facturada de los contenedores elegidos. No puede superar el importe pendiente cobrable ({max}).",
    quickAddCollectCalcCappedByBalance:
      "La suma por líneas elegidas es {selected}, por encima del pendiente; el monto del cobro queda en {cap}.",
    quickAddCollectCalcCappedAdvancePool:
      "El adelanto al {pct}% sobre {invoice} da {advance}, que supera el pendiente; el cobro queda limitado a {cap}.",
    quickAddCollectCalcAdvanceBreakdown:
      "{pct}% × subtotal facturada {invoice} = {amount}.",
    quickAddCollectCalcNoPicksUsesPending:
      "Sin contenedores elegidos — el monto es el pendiente total. Elegí por línea para alinear el cobro con la factura.",
    quickAddCollectCalcNoPicksUsesPendingAdvance:
      "Sin contenedores — el monto es el adelanto pendiente completo. Al elegir líneas, el monto pasa a ser el {pct}% de esa subtotal (sin superar lo que queda).",
    failedToSaveCollection: "Error al guardar el cobro",
    quickRequestPaymentTitle: "Solicitar pago (gasto)",
    quickPayExpenseTitle: "Pagar gasto",
    quickPaymentAppliedToTitle: "Se aplica a",
    quickPaymentAppliedToUnnamed: "Gasto",
    quickPayExpenseAmountLabel: "Monto a pagar",
    quickPayExpenseHint:
      "El pago se guarda ya como pagado: no hay que confirmarlo después.",
    quickPayExpenseSave: "Pagar",
    quickPayExpenseSuccess: "Pago registrado",
    quickPayExpenseDateRequiredTitle: "Falta la fecha de pago",
    quickPayExpenseDateRequiredText: "Poné la fecha en que se pagó el gasto.",
    quickRequestPaymentHint:
      "Se crea el pago solo para este gasto. El monto aplicado (payment_appliedto) sigue el importe que indiques. Elegí la cuenta bancaria y, si querés, un comentario.",
    quickRequestPaymentAmountLabel: "Monto a solicitar",
    quickRequestPaymentBankLabel: "Cuenta bancaria (origen)",
    quickRequestPaymentCommentLabel: "Comentario",
    quickRequestPaymentBankRequiredTitle: "Falta la cuenta bancaria",
    quickRequestPaymentBankRequiredText:
      "Seleccioná la cuenta bancaria para este pedido de pago.",
    quickRequestPaymentSave: "Guardar",
    quickRequestPaymentMissingFields:
      "No se pudieron cargar los campos del pago. Probá de nuevo o usá el formulario completo.",
    quickRequestPaymentOpenFailed:
      "No se pudo abrir el formulario rápido de pago.",
    quickRequestPaymentAmountInvalidTitle: "Monto no válido",
    quickRequestPaymentAmountInvalidText: "Ingresá un importe mayor a 0.",
    quickRequestPaymentAmountTooMuchTitle: "Monto demasiado alto",
    quickRequestPaymentAmountTooMuchText:
      "No puede superar el pendiente de este gasto ({max}).",
    quickRequestPaymentSplitContactRequiredTitle: "Falta el contacto",
    quickRequestPaymentSplitContactRequiredText:
      "Elegí el contacto para el gasto dividido de factura proveedor.",
    quickRequestPaymentSplitSourceMissing:
      "No se pudo cargar el gasto proveedor origen para dividir el pago.",
    quickRequestPaymentSplitParentMissing:
      "No se pudo resolver el embarque para el gasto dividido.",
    quickRequestPaymentSplitCreateExpenseFailed:
      "No se pudo crear el gasto dividido de factura proveedor.",
    quickRequestPaymentSplitSourceAmountInvalid:
      "El gasto proveedor origen tiene un monto inválido para dividir.",
    quickRequestPaymentSplitAmountTooHigh:
      "El monto a dividir no puede superar el monto del gasto proveedor origen.",
    // Collection details modal
    viewCollections: "Ver cobros",
    collectionDetails: "Detalles de Cobros",
    collectedAmount: "Monto Cobrado",
    collections: "Cobros",
    name: "Nombre",
    amount: "Monto",
    status: "Estado",
    date: "Fecha",
    actionsColumn: "Acciones",
    received: "Recibido",
    viewDetails: "Ver detalles",
    noCollections: "No se encontraron cobros",
    fobNotaComercial: {
      addSupplierNote: "Nota del proveedor",
      addSupplierNoteHint:
        "Crear una nota comercial del proveedor de este gasto, con su rol y su moneda ya cargados.",
      addSupplierNoteFailed: "No se pudo abrir la nota comercial de este gasto.",
      notaComercialButton: "Nota comercial",
      notaComercialButtonShipping: "Nota comercial (embarque)",
      modalTitle: "Nota comercial",
      variantLabel: "Tipo de nota",
      optionCreditoCliente: "Nota de crédito al cliente",
      optionDebitoCliente: "Nota de débito al cliente",
      optionCreditoProveedor: "Crédito del proveedor a nosotros",
      optionDebitoProveedor: "Débito del proveedor a nosotros",
      amountLabel: "Monto",
      dateLabel: "Fecha",
      currencyLabel: "Moneda",
      appliedToShippingHint: "Aplicada al embarque: {name}",
      appliedToProformHint: "Aplicada a la proforma: {name}",
      save: "Guardar",
      saving: "Guardando…",
      cancel: "Cancelar",
      successTitle: "Nota comercial creada",
      successText: "La nota se guardó correctamente.",
      errorTitle: "No se pudo crear la nota",
      needClient: "La operación no tiene un cliente asignado.",
      needSupplier: "Este embarque no tiene contacto proveedor.",
      needShipping: "Agregá al menos un embarque para aplicar la nota.",
      needProform: "No se pudo resolver la proforma para aplicar la nota.",
      needAmount: "Ingresá un monto válido mayor a cero.",
      needCurrencyLists: "No se pudo cargar la lista de monedas. Probá de nuevo o recargá la página.",
      editCommercialNote: "Editar nota de crédito",
      editModalTitle: "Editar nota de crédito",
      editHintProform: "Importe aplicado a esta proforma ({name}).",
      editHintShipping: "Importe aplicado a la factura de este embarque.",
      editLoadFailed: "No se pudo cargar la nota.",
      editSuccessTitle: "Nota actualizada",
      editSuccessText: "Los cambios se guardaron.",
      dragApplyNoLines: "Esta nota ya no tiene importe aplicado solo a esta proforma.",
      dragReturnNoLines: "No hubo importe en este embarque para volver a la proforma.",
      deleteButton: "Eliminar",
      deleteConfirmTitle: "¿Eliminar esta nota?",
      deleteConfirmText:
        "La nota comercial se eliminará de forma permanente y se desvinculará de los saldos.",
      deleteSuccessTitle: "Nota eliminada",
      deleteSuccessText: "La nota comercial fue eliminada.",
    },
    errorLoadingCollectionDetails: "Error al cargar detalles de cobros",
    // Cash flow modal
    viewCashFlow: "Ver flujo de caja",
    cashFlowDetails: "Detalles de Flujo de Caja",
    collectionsIncome: "Cobros (Ingresos)",
    paymentsExpenses: "Pagos (Egresos)",
    totalCollected: "Total Cobrado",
    totalPaid: "Total Pagado",
    noPayments: "No se encontraron pagos",
    errorLoadingCashFlow: "Error al cargar flujo de caja",
    // Receipt modal
    viewReceipt: "Ver comprobante",

    // Additional shipping-specific translations
    shippingPending: "Embarque pendiente de cobro",
    toCollect: "por cobrar",
    shippingPendingDetails:
      "No se han registrado cobros aún para este embarque.",
    shippingPartial: "Cobro parcial",
    of: "de",
    remaining: "restante",
    shippingComplete: "Embarque completamente cobrado",
    collectionsRegistered: "cobro(s) registrado(s)",
    help: {
      advanceTitle: "Pago Adelantado",
      advanceDescription:
        "El adelanto es un porcentaje del total de la proforma que el cliente paga antes de que se despache el embarque. Se configura a través del campo 'Condición de Pago'.",
      calculationTitle: "Cómo se calcula",
      calculationDescription:
        "Adelanto Esperado = Total Proforma × Porcentaje de Adelanto. Por ejemplo, si la proforma es $10,000 y el adelanto es 30%, el adelanto esperado es $3,000.",
      shippingTitle: "Embarques y Adelantos",
      shippingDescription:
        "Cuando cobras desde un embarque, el sistema descuenta automáticamente el adelanto proporcional ya pagado. Si la proforma tiene 2 embarques y se pagaron $3,000 de adelanto, cada embarque descuenta $1,500.",
      exampleTitle: "Ejemplo Práctico",
      example1: "Proforma: $10,000 con 30% de adelanto",
      example2: "Adelanto esperado: $3,000 (se cobra antes del embarque)",
      example3:
        "Al cobrar embarque: Total embarque - ($3,000 ÷ número de embarques)",
    },
    // Sección de pagos (para shippings)
    payments: {
      title: "Pagos al Proveedor",
      allGood: "Todos los pagos están al día",
      supplierTotal: "Total Proveedor",
      total: "Total",
      requested: "Solicitado",
      debitNotes: "notas de débito",
      expectedAdvance: "Adelanto Esperado",
      paid: "Pagado",
      pending: "Pendiente",
      notes: "Notas",
      totalExpenses: "Total Gastos",
      expensesPaid: "Gastos Pagados",
      expensesPending: "Gastos Pendientes",
      addPayment: "Solicitar Pago",
      completePayment: "Solicitar Pago",
      requestAdvance: "Solicitar {percentage}%",
      requestFull: "Solicitar 100%",
      requestRemaining: "Completar Adelanto",
      requestBalance: "Solicitar Saldo",
      paymentCreatedSuccessfully: "Pago creado exitosamente",
      failedToOpenPaymentModal: "Error al abrir el formulario de pago",
      failedToSavePayment: "Error al guardar el pago",
      advancePending:
        "🚚 <strong>Adelanto al proveedor pendiente:</strong> Se debe pagar el {percentage}% ({amount}) al proveedor antes del embarque.",
      advancePendingDetails:
        "Registra el pago de adelanto al proveedor/shipper.",
      advancePartial:
        "⏳ <strong>Adelanto parcial pagado:</strong> {paid} de {expected} ({percentage}%). <strong>Faltan {remaining}</strong>",
      advancePartialDetails: "Completa el pago de adelanto al proveedor.",
      advanceComplete:
        "✅ <strong>Adelanto al proveedor completo:</strong> {amount} pagado",
      advanceCompleteDetails:
        "El pago de adelanto al proveedor ha sido completado.",
      balancePending: "Saldo pendiente: {amount} restante por solicitar.",
      balanceRequested:
        "Saldo de {amount} solicitado. Esperando confirmación de pago.",
      requestAlreadySent:
        "Ya hay una solicitud de pago para este importe. Abrí el pago vinculado y usá Pagar (no Pedir pago otra vez).",
      actionDisabledNoPermission:
        "No tenés permiso para registrar pagos al proveedor (finance.payments o finance.manage).",
      actionDisabledNoCollectPermission:
        "No tenés permiso para registrar cobros (finance.collects o finance.manage).",
      balanceAwaitingHint:
        "El saldo ya fue solicitado; abrí el pago vinculado y usá Pagar para marcarlo como pagado en banco.",
      summaryPreparing: "Cargando resumen de pagos…",
      emptySummaryTitle: "Aún no hay líneas de pago al proveedor ni de gastos",
      emptySummaryDetailsNoExpenses:
        "No hay monto de factura proveedor para este embarque y no hay gastos del embarque cargados. Agregá montos en Gastos (y asegurate de que la operación tenga totales de proveedor) para que aquí aparezcan las solicitudes de pago.",
      emptySummaryDetailsGeneric:
        "Todavía no hay nada que mostrar en este resumen. Cuando la operación tenga montos de proveedor o gastos con importe, aparecerán aquí.",
      summaryLoadError: "No se pudo cargar el resumen de pagos",
      summaryLoadErrorDetails:
        "Revisá la conexión y probá actualizar. Si sigue fallando, contactá a soporte.",
      supplierInvoicePending:
        "🚚 <strong>Factura proveedor pendiente:</strong> {amount} debe pagarse al proveedor.",
      supplierInvoicePendingDetails: "Registra el pago al proveedor/shipper.",
      supplierInvoiceNoAmount:
        "🚚 <strong>Factura proveedor:</strong> todavía sin importe.",
      supplierInvoiceNoAmountDetails:
        "Cargá los precios del proveedor para pedir pagos. Sus notas comerciales ya se pueden asignar.",
      supplierInvoicePartial:
        "⏳ <strong>Pago parcial al proveedor:</strong> {paid} de {total} ({percentage}%). <strong>{remaining} restante</strong>",
      supplierInvoiceComplete:
        "✅ <strong>Factura proveedor completa:</strong> {amount} pagado",
      expensesPendingMsg:
        "📋 <strong>Gastos pendientes:</strong> {amount} en gastos de embarque por pagar.",
      expensesPendingDetails: "Registra los pagos de los gastos del embarque.",
      expensesPartial:
        "⏳ <strong>Gastos parcialmente pagados:</strong> {paid} de {total} ({percentage}%). <strong>Faltan {remaining}</strong>",
      expensesComplete: "✅ <strong>Gastos completos:</strong> {amount} pagado",
      expense: "Gasto",
      toPay: "por pagar",
      of: "de",
      remaining: "restante",
      expenseNotPaidDetails: "Este gasto aún no ha sido pagado.",
      requested: "solicitado",
      awaitingPayment:
        "Solicitud enviada. Abrí el pago vinculado y usá Pagar para marcarlo como pagado en banco (verde = ya pagado; rojo = pendiente).",
      paymentLinkPaidHint: "Pago marcado como pagado en banco",
      paymentLinkUnpaidHint:
        "Solicitud pendiente: aún no marcado como pagado en banco. Usá Pagar en este pago.",
      bankPaymentDateForPaymentHint: "Fecha de pago en banco: {name}",
      payExpense: "Solicitar",
      completeExpense: "Solicitar",
      proformaNegotiationFreight: "En negociación: {amount}",
    },
    // Operation Balance section
    balance: {
      title: "Balance de Operación",
      noData: "Datos de balance no disponibles",
      concept: "Concepto",
      totalAmount: "Total",
      paid: "Pagado/Cobrado",
      pending: "Pendiente",
      status: "Estado",
      complete: "Completo",
      partial: "Parcial",
      pendingStatus: "Pendiente",
      // Client section
      clientSection: "CLIENTE (Ingresos)",
      totalInvoice: "Total Factura",
      // Supplier section
      supplierSection: "PROVEEDOR (Egresos)",
      supplierInvoice: "Factura Proveedor",

      costsSubtotal: "Subtotal Costos",
      breakdownAmountTitle: "De dónde sale: {concept}",
      breakdownPaidTitle: "Pagos de: {concept}",
      breakdownAmountHint: "Ver de qué gastos sale este monto",
      breakdownPaidHint: "Ver con qué pagos se cubre este monto",
      breakdownContact: "Contacto",
      breakdownRequested: "Solicitado (sin pagar)",

      projectedMargin: "Margen Proyectado",
      realMargin: "Margen Real",
      currentMargin: "Margen Actual",
      basedOnProforma: "basado en proforma",
      basedOnAllRequests: "basado en todos los gastos",
      basedOnPaidOnly: "solo pagos confirmados",
      proformaTotal: "Total Proforma",
      totalInvoices: "Total Facturas",
      projected: "Proyectado",
      invoice: "Factura",

      advancePortion: "Adelanto",
      overCollectedStatus: "Cobró de más",
      marginHelpAria: "Cómo se calcula este margen",
      marginHelp: {
        clientNotes: "Notas comerciales del cliente",
        estimatedCosts: "Costos estimados",
        bankCommissions: "Comisiones bancarias",
        cashIn: "Cobrado (aplicado a esta operación)",
        collectedApplied: "Cobros aplicados",
        creditNotes: "Notas de crédito aplicadas",
        confirmedPaid: "Pagos confirmados (pagados)",
        supplierPaid: "Proveedor pagado",
        costsPaid: "Otros costos pagados",
        projectedIntro:
          "El Margen Proyectado usa el total de la proforma menos los costos estimados de esta operación:",
        projectedNote:
          "Los costos estimados incluyen la factura del proveedor, otros gastos del embarque y las comisiones bancarias.",
        realIntro:
          "El Margen Real usa el total de factura de esta operación menos los mismos costos estimados:",
        realNote:
          "Misma base de costos que el Margen Proyectado; solo cambia el ingreso de proforma a factura.",
        currentIntro:
          "El Margen Actual es el flujo de caja real de esta operación: lo ya cobrado menos los pagos ya marcados como pagados:",
        currentNote:
          "No usa solicitudes de pago pendientes ni el total de factura completo: solo movimientos de caja confirmados.",
        fobProjectedIntro:
          "En FOB el Margen Proyectado parte del margen bruto de la negociación y cambia el interés estimado por el de la operación:",
        grossMargin: "Margen bruto de la negociación",
        estimatedInterest: "Interés estimado (negociación)",
        interestReal: "Interés real (días entre pago y cobro)",
        interestProjected: "Interés proyectado (lo pendiente, como si fuera hoy)",
        fobProjectedNote:
          "Mientras falte cobrar, el interés se proyecta a hoy y sube cada día de demora; con el último cobro queda el real.",
        fobRealIntro:
          "En FOB el Margen Real es el Margen Actual menos los pagos pedidos que todavía no se pagaron:",
        requestedUnpaid: "Pagos pedidos sin pagar",
        fobRealNote: "Es lo que quedaría en caja si hoy se pagara todo lo que ya se pidió.",
        proformPlanIntro:
          "El Margen Proyectado usa el total de la proforma menos los gastos cargados en la misma proforma:",
        proformPlanCosts: "Gastos de la proforma",
        proformPlanNote:
          "Los gastos de la proforma son el plan de la operación: factura del proveedor, flete, comisiones y demás costos previstos.",
      },
    },
  },

  // PDF Exporter translations
  pdfExporter: {
    exportToPdf: "Exportar a PDF",
    customizePdf: "Personalizar PDF",
    template: "Plantilla",
    fieldsToInclude: "Campos a incluir",
    preview: "Vista previa",
    cancel: "Cancelar",
    export: "Exportar",

    errorGeneratingPdf: "Error al generar el PDF",
  },
  // Tree Edit translations
  treeEdit: {
    dragToMove: "Arrastrar para mover",
    elementName: "Nombre del elemento",
    editElement: "Editar elemento",
    deleteElement: "Eliminar este elemento",

    accountingCode: "Código contable para asientos",
    itemColor: "Color del elemento",
    itemColorHint:
      "El color se usa como fondo de la etiqueta cuando este elemento aparece en un listado. Si no elegís ninguno, se muestra en gris.",
    noColor: "Sin color",
    listTranslationsSection: "Traducciones por idioma (opcional)",
    listTranslationsHint:
      "Si rellenas un idioma, los usuarios verán ese texto al tener la interfaz en ese idioma. Si lo dejas vacío, se usa el nombre por defecto de arriba.",
  },
  // Template pages translations
  templatePages: {
    editRecord: "Editar",
    printOrExport: "Imprimir o exportar",
    openRecord: "Ver ficha",
    pdfTextSize: "Tamaño de letra (impresión)",
    pdfTextSizeHint:
      "Letra más chica ayuda a que entre más contenido en una sola página al imprimir o guardar PDF desde el navegador.",

    retry: "Reintentar",
    reloadVersion: "Recargar versión",
    generatedAt: "PDF generado",
    generatedAtHint:
      "Fecha de la versión que se está viendo. Recargá la versión para regenerarla con los datos actuales.",
  },
  // AI translations (keys aligned with en.js; UI strings in Spanish)
  ai: {
    analyzing: "Analizando...",

    analyzeWithAI: "Análisis con IA",
    analysisConfiguration: "Configuración del análisis",
    analysisPrompt: "Prompt de análisis",
    clearResults: "Limpiar resultados",
    processing: "Procesando...",
    aiAnalysis: "Análisis de IA",

    analysisWithAI: "Análisis con IA",
    hereToHelpTooltip: "Aquí estoy para ayudarte",

    customPrompts: "Pedidos personalizados",
    customPromptsChatHint:
      "Elegí un prompt para cargarlo en el chat. Podés editarlo antes de enviar.",
    executeWithAiNow: "Ejecutar ahora",
    quickRunFieldset: "Crear pedido personalizado",
    missingItemForChat:
      "No hay un ítem cargado; abrí el análisis desde el detalle de un registro.",
    customPromptLoadedInChat:
      "Cargué el prompt «{name}» en el cuadro de abajo; enviá cuando quieras.",
    deletePrompt: "Eliminar prompt",

    saveCustomPrompt: "Guardar pedido personalizado",
    promptName: "Nombre del pedido",

    prompt: "Pedido",

    pleaseSelectAIModel: "Selecciona un modelo de IA",
    pleaseEnterPrompt: "Introduce un prompt para el análisis",
    errorStartingAnalysis: "Error al iniciar el análisis",
    errorAnalyzingContent: "Error al analizar el contenido",
    errorCheckingStatus: "Error al comprobar el estado",

    errorGettingResult: "Error al obtener el resultado",
    analysisFailed: "El análisis falló",
    analysisTimeout: "El análisis tardó demasiado y se canceló",
    errorCheckingAnalysisStatus: "Error al comprobar el estado del análisis",

    promptSaved: "Prompt guardado",
    promptSavedSuccessfully:
      "El prompt personalizado se guardó correctamente y estará disponible en análisis futuros.",

    errorSavingCustomPrompt: "Error al guardar el prompt personalizado",
    deletePromptQuestion: "¿Eliminar prompt?",
    deletePromptConfirmation:
      "¿Seguro que quieres eliminar el prompt «{promptName}»? Esta acción no se puede deshacer.",
    yesDelete: "Sí, eliminar",
    promptDeleted: "Prompt eliminado",
    promptDeletedSuccessfully:
      "El prompt personalizado se eliminó correctamente.",
    errorDeletingPrompt: "Error al eliminar el prompt",
    errorDeletingCustomPrompt: "Error al eliminar el prompt personalizado",
    accept: "Aceptar",
    yes: "Sí",
    no: "No",
    error: "Error",

    errorLoadingModels: "Error al cargar los modelos",
    errorLoadingRecords: "Error al cargar los registros del modelo",
    errorInAnalysis: "Error en el análisis",
    errorCopyingToClipboard: "Error al copiar al portapapeles",
    errorSavingToView: "Error al guardar en la vista",

    itemCreateGenerateError: "No se pudo generar el JSON",
    itemCreateApplyError: "No se pudo crear el registro",
    itemCreateOriginalPrompt: "Pedido original",
    itemCreateIntent: "Intención",
    itemCreateCreatedTitle: "Registro creado",
    itemCreateCreatedBody:
      "Modelo: {model}. Puedes abrir el nuevo registro desde la ficha.",
    itemCreateCreatedShort: "El registro se creó correctamente.",

    itemModifySpecUserPrompt: "Pedido del usuario (Análisis con IA):",
    itemModifySpecAiResponse: "Respuesta del análisis:",
    itemModifySpecPending: "Aclaraciones pendientes",
    itemModifyFieldsHint: "Campos sugeridos",

    itemModifyGenerateError: "No se pudo generar el JSON de actualización",
    itemModifyApplyError: "No se pudieron aplicar los cambios",
    itemModifySavedTitle: "Registro actualizado",
    itemModifySavedBody:
      "Se guardó el registro. La página se actualizará con los datos actuales.",
    lastAiAnalysisSection: "Último análisis con IA",
    viewHistoryItem: "Ver",

    conversationIntro:
      "Hablá en lenguaje natural: podés pedir análisis, cambios en campos o creación de registros.",
    conversationPlaceholder:
      "Ej.: analizá este registro y decime riesgos; o actualizá el campo demanda con este texto...",
    agentChatTitle: "Agente IA",
    agentFabChoice: "Asistente",
    agentFabOpenFull: "Abrir en pantalla completa",
    agentFabReplied: "El asistente te respondió",
    agentNewChat: "Nuevo chat",
    agentHistoryTitle: "Historial",
    agentSpendMonth: "IA este mes: {usd}",
    agentSpendMine: "vos: {usd}",
    agentSpendTrial: "sin cargo hasta el {date}",
    agentSpendSaving: "ahorro",
    agentSpendChange: "Cambiar IA",
    agentSpendAccumulated: "Acumulado este mes:",
    agentModelChange: "Cambiar modelo de IA",
    agentSpendColMessages: "Mensajes",
    agentSpendColSpent: "Gastado",
    agentSpendOther: "Sin detalle por mensaje",
    agentSpendPerMessage: "{usd} por mensaje",
    agentModelChoose: "Elegí con qué modelo seguir",
    agentMessageCost: "Este mensaje: {usd}",
    agentModelModalTitle: "Modelo de IA del chat",
    agentModelModalIntro: "Cada mensaje al asistente se cobra según el modelo que lo responde. En lo que va del mes, la empresa lleva {usd}.",
    agentModelOnlyAdmin: "Solo un administrador puede cambiar el modelo. Pedíselo si querés gastar menos.",
    agentHistoryEmpty: "Todavía no hay conversaciones.",
    agentHistoryUntitled: "Conversación sin título",
    goodMorningTitle: "Buen día",
    goodMorningGreeting: "Buen día, {name}",
    goodMorningHint: "Tocá una propuesta para charlarla conmigo.",
    goodMorningPreview: "Vista previa de {name}: no se guarda ni se le muestra.",
    goodMorningOpen: "Abrir la pantalla",
    goodMorningDismiss: "Ocultar por hoy",
    goodMorningCustomPending: "Preparando…",
    goodMorningCustomError: "No se pudo armar hoy.",
    goodMorningCustomize: "Mis consejos personalizados",
    agentLockedIntro: "Cada mañana te dejo consejos para arrancar el día. Para pedirme que haga cosas en el sistema hace falta el chat del asistente IA.",
    agentLockedReply: "No puedo ayudarte con eso si no tenés el chat activado. Con el chat puedo buscar, cargar y modificar registros por vos.",
    agentLockedAdmin: "Activalo en [Funciones del sistema → Inteligencia artificial](/systemfeatures): la primera semana es gratis.",
    agentLockedUser: "Pedile a un administrador que lo active en Funciones del sistema: la primera semana es gratis.",
    agentLockedUnavailable: "El chat del asistente todavía no está disponible para tu empresa.",
    agentLockedPlaceholder: "El chat no está activado",
    customAdviceTitle: "Mis consejos personalizados",
    customAdviceHelp: "Decile a tu asistente qué querés que vigile por vos. Cada mañana lo revisa solo, sin que se lo pidas, y te deja lo que encontró en «Hoy te propone». Solo lee datos: no carga ni modifica nada.",
    customAdviceExample: "Ej.: Avisame de los pagos que vencen esta semana, con proveedor y monto.",
    customAdviceAdd: "Agregar",
    customAdviceSave: "Guardar",
    customAdviceEmpty: "Todavía no tenés consejos personalizados.",
    customAdviceFreeBadge: "Gratis",
    customAdvicePaidBadge: "Pago por uso",
    customAdviceCount: "{used} de {limit}",
    customAdviceLimitFree: "Tenés {free} gratis. Para agregar más, un administrador tiene que activarlos en Funciones del sistema → Inteligencia artificial.",
    customAdvicePaidWarning: "Desde el tercero se cobra por uso a la empresa.",
    customAdviceDeleteConfirm: "¿Borrar este consejo personalizado?",
    customAdviceSaved: "Listo: lo estoy armando y te aparece en los consejos de hoy.",
    agentChatIntro: "Pedile lo que necesites: buscar, crear o modificar registros. Antes de guardar algo te muestra qué va a cargar y espera tu confirmación.",
    agentChatPlaceholder: "Escribí tu pedido…",
    agentChatUnavailable: "El asistente no está disponible.",
    agentChatLoading: "El asistente está trabajando; puede tardar un par de minutos",
    agentFileDownloadError: "No se pudo bajar el archivo.",
    agentChatKnowledge: "Lo que aprendió",
    agentChatKnowledgeHelp: "Lo que le enseñaron en la empresa. Lo usa en todas las conversaciones de todos los usuarios: corregí o borrá lo que no esté bien.",
    agentChatKnowledgeEmpty: "Todavía no aprendió nada. Explicale un término en el chat (por ejemplo, qué es apropiar) y te va a ofrecer guardarlo.",
    agentChatKnowledgeDeleteConfirm: "¿Borrar «{term}»? El agente lo va a olvidar en las próximas conversaciones.",
    agentChatInstallApp: "Instalar app",
    agentChatInstallHelp: "Instalá {name} en tu teléfono para chatear con el Agente IA como con cualquier app, sin abrir el navegador.",
    agentChatInstallIosSteps: "En iPhone: tocá Compartir (el cuadrado con la flecha hacia arriba) y elegí «Agregar a pantalla de inicio».",
    agentChatInstallOtherSteps: "Abrí el menú del navegador (⋮) y elegí «Instalar app» o «Agregar a pantalla de inicio».",
    agentChatInstallOpensHome: "La app abre en el inicio de {name}; el chat está en el menú, en «Agente IA».",
    agentChatSubtitle: "Asistente de {name}",
    agentChatTyping: "escribiendo…",
    agentChatNotifyOff: "Activar notificaciones",
    agentChatNotifyOn: "Notificaciones activadas",
    agentChatNotifyEnabled: "Listo: cuando el Agente IA responda te llega un aviso en este dispositivo, aunque hayas cerrado el chat. Tocándolo volvés a la conversación. También te avisa de los emails que recibas del sistema.",
    agentChatNotifyDenied: "El navegador tiene bloqueadas las notificaciones de {name}. Habilitalas en los ajustes del navegador y volvé a intentar.",
    agentChatNotifyUnavailable: "Las notificaciones todavía no están configuradas en el servidor.",
    agentChatNotifyIosInstallFirst: "En iPhone las notificaciones funcionan solo con la app instalada: tocá «Instalar app», abrí {name} desde la pantalla de inicio y activalas desde ahí.",
    conversationSend: "Enviar",
    conversationClear: "Reiniciar conversación",
    conversationLoading: "La IA está pensando, a veces puede tardar un poco...",
    conversationGreeting:
      "Listo, ya tengo contexto del registro ({model}). Contame qué necesitás y lo resolvemos por chat.",

    listingAssistantIntro:
      "Podés crear un registro nuevo, pedir filtros para acotar el listado (la IA arma la URL como la barra de filtros) o preguntar por los campos. La IA usa la definición de este listado. No hace falta tener todos los datos para un alta: alcanza con lo principal para un borrador y completar el resto en la ficha.",
    listingAssistantPlaceholder:
      "Ej.: generá un borrador con los datos…, explicá qué es el campo X…",
    listingAssistantGreeting:
      "Estás en el listado de {model}. Contame qué registro querés generar o qué necesitás.",
    listingAssistantCreatedOk: "Listo, el registro quedó creado.",
    listingFiltersApplied:
      "Listo, actualicé los filtros del listado (se reflejan en la URL).",
    listingAssistantError: "No se pudo completar la acción con la IA.",
    supportFABAssistantIntro:
      "Preguntá en lenguaje cotidiano sobre cómo funciona el sistema, formularios, envíos o tickets de soporte.",

    supportFABAssistantPlaceholder:
      "Ej.: no se me rellenó un dato al crear un envío, ¿cómo sigo un ticket?, ¿dónde cambio…?",
    supportFABAssistantError:
      "No se pudo completar la respuesta del asistente.",
    supportFABTokenUsage:
      "Consumo de este mensaje: {total} tokens ({prompt} entrada + {completion} salida, {calls} consultas) · {cost} USD",
    supportFABGreetingCapabilities:
    "Podés consultarme sobre el uso del sistema, formularios, envíos o tickets de ayuda.\n\nReglas con palabras clave:\n«Recuerda esto:» — Para que recuerde reglas en el futuro y no tengas que volver a repetirlas (por ej: 'Cuando digo MF es Martin Fernandez'). También podés usar «aclaracion:» o «remember this:».\nPodés ver o editar estas reglas en Características del sistema → Módulos incluidos → Soporte técnico IA → Mis reglas. Se comparten con todos los usuarios del sistema.",      
    chatTurnNetworkSlow:
      "El servicio está muy lento o no alcanzó a responder. Probá de nuevo en unos minutos.",
    chatTurnTimeoutSlow:
      "La respuesta tardó demasiado. Probá de nuevo en un rato o con una pregunta más corta.",
    supportChatTurnTimeoutPartial:
      "La consulta tardó más de lo que el navegador espera, pero ya hay parte de la respuesta arriba. Podés enviar de nuevo o reformular el pedido.",
    supportFABTechnicalIALabel: "Soporte técnico IA",

    supportChatAttach: "Adjuntar archivo",
    supportChatAttachMax: "Máximo {max} archivos por conversación.",
    supportChatAttachError: "No se pudo subir el archivo.",
    supportFABChoiceReportBug: "Reportar un bug",
    supportFABChoiceChat: "Chatear",
    supportFABChoicePerformance: "Performance",
    supportFABPerformanceTitle: "Performance",
    supportFABPerformanceIntro:
      "Medimos la conexión desde tu navegador. Si soporte te lo pide, hacé una captura de pantalla de este panel.",
    supportFABPerformanceRefresh: "Actualizar medición",
    supportFABPerformanceCopy: "Copiar datos",
    supportFABPerformanceCopied: "Datos copiados al portapapeles.",
    supportFABPerformanceCopyError: "No se pudieron copiar los datos.",
    supportFABPerformanceLoading: "Midiendo conexión…",
    supportFABPerformanceError: "No se pudo completar la medición.",
    supportFABPerformanceNotAvailable: "No disponible",
    supportFABPerformanceSummary: "Resumen",
    supportFABPerformanceNetwork: "Red del navegador",
    supportFABPerformanceOnline: "En línea",
    supportFABPerformanceEffectiveType: "Tipo de conexión",
    supportFABPerformanceDownlink: "Descarga estimada",
    supportFABPerformanceBrowserRtt: "RTT del navegador",
    supportFABPerformanceSaveData: "Ahorro de datos",
    supportFABPerformanceApiLatency: "Latencia al servidor",
    supportFABPerformanceAvgLatency: "Promedio",
    supportFABPerformanceMinMaxLatency: "Mín / Máx",
    supportFABPerformanceSamples: "Muestras",
    supportFABPerformancePageLoad: "Carga de esta página",
    supportFABPerformanceTtfb: "TTFB",
    supportFABPerformanceDomInteractive: "DOM interactivo",
    supportFABPerformanceLoadTotal: "Carga total",
    supportFABPerformanceEnvironment: "Entorno",
    supportFABPerformanceTimezone: "Zona horaria",
    supportFABPerformanceLocale: "Idioma",
    supportFABPerformanceScreen: "Pantalla",
    supportFABPerformanceViewport: "Viewport",
    supportFABPerformanceScreenshotHint:
      "Enviá una captura de esta pantalla a soporte si te la piden.",
    supportFABPerformanceOffline: "Sin conexión",
    supportFABPerformanceStatusGood: "Buena",
    supportFABPerformanceStatusModerate: "Regular",
    supportFABPerformanceStatusSlow: "Lenta",
    supportFABPerformanceStatusUnknown: "Sin datos",
    supportFABPerformanceGeneratedAt: "Medición",

    promptHistoryTitle: "Historial del chat con IA (resultado aplicado)",
    promptHistoryHint:
      "Queda guardado en tu cuenta cuando el chat aplicó cambios en la ficha o creó un registro desde el chat. Recuperá el pedido abajo para reutilizarlo o afinarlo.",
    promptHistoryRestoredHint:
      "Dejé el pedido en el cuadro de abajo; revisalo y enviá cuando quieras.",
    promptHistoryRestore: "Recuperar",
    promptHistoryRemove: "Quitar del historial",
    promptHistoryUntitled: "(sin título)",

    promptHistoryKindChatModify: "Chat · cambios aplicados",
    promptHistoryKindChatCreate: "Chat · alta aplicada",
    promptHistoryChatModifyNote: "Cambios aplicados al registro desde el chat.",
    promptHistoryChatCreateNote: "Nuevo registro creado desde el chat.",

    analysisInProgressTitle: "Análisis en curso",
    analysisInProgressMessage: "Analizando: «{excerpt}»",
    viewContent: "Ver contenido",
    cancelAnalysis: "Cancelar",
    analysisCompletedTitle: "Análisis completado",
    analysisCompletedMessage: "El análisis de IA finalizó correctamente.",
    analysisCancelledTitle: "Análisis cancelado",
    analysisCancelledMessage: "El análisis se canceló.",
    analysisErrorTitle: "Error en el análisis",
    analysisErrorGeneric: "Ocurrió un error durante el análisis.",
    cancelAnalysisErrorTitle: "No se pudo cancelar",

    cancelAnalysisErrorRetry:
      "No se pudo cancelar el análisis. Inténtalo de nuevo.",
    processingAnalysisProgress: "Procesando análisis… {progress}%",

    progressBarPercent: "{progress}% completado",
  },
  // Preferences translations
  savePreferences: "Guardar preferencias",
  preferencesSaved: "Preferencias guardadas correctamente",
  preferencesSaveError: "Error al guardar las preferencias",
  savePreferencesTooltip:
    "Guarda las preferencias actuales de columnas, orden, anchos y filtros",
  applyPreferencesToAllUsers: "Aplicar estas preferencias a todos los usuarios",
  applyPreferencesToAllUsersHint:
    "Esto sobrescribirá las preferencias de todos los usuarios del sistema para este modelo",
  preferencesAppliedToAllUsers:
    "Preferencias aplicadas a todos los usuarios correctamente",
  // Column and report translations
  ColumnRemoved: "Se ha quitado la columna",
  LoadingColumnPreferences: "Cargando preferencias de columnas...",
  NoRecordsAvailable: "No hay registros disponibles",
  // Piezas mobile (components/mobile) y versión de teléfono de las pantallas.
  mobile: {
    actions: "Acciones",
    recordActions: "Acciones del registro",
    columns: "Columnas",
    filterFields: "Elegir filtros",
    showResults: "Ver {n} resultados",
    of: "de",
    previous: "Anterior",
    next: "Siguiente",
    navigation: "Navegación",
    home: "Inicio",
    support: "Soporte",
    menu: "Menú",
    pushOff: "Activar notificaciones",
    pushOn: "Notificaciones activadas",
    pushEnabled: "Listo: en este teléfono te llega un aviso por cada email que recibas del sistema y cuando responda el Agente IA. Tocá de nuevo para desactivarlas.",
    pushDenied: "El teléfono tiene bloqueadas las notificaciones de esta app. Habilitalas en los ajustes y volvé a intentar.",
    installTitle: "Instalá {name} en tu teléfono",
    installSubtitle: "Se abre como una app y te avisa de tus emails.",
    installButton: "Instalar",
    installDismiss: "Ahora no",
    installWhichPhone: "¿Qué teléfono tenés?",
    installOtherPhone: "¿Tenés {name}? Ver sus pasos",
    installAndroidQuick: "Tu teléfono permite instalarla con un toque:",
    installNow: "Instalar ahora",
    installOrManual: "O hacelo a mano:",
    installIosStep1: "Abrí esta página en Safari y tocá el botón Compartir (el cuadrado con la flecha hacia arriba), en la barra de abajo.",
    installIosStep2: "Deslizá hacia abajo y elegí «Agregar a pantalla de inicio».",
    installIosStep3: "Tocá «Agregar», arriba a la derecha.",
    installIosAddLabel: "Agregar a inicio",
    installIosCancel: "Cancelar",
    installIosConfirm: "Agregar",
    installAndroidStep1: "En Chrome, tocá los tres puntitos (⋮) arriba a la derecha.",
    installAndroidStep2: "Elegí «Instalar app» (o «Agregar a pantalla de inicio»).",
    installAndroidStep3: "Confirmá tocando «Instalar».",
    installAndroidLabel: "Instalar app",
    installStepOpen: "Listo: abrí {name} desde el ícono en tu pantalla de inicio. Desde ahí podés activar las notificaciones en el menú de tu usuario.",
    pushBannerTitle: "Activá las notificaciones",
    pushBannerSubtitle: "Recibí en el teléfono los avisos que hoy te llegan por email.",
    pushBannerButton: "Activar",
    pushNeedsInstall: "En iPhone las notificaciones funcionan solo con la app instalada: en Safari tocá Compartir → «Agregar a pantalla de inicio», abrí la app desde ahí y activalas en este menú.",
  },
  PleaseSelectColumns:
    "Por favor selecciona columnas en el botón azul arriba a la derecha para ver información en este listado",
  Column: "Columna",
  restored: "restaurada",
  New: "Nuevo",
  ImportJSON: "Importar JSON",
  SelectAll: "Seleccionar todo",
  BulkEdit: "Edición masiva",
  DeleteSelected: "Eliminar seleccionados",
  Archive: "Archivar",
  ArchiveSelected: "Archivar seleccionados",
  listTitleTrash: "Papelera",
  listTitleArchive: "Archivados",
  listTitleHidden: "Escondidos",
  "Export to Excel": "Exportar a Excel",
  "Hide empty date": "Ocultar sin fecha",
  "Actions": "Acciones",
  "Debit": "Débito",
  "Credit": "Crédito",
  "Attached File": "Archivo adjunto",
  "No transactions found matching your search": "No hay movimientos que coincidan con la búsqueda",
  "Hide movements that have no date": "Ocultar los movimientos que no tienen fecha",
  "No payments found": "No se encontraron pagos",
  "No collects found": "No se encontraron cobros",
  listTabActive: "Activos",
  listTabArchived: "Archivados",
  listTabAll: "Todo",
  hide: "Esconder",
  hideInThisView: "Ocultar en esta vista",
  showInThisView: "Mostrar en esta vista",
  HideSelected: "Esconder seleccionados",
  ShowSelected: "Mostrar seleccionados",
  "View archived": "Ver archivados",
  "This item is archived": "Este elemento está archivado",
  excelExportArchived: "Archivado",
  excelExportPaid: "Pagado",
  excelExportUnpaid: "Sin pagar",
  Unarchive: "Desarchivar",
  UnarchiveSelected: "Desarchivar seleccionados",
  "records archived successfully.": "registros archivados correctamente.",
  "records archived": "registros archivados",
  "An error occurred while archiving the records.": "Ocurrió un error al archivar los registros.",
  "records unarchived successfully.": "registros desarchivados correctamente.",
  "records unarchived": "registros desarchivados",
  "An error occurred while unarchiving the records.": "Ocurrió un error al desarchivar los registros.",
  "The record has been unarchived successfully.": "El registro se desarchivó correctamente.",
  "An error occurred while unarchiving the record.": "Ocurrió un error al desarchivar el registro.",
  SaveAsReport: "Guardar como reporte",
  Reports: "Reportes",
  Filters: "Filtros",
  MoreFilters: "Más filtros",
  MyItems: "Mis registros",
  listTitleMyItems: "Solo mis registros",
  userOwner: "User owner",
  userOwnerFieldSelect: "Campos de usuario propietario",
  userOwnerFieldNone: "Ninguno",
  userOwnerFieldSaveError: "No se pudo guardar el campo de usuario propietario",
  KeywordSearch: "Búsqueda por palabras",
  Choose: "Elegir",
  CreationDate: "Fecha de creación",
  ReportLoaded: "Reporte cargado",
  ReportLoadedSuccessfully: 'El reporte "{name}" se ha cargado correctamente',
  ErrorLoadingReport: "Error al cargar el reporte",
  // Report modal translations
  ReportName: "Nombre del reporte",
  EnterReportName: "Ingresa el nombre del reporte",
  EnterReportDescription: "Ingresa la descripción del reporte (opcional)",
  MakeReportPublic:
    "Hacer este reporte público (todos los usuarios pueden acceder)",
  ReportSaveInfo:
    "Esto guardará la configuración actual de la vista incluyendo:",
  ReportSaveInfoColumns: "Columnas seleccionadas y su orden",
  ReportSaveInfoColumnLabels:
    "Títulos de columnas personalizados (se guardan con el reporte)",
  ReportSaveInfoWidths: "Anchos de columnas",
  ReportSaveInfoFilters: "Filtros aplicados",
  ReportSaveInfoSort: "Orden de clasificación",
  ReportSaveInfoPagination: "Configuración de paginación",
  SaveReport: "Guardar reporte",
  PleaseEnterReportName: "Por favor ingresa un nombre para el reporte",
  ReportIcon: "Icono del reporte",
  SearchIcon: "Buscar icono...",
  ChooseIcon: "Elegir ícono",
  NoIconsFound: "No hay íconos con ese nombre",
  ReportSavedSuccessfully: "¡Reporte guardado correctamente!",
  ErrorSavingReport: "Error al guardar el reporte",
  SavedReports: "Reportes guardados",
  Loading: "Cargando...",
  NoSavedReportsFound: "No se encontraron reportes guardados",
  Name: "Nombre",
  Visibility: "Visibilidad",
  CreatedBy: "Creado por",
  UpdatedBy: "Actualizado por",
  Created: "Creado",
  Public: "Público",
  Private: "Privado",
  Unknown: "Desconocido",
  Load: "Cargar",
  LoadReport: "Cargar reporte",
  EditReport: "Editar reporte",
  DeleteReport: "Eliminar reporte",
  Import: "Importar",
  Continue: "Continuar",
  ImportReportConfig: "Importar configuración de reporte",
  ExportReportConfig: "Exportar configuración de reporte",
  ReportConfigImportedSuccessfully:
    "Configuración de reporte importada correctamente",
  ErrorImportingReportConfig: "Error al importar la configuración del reporte",
  ErrorExportingReportConfig: "Error al exportar la configuración del reporte",
  InvalidReportConfigFile: "Archivo JSON de configuración de reporte inválido",
  ModelMismatch: "Modelo distinto",
  ReportConfigModelMismatch:
    "Esta configuración fue exportada desde otro modelo. Puedes continuar, pero algunas columnas o filtros podrían no aplicar.",
  Close: "Cerrar",
  deleteBlockedFinancial: {
    title: "No se puede eliminar",
    introProforms:
      "Las siguientes proformas no se pueden eliminar porque tienen pagos/cobros asociados:",
    introShippings:
      "Los siguientes embarques no se pueden eliminar porque tienen pagos/cobros asociados:",
    introGeneric:
      "Los siguientes registros no se pueden eliminar porque tienen pagos/cobros asociados:",
    introContacts:
      "Los siguientes contactos no se pueden eliminar porque tienen movimientos asociados:",
    commercialNotes: "Notas comerciales",
    expenseShippings: "Embarques con gastos del contacto",
    clientShippings: "Embarques donde es cliente",
    bankAccounts: "Cuentas bancarias",
  },
  Save: "Guardar",
  Saving: "Guardando",
  Edit: "Editar",
  List: "Lista",
  ListOpenView: "Ver",
  "Add new": "Añadir nuevo",
  "Recalculate status": "Recalcular status",
  "Recalculate status for all shippings":
    "Recalcular status de todos los embarques",
  "Recalculate status done":
    "Status actualizado para {count} embarques en {ms} ms.",
  All: "Todos",
  addReferenceRelatedToContent: "Agregar {label}",
  Delete: "Eliminar",
  Clear: "Limpiar",
  Activate: "Activar",
  Deactivate: "Desactivar",
  Active: "Activo",
  Inactive: "Inactivo",
  editColumnDisplayName: "Nombre de la columna",
  editColumnDisplayNameHint:
    "Déjelo vacío o igual al nombre por defecto para restaurar la etiqueta original.",
  editColumnDisplayNameTooltip: "Personalizar columna",
  editColumnDescription: "Descripción de la columna",
  editColumnDescriptionHint:
    "Se muestra al pasar el mouse por el icono «?» de la cabecera. Déjelo vacío para volver a la descripción del sistema, o para quitar el icono si el campo no tiene una.",
  editColumnDescriptionTooltip: "Describir esta columna",
  editColumnDisplayNameTooLong: "Máximo 200 caracteres",
  editColumnDisplayBold: "Negrita",
  editColumnShowTotal: "Mostrar total",
  editColumnGroupBy: "Agrupar filas por esta columna",
  editColumnMoveToStart: "Enviar al inicio",
  editColumnMoveToEnd: "Enviar al final",
  reportColumnLayoutTitle: "Diseño de columnas",
  reportRowGroupingBy: "Filas agrupadas por: {column}",
  reportRowGroupingNone: "Las filas no están agrupadas. Para agrupar filas, usá «Personalizar columna» en el encabezado de la columna.",
  reportRowGroupingChange: "Cambiar",
  reportGroupByEmpty: "(sin valor)",
  groupTotals: {
    groupDateBy: "Agrupar la fecha por",
    period: { day: "Día", yearMonth: "Mes", year: "Año" },
    inGroupRow: "En la fila de cada grupo, mostrar",
    weightedBy: "ponderado por",
    op: {
      none: "Nada",
      sum: "Suma",
      avg: "Promedio",
      weightedAvg: "Promedio ponderado",
      min: "Mínimo",
      max: "Máximo",
    },
    highlightMonth: "Indicar en cada año el mes",
    none: "No indicar",
    lowestMonth: "Más bajo",
    highestMonth: "Más alto",
    lowestMonthText: "mes más bajo: {month} ({value})",
    highestMonthText: "mes más alto: {month} ({value})",
    collapsedByDefault: "Grupos cerrados al abrir (una fila por grupo)",
    toggleGroup: "Abrir o cerrar el grupo",
  },
  reportColumnLayoutHint:
    "Agrupar columnas las muestra juntas bajo un título y color (también las ya combinadas). Combinar columnas junta el contenido en una sola columna; no se combinan columnas ya combinadas.",
  reportColumnMergeIncludesMergedTitle: "Usá Agrupar columnas",
  reportColumnMergeIncludesMergedText:
    "Las columnas ya combinadas no se pueden volver a combinar. Seleccionalas y usá Agrupar columnas para ponerlas bajo un mismo título y color.",
  reportColumnGroup: "Agrupar columnas",
  reportColumnMerge: "Combinar columnas",
  reportColumnGroupTitle: "Título del grupo",
  reportColumnGroupTitleRequired: "Indique un título para el grupo",
  reportColumnMergeStack: "Uno debajo de otro",
  reportColumnMergeSum: "Sumar valores",
  reportColumnSelectTwo: "Seleccioná al menos dos columnas",
  reportColumnMergesList: "Columnas unidas",
  reportColumnGroupsList: "Grupos",
  reportColumnMergedBadge: "unida",
  reportColumnLayoutColumns: "columnas",
  Apply: "Aplicar",
  ReportUpdatedSuccessfully: "Reporte actualizado correctamente",
  ErrorUpdatingReport: "Error al actualizar el reporte",
  updateReport: "Actualizar reporte",
  foreignReport: {
    title: "Este reporte no es tuyo",
    text: "«{name}» es de {owner}: tus cambios no se pueden guardar en él. ¿Querés guardarlos como un reporte nuevo, tuyo?",
    textNoOwner: "«{name}» es de otro usuario: tus cambios no se pueden guardar en él. ¿Querés guardarlos como un reporte nuevo, tuyo?",
    saveAsNew: "Guardar como nuevo",
    keepWithoutSaving: "Seguir sin guardar",
    copyName: "{name} (copia)",
  },
  updateReportTooltip:
    "Actualiza el reporte cargado con la configuración actual",

  ReportExited: "Has salido del reporte y vuelto a tus preferencias guardadas",
  ErrorExitingReport: "Error al salir del reporte",
  ViewingReport: "Viendo reporte",
  AreYouSure: "¿Estás seguro?",
  ConfirmDeleteReport: '¿Deseas eliminar el reporte "{name}"?',
  YesDeleteIt: "Sí, eliminarlo",
  Deleted: "Eliminado",
  ReportDeletedSuccessfully: "Reporte eliminado correctamente",
  ErrorDeletingReport: "Error al eliminar el reporte",
  ErrorLoadingReports: "Error al cargar los reportes",
  ResizeColumn: "Redimensionar columna",
  Sort: "Ordenar",
  PinColumn: "Fijar columna",
  UnpinColumn: "Desfijar columna",
  "Select all": "Seleccionar todo",
  columnSelectorSelectedCount: "{count} columnas seleccionadas",
  columnSelectorNoFields: "No hay campos que se puedan mostrar",
  "Customize display": "Personalizar vista",
  "Clear filter": "Quitar filtro",
  "Clear all": "Quitar todos",
  "Close all": "Cerrar todas",
  "Is empty": "Está vacío",
  "Is not empty": "No está vacío",
  HideColumn: "Ocultar columna",
  ClipViewMoreColumnOn: "Columna compacta (mostrar + para expandir)",
  ClipViewMoreColumnOff: "Desactivar columna compacta",
  WrapTextColumnOn: "Ajustar texto en la columna",
  WrapTextColumnOff: "Quitar el ajuste de texto",
  ColumnsFormatAll: "Formato de todas las columnas",
  WrapTextAllColumns: "Todas en renglones",
  ClipViewMoreAllColumns: "Todas compactas (con +)",
  ClearFormatAllColumns: "Quitar formato a todas",
  OrderByDragAndDrop: "Ordenar arrastrando",
  RowDragHandle: "Arrastrar para ordenar",
  RowOrderSaveError: "No se pudo guardar el orden de las filas",
  ColumnFieldHelpAria: "Ver descripción del campo",
  ImportCSV: "Importar CSV",
  AdvancedImport: "Importación Avanzada",
  ImportPresetSavedConfigs: "Configuraciones guardadas",
  ImportPresetPickToApply: "— Aplicar configuración guardada —",
  ImportPresetSaveCurrent: "Guardar configuración actual",
  ImportPresetPickToDelete: "— Eliminar guardada —",
  ImportPresetHint:
    "Guarde el mapeo (CSV), separador y opciones de duplicados / referencias para reutilizarlos. Puede aplicar cualquier configuración guardada; las columnas que coincidan por nombre usarán el mapeo guardado. Al guardar, el nombre será el del archivo subido (sin extensión).",
  ImportPresetNamePrompt: "Nombre para esta configuración",
  ImportPresetNameRequired: "Indique un nombre para guardar.",
  ImportPresetSavedOk: "Configuración guardada correctamente.",
  ImportPresetMismatch:
    "Las columnas del archivo no coinciden con esa configuración.",
  ImportPresetDeletedOk: "Configuración eliminada.",
  ImportPresetConfirmDelete: "¿Eliminar esta configuración guardada?",
  ImportPresetNoFile: "Sin archivo CSV",
  ImportPresetNoFileDetail:
    "Seleccione un archivo para poder guardar la configuración.",
  ImportSkipHooks: "Omitir hooks durante la importación",
  ImportSkipHooksHelp:
    "Acelera la importación evitando la ejecución de hooks/model hooks en cada fila.",
  ImportErrorsLiveTitle: "Errores detectados durante la importación",
  ImportRowPrefix: "Fila",
  ImportGenericRowError: "Error al importar la fila",
  ImportErrorAdminNote: "Detalle técnico visible por rol admin.",
  ImportCreateMissingRefs: "Crear referencias faltantes",
  ImportCreateMissingRefsHelp:
    "Si un campo reference no existe, se creará automáticamente usando el valor del archivo como nombre (name).",
  LoadingData: "Cargando datos...",
  // AI Model Context translations
  aiModelContext: {
    title: "Configuración de Contexto IA por Modelo",
    subtitle:
      "Define el contexto específico que la IA debe tener para cada modelo de datos",
    configurePrompts: "Configurar Prompts",
    goToAI: "Ir a IA",
    whatIsAIContext: "¿Qué es el Contexto de IA?",
    aiContextDescription:
      "El contexto de IA es información específica que se envía a la inteligencia artificial cada vez que analiza datos de un modelo particular. Esto ayuda a la IA a entender:",
    whatModelRepresents: "Qué representa el modelo",
    whatModelRepresentsDesc: "Su propósito y función en el negocio",
    howToInterpretData: "Cómo interpretar los datos",
    howToInterpretDataDesc: "El significado de cada campo",
    whatToLookFor: "Qué buscar en el análisis",
    whatToLookForDesc: "Aspectos importantes a considerar",
    businessContext: "El contexto del negocio",
    businessContextDesc: "Relaciones con otros modelos",
    definitionModels: "Modelos de Definición",
    loading: "Cargando...",
    loadingModels: "Cargando modelos...",
    noModelsDefined: "No hay modelos definidos",
    createModelsDescription:
      "Crea modelos de definición para poder configurar su contexto de IA",
    createModel: "Crear Modelo",
    model: "Modelo",
    label: "Etiqueta",
    aiContext: "Contexto IA",
    status: "Estado",
    actions: "Acciones",
    noLabel: "Sin etiqueta",
    configured: "Configurado",
    notConfigured: "Sin configurar",
    active: "Activo",
    configure: "Configurar",
    view: "Ver",
    configureAIContext: "Configurar Contexto IA",
    modelLabel: "Modelo:",
    aiContextLabel: "Contexto de IA *",
    aiContextGeneralLabel: "Contexto general del modelo",
    generalContextOptional:
      "Opcional si ya completás las secciones de acciones o campos.",
    actionPromptsTitle: "Prompts por acción",
    actionEditItemLabel: "Editar un ítem",
    actionAddItemLabel: "Agregar un ítem",
    actionDeleteItemLabel: "Borrar un ítem",
    actionSearchItemLabel: "Buscar un ítem",
    actionPromptPlaceholder: "Instrucciones para la IA cuando aplique esta acción…",
    fieldPromptsTitle: "Prompts por campo",
    fieldPromptsHint:
      "Clave técnica del campo (como en filtros y JSON). Solo se guardan textos no vacíos.",
    fieldPromptPlaceholder: "Reglas o significado operativo de este campo…",
    noFieldsInModel: "Este modelo no tiene campos en la definición.",
    saveRequiresOneSection:
      "Completá al menos un bloque: contexto general, una acción o un campo.",
    previewAsSentToAi: "Vista previa (como se envía a la IA)",
    previewGeneral: "Contexto general del modelo",
    previewActions: "Instrucciones por acción",
    previewFields: "Instrucciones por campo (clave técnica)",
    emptyPreview: "(sin contenido)",
    aiContextPlaceholder:
      "Describe el contexto específico de este modelo para la IA...",
    contextExamples: "Ejemplos de contexto:",
    example1:
      "Este modelo representa contactos comerciales. Analiza la calidad de la información de contacto, la actividad comercial y las oportunidades de negocio.",
    example2:
      "Este modelo contiene productos del catálogo. Evalúa la completitud de la información, precios competitivos y descripción del producto.",
    example3:
      "Este modelo registra transacciones financieras. Identifica patrones de gastos, categorización correcta y posibles anomalías.",
    tipsForGoodContext: "Consejos para un buen contexto:",
    tip1: "Explica qué representa el modelo en el negocio",
    tip2: "Describe qué aspectos son importantes analizar",
    tip3: "Menciona relaciones con otros modelos si las hay",
    tip4: "Especifica el tipo de insights que esperas obtener",
    cancel: "Cancelar",
    saving: "Guardando...",
    saveContext: "Guardar Contexto",
    modelAIContext: "Contexto IA del Modelo",
    aiContextLabelView: "Contexto de IA:",
    close: "Cerrar",
    edit: "Editar",
    error: "Error",
    errorLoadingModels: "Error al cargar los modelos",
    success: "¡Éxito!",
    contextSavedSuccessfully: "Contexto de IA guardado exitosamente",
    errorSavingContext: "Error al guardar el contexto",
  },

  // Months
  months: {},

  // Website Module
  websites: {
    title: "Sitios Web",
    subtitle: "Gestiona tus sitios web y dominios",
    menuItem: "Websites",
    createWebsite: "Crear Website",
    editWebsite: "Editar Website",
    name: "Nombre",
    description: "Descripción",
    domain: "Dominio",
    status: "Estado",
    createdAt: "Fecha de creación",
    actions: "Acciones",
    active: "Activo",
    inactive: "Inactivo",
    isActive: "Activo",
    edit: "Editar",
    delete: "Eliminar",
    noWebsites: "No hay sitios web",
    noWebsitesHint: "Crea tu primer sitio web usando el botón de arriba",
    searchPlaceholder: "Buscar sitios web...",
    namePlaceholder: "Nombre del sitio web",
    descriptionPlaceholder: "Descripción del sitio web (opcional)",
    domainPlaceholder: "ejemplo.com",
    domainHint:
      "Opcional. Configura el dominio cuando quieras publicar el sitio.",
    saving: "Guardando...",
    created: "Sitio web creado correctamente",
    updated: "Sitio web actualizado correctamente",
    deleted: "Sitio web eliminado correctamente",
    confirmDelete: '¿Deseas eliminar el sitio web "{name}"?',
    requiredFields: "Por favor completa los campos obligatorios",
    errorLoading: "Error al cargar los sitios web",
    errorSaving: "Error al guardar el sitio web",
    errorDeleting: "Error al eliminar el sitio web",
    preview: "Vista previa",
  },

  // Pages (Website Module)
  pages: {
    title: "Páginas",

    createPage: "Crear Página",
    editPage: "Editar Página",
    slug: "Slug",
    model: "Modelo",

    status: "Estado",

    actions: "Acciones",
    active: "Activo",
    inactive: "Inactivo",

    noPages: "No hay páginas",
    noPagesHint: "Crea tu primera página usando el botón de arriba",
    searchPlaceholder: "Buscar páginas...",

    created: "Página creada correctamente",
    updated: "Página actualizada correctamente",
    deleted: "Página eliminada correctamente",
    confirmDelete: '¿Deseas eliminar la página "{slug}"?',
    requiredFields: "El slug es obligatorio",

    errorSaving: "Error al guardar la página",
    errorDeleting: "Error al eliminar la página",
    preview: "Vista previa",

    shortcodeIf: "Muestra contenido si el campo existe",
    shortcodeHidden: "Oculta en ciertos dbNames",
    shortcodeShow: "Muestra solo en ciertos dbNames",
    shortcodeFor: "Itera sobre un array",

    conditionals: "Condicionales",
    loops: "Loops",
    visibility: "Visibilidad",
    operators: "Operadores",
    loopVars: "Variables del loop",
    loopIndex: "Índice actual (0, 1, 2...)",
    loopFirstLast: "Primer/último elemento",

    // Visual Editor
    editor: {
      loading: "Cargando editor...",
      splitView: "Vista dividida",
      codeOnly: "Solo código",
      previewOnly: "Solo preview",
      openInBrowser: "Ver en navegador",
      save: "Guardar",
      saving: "Guardando...",
      configuration: "Configuración",
      urlSlug: "URL (slug)",
      pageActive: "Página activa",
      dataSource: "Fuente de datos",
      noData: "Sin datos",
      selectModel: "Seleccionar modelo...",
      selectReport: "Seleccionar reporte...",
      elements: "Elementos",
      title: "Título",
      text: "Texto",
      image: "Imagen",
      button: "Botón",
      divider: "Divisor",
      container: "Contenedor",
      columns: "Columnas",
      list: "Lista",
      card: "Tarjeta",
      hero: "Hero",
      gallery: "Galería",
      video: "Video",
      blocks: "Bloques",
      media: "Media",
      uploadImage: "Subir imagen",
      noMedia: "No hay imágenes",
      clickToInsert: "Clic para insertar",
      uploadError: "Error al subir imagen",
      confirmDeleteMedia: "¿Eliminar esta imagen?",
      files: "Archivos CSS/JS",
      noFiles: "No hay archivos",
      manageFiles: "Gestionar archivos",
      fileInserted: 'Shortcode del archivo "{name}" insertado',
      variables: "Variables",
      insertLoop: "Insertar bucle t-for",
      logic: "Lógica",
      conditional: "Condicional",
      ifElse: "If/Else",
      loop: "Bucle",
      hideFor: "Ocultar para",
      showFor: "Mostrar para",
      html: "HTML",
      formatCode: "Formatear código",
      livePreview: "Vista previa",
      refresh: "Actualizar",
      noSampleWarning: "Sin datos de muestra",
      writePlaceholder:
        "Escribe tu HTML aquí o usa los elementos del panel izquierdo...",
    },
    // Page Import
    importFromHtml: "Importar desde HTML",
    importHtmlSimpleHelp:
      "Pega tu código HTML. Los archivos CSS y JavaScript serán extraídos automáticamente y guardados como archivos del sitio.",

    baseUrl: "URL base del sitio",
    baseUrlHint:
      "Para resolver URLs relativas (ej: /css/style.css → https://ejemplo.com/css/style.css)",
    pasteHtml: "Pega tu código HTML aquí:",
    htmlPlaceholder:
      "<!DOCTYPE html>\n<html>\n<head>...</head>\n<body>\n  <header>...</header>\n  <main>...</main>\n  <footer>...</footer>\n</body>\n</html>",
    importPage: "Importar página",
    importing: "Importando...",
    importSuccess:
      "Página importada correctamente. {files} archivos CSS/JS extraídos.",
    importError: "Error al importar la página",

    generateBlocksWithAI: "Generar bloques con IA",
    analyzing: "Analizando...",
    aiAnalysisResults: "Resultados del análisis IA",
    blocksDetected: "Bloques detectados",
    pagePreview: "Vista previa de la página",
    createSelectedBlocks: "Crear bloques seleccionados",
    createBlocksAndUpdatePage: "Crear bloques y actualizar página",
    noBlocksDetected: "No se detectaron bloques",
    htmlRequired: "El HTML es requerido",
    analyzeError: "Error al analizar el HTML",
    generateBlocksInfo:
      "Se crearán los bloques seleccionados y se actualizará el contenido de la página, reemplazando el HTML original con los shortcodes de cada bloque.",
    pageContentAfter: "Contenido de la página (después)",
    pageUpdatedWithBlocks: "Página actualizada con {blocks} bloques creados",
    noContentToAnalyze: "Esta página no tiene contenido para analizar",
    errorUpdating: "Error al actualizar la página",
    deletePage: "Eliminar página",

    analyzeError: "Error al analizar el HTML",

    noBlocksDetected: "No se detectaron bloques reutilizables",

    pageCreatedWithBlocks: "Página creada con {blocks} bloques",
    slugRequired: "El slug es obligatorio",

    errorCreating: "Error al crear la página",
  },

  // Blocks (Website Module)
  blocks: {
    title: "Bloques",

    createBlock: "Crear Bloque",
    editBlock: "Editar Bloque",
    name: "Nombre",

    model: "Modelo",
    content: "Contenido",
    status: "Estado",
    actions: "Acciones",
    shortcode: "Shortcode",
    isActive: "Activo",
    noBlocks: "No hay bloques",
    noBlocksHint: "Crea tu primer bloque usando el botón de arriba",
    searchPlaceholder: "Buscar bloques...",
    contentPlaceholder: "<header>\n  <nav>...</nav>\n</header>",
    created: "Bloque creado correctamente",
    createdCount: "{count} bloques creados correctamente",
    createError: "Error al crear bloques",
    updated: "Bloque actualizado correctamente",
    deleted: "Bloque eliminado correctamente",
    confirmDelete: '¿Deseas eliminar el bloque "{name}"?',
    requiredFields: "El nombre es obligatorio",
    nameRequired: "El nombre del bloque es obligatorio",
    namePlaceholder: "Ej: Header Principal",
    newBlock: "Nuevo Bloque",
    blockActive: "Bloque activo",
    noItemId: "Sin Item ID",
    fromUrl: "Desde URL (?itemId=...)",
    fixedId: "ID fijo",
    errorSaving: "Error al guardar el bloque",
    errorDeleting: "Error al eliminar el bloque",
    types: {},
    modelConfig: "Configuración de Modelo",
    noModel: "Sin modelo",
    itemIdSource: "Origen del Item ID",
    itemIdNone: "Ninguno (aleatorio)",
    itemIdUrl: "Desde URL (?itemId=...)",
    itemIdFixed: "ID fijo (hardcodeado)",
    itemIdSourceHelp: "De dónde obtener el ID del item",
    fixedItemId: "Item ID fijo",
    fixedItemIdPlaceholder: "ID del documento",
    // HTML Import with AI
    importFromHtml: "Importar desde HTML",
    importHtmlHelp:
      "Pega tu código HTML y la IA identificará automáticamente los bloques reutilizables como headers, footers, secciones hero, etc.",
    pasteHtml: "Pega tu código HTML aquí:",
    htmlPlaceholder:
      '<html>\n<head>...</head>\n<body>\n  <header>...</header>\n  <section class="hero">...</section>\n  <footer>...</footer>\n</body>\n</html>',
    analyzeWithAi: "Analizar con IA",
    analyzing: "Analizando...",
    blocksFound: "{count} bloques encontrados",
    analyzeAnother: "Analizar otro HTML",
    selectAtLeastOne: "Selecciona al menos un bloque para crear",
    createSelected: "Crear {count} bloques seleccionados",
    noBlocksFound: "No se encontraron bloques reutilizables en el HTML",
    analyzeError: "Error al analizar el HTML",
    blocksCreated: "{count} bloques creados correctamente",
    someBlocksFailed: "{count} bloques no pudieron ser creados",
    errorCreating: "Error al crear los bloques",
  },

  // Menus (Website Module)
  menus: {
    locations: {},
  },

  // Files (Website Module - CSS/JS)
  files: {
    title: "Archivos",

    createFile: "Crear Archivo",
    editFile: "Editar Archivo",
    name: "Nombre",
    type: "Tipo",
    source: "Origen",
    url: "URL",
    content: "Contenido",
    status: "Estado",
    actions: "Acciones",
    shortcode: "Shortcode",
    isActive: "Activo",
    isExternal: "Archivo externo (CDN)",
    isExternalHint:
      "Activa si el archivo está en un CDN externo (solo URL). Desactiva para código local.",
    noFiles: "No hay archivos",
    noFilesHint:
      "Los archivos CSS/JS se crearán automáticamente al importar HTML o puedes crearlos manualmente",
    searchPlaceholder: "Buscar archivos...",
    nameHint: "Incluye la extensión (.css o .js)",
    created: "Archivo creado correctamente",
    updated: "Archivo actualizado correctamente",
    deleted: "Archivo eliminado correctamente",
    confirmDelete: '¿Deseas eliminar el archivo "{name}"?',

    errorSaving: "Error al guardar el archivo",
    errorDeleting: "Error al eliminar el archivo",
  },

  // Media
  media: {
    title: "Multimedia",

    upload: "Subir Archivo",
    name: "Nombre",
    url: "URL",

    noMedia: "No hay archivos multimedia",
    noMediaHint:
      "Las imágenes se importarán automáticamente del HTML o puedes subirlas manualmente",
    searchPlaceholder: "Buscar multimedia...",
    delete: "Eliminar",
    copyUrl: "Copiar URL",
    urlCopied: "URL copiada al portapapeles",
    copyError: "Error al copiar la URL",
    deleted: "Archivo multimedia eliminado",
    confirmDelete: '¿Deseas eliminar el archivo "{name}"?',
    errorDeleting: "Error al eliminar el archivo",
    uploadHint:
      "Para subir imágenes, usa el editor de páginas o importa HTML con imágenes",
  },

  // Accounting Module
  accounting: {
    journalEntries: "Asientos Contables",

    generateEntry: "Generar Asiento",
    viewEntry: "Ver Asiento",
    editEntry: "Editar Asiento",
    newEntry: "Nuevo Asiento",
    entryNumber: "Número de Asiento",
    entryGenerated: "Asiento Generado Exitosamente",
    errorGenerating: "Error al generar el asiento",
    regenerateEntry: "Regenerar Asiento",
    regenerate: "Regenerar",
    regenerateConfirmText:
      "Esto actualizará el asiento con los datos actuales del documento origen (números de cuenta, montos, etc.)",
    regenerateSuccess: "Asiento Regenerado",
    regenerateSuccessText:
      "El asiento ha sido actualizado con los datos actuales.",
    regenerateError: "Error al regenerar el asiento",
    regenerateEntryGone: "El documento ya no genera este asiento: se quitó del diario.",
    regenerateAll: "Regenerar todo",
    regenerateAllConfirmText:
      "Se rearman los asientos de todos los documentos que muestra el diario con los filtros actuales, con los datos de hoy (cuentas, contacto, montos). Los asientos manuales no se tocan; los de cobros y pagos se vuelven a numerar.",
    regenerateAllDone: "Asientos regenerados",
    regenerateAllResult: "{resynced} de {documents} documentos actualizados.",
    regenerateAllSkipped: "{count} sin documento de origen (borrado o en la papelera).",
    regenerateAllErrors: "{count} con error.",

    generateAllEntries: "Generar Todos los Asientos",
    confirmGenerateAll: "¿Generar Todos los Asientos?",
    confirmGenerateAllText:
      "Esto generará asientos contables para todas las transacciones pendientes en esta operación.",
    generate: "Generar",
    generationResults: "Resultados de Generación",
    generated: "Generados",
    skipped: "Omitidos",
    errors: "Errores",
    entriesGenerated: "Asientos Generados",
    noNewEntries: "Sin Nuevos Asientos",
    allEntriesExist:
      "Todos los asientos contables ya existen para esta operación.",
    export: "Exportar a Excel",
    exportExcel: "Exportar a Excel",
    exportCSV: "Exportar a CSV",

    noEntries: "No se encontraron asientos contables",
    noEntriesHint:
      "Genera asientos desde la pestaña Finance de un Shipping o Proforma",
    searchPlaceholder: "Buscar por concepto, cuenta...",
    totalItems: "{count} asiento(s)",
    showingItems: "Mostrando {from}-{to} de {total}",

    // Date fields
    date: "Fecha",
    dateFrom: "Fecha Desde",
    dateTo: "Fecha Hasta",
    day: "Día",
    year: "Año",
    month: "Mes",

    accountNumber: "Número de Cuenta",
    accountName: "Nombre de Cuenta",
    searchAccount: "Buscar por número o nombre…",
    accountNotInChart: "No está en el plan de cuentas",
    chooseAccounts: "Elegí la cuenta del debe y del haber",
    debit: "Debe",
    credit: "Haber",

    // Transaction fields
    concept: "Concepto",
    conceptPlaceholder: "ej., COBRO ANTICIPO PI 4803/2025",
    amount: "Monto",
    total: "Total",
    currency: "Moneda",
    notes: "Notas",
    notesPlaceholder: "Notas adicionales (opcional)",
    sourceDocument: "Documento Origen",
    entryType: "Tipo de Asiento",

    // Currency names
    currencies: {
      ARS: "Peso Argentino",
      USD: "Dólar Estadounidense",
      EUR: "Euro",
      GBP: "Libra Esterlina",
      CNY: "Yuan Chino",
    },

    // Entry types
    types: {
      collect_advance: "Cobro Anticipo Cliente",
      collect_balance: "Cobro Saldo Cliente",
      payment_advance: "Pago Anticipo Proveedor",
      payment_expense: "Pago de Gasto",
      payment_bank_to: "Pago cuenta bancaria (destino)",
      invoice_client: "Factura a Cliente",
      expense_load: "Carga de Gasto",

      other: "Manual / Otro",
    },

    // Delete all
    deleteAll: "Eliminar Todos",
    deleteAllConfirmTitle: "¿Eliminar todos los asientos?",
    deleteAllConfirmText:
      "Esta acción eliminará TODOS los asientos contables. Esta acción no se puede deshacer.",
    deleteAllWarning: "¡ADVERTENCIA: Esta acción es irreversible!",
    typeToConfirm: "Escribe 'delete all' para confirmar",
    typeDeleteAllToConfirm: "Debes escribir 'delete all' para confirmar",
    deleteAllSuccess: "Asientos eliminados",
    deleteAllSuccessText: "Se eliminaron {count} asiento(s) exitosamente.",
    deleteAllError: "Error al eliminar todos los asientos",

    // Pestañas del diario
    tabEntries: "Asientos",
    issues: {
      tab: "No generados",
      intro:
        "Documentos que no generaron su asiento y asientos que salieron con una cuenta faltante. Cada fila dice por qué y qué hay que corregir; después de corregirlo, tocá «Reintentar».",
      loading: "Revisando documentos…",
      empty: "No hay asientos pendientes: todo lo que debía contabilizarse tiene su asiento completo.",
      toFix: "Qué corregir",
      toFixHint: "Lo que más asientos destraba, primero.",
      affects: "{count} asiento(s)",
      showMore: "Ver todo",
      showLess: "Ver menos",
      filterKind: "Problema",
      filterSource: "Documento",
      searchPlaceholder: "Documento, contacto, embarque…",
      document: "Documento",
      date: "Fecha",
      amount: "Monto",
      reason: "Por qué no salió",
      fix: "Qué hacer",
      retry: "Reintentar",
      retryAll: "Generar {count} asiento(s)",
      retryAllHint: "{count} documento(s) no tienen nada para corregir: solo falta generar o rearmar su asiento.",
      retryAllProgress: "Generando {done} de {total}…",
      retryAllConfirmTitle: "¿Generar {count} asiento(s)?",
      retryAllConfirmText: "Se rearman los asientos de esos documentos con los datos que tienen hoy. Puede tardar unos minutos: no cierres la pantalla.",
      retryAllDone: "Se generaron {count} asiento(s)",
      retryAllStill: "{count} documento(s) siguen en la lista ({failed} con error): revisá su motivo.",
      retryDone: "Asientos rearmados",
      retryStill: "El documento sigue con un problema: revisá el motivo.",
      retryError: "No se pudo reintentar",
      open: "Abrir",
      openContact: "Abrir contacto",
      openBankAccount: "Abrir cuenta bancaria",
      openShipping: "Abrir embarque",
      kinds: {
        missing: "Sin asiento",
        incomplete: "Asiento incompleto",
      },
      sources: {
        collect: "Cobro",
        payment: "Pago",
        shipping: "Factura de venta",
        shipping_expenses: "Gasto",
        notacomercial: "Nota comercial",
      },
      reasons: {
        contact_without_account: "El contacto «{name}» no tiene número de cuenta contable.",
        stale_contact_account: "El asiento salió sin la cuenta del contacto «{name}», que ahora ya la tiene.",
        bank_without_account: "La cuenta bancaria «{name}» no tiene número de cuenta contable.",
        stale_bank_account: "El asiento salió sin la cuenta de «{name}», que ahora ya la tiene.",
        expense_type_without_code: "El tipo de gasto «{type}» no tiene código contable.",
        paid_expense_without_invoice: "El pago está aplicado al gasto «{expense}» del embarque {shipping}, que no tiene número de factura.",
        before_start: "La fecha {date} es anterior al inicio de la contabilidad ({startDate}).",
        nota_unsupported: "A la nota le falta: {missing}.",
        nota_unsupported_combination: "Esa combinación de crédito/débito, dirección y rol del contacto no lleva asiento.",
        not_generated: "Tiene todos los datos, pero el asiento no se generó.",
        error: "Error al armar el asiento: {message}",
      },
      fixes: {
        contact_without_account: "Cargá el número de cuenta contable en la ficha del contacto y tocá Reintentar.",
        stale_contact_account: "Tocá Reintentar para rearmar el asiento.",
        bank_without_account: "Cargá el número de cuenta contable en la cuenta bancaria y tocá Reintentar.",
        stale_bank_account: "Tocá Reintentar para rearmar el asiento.",
        expense_type_without_code: "Cargá el código contable del tipo de gasto en su lista (Ajustes → Listas) y tocá Reintentar.",
        paid_expense_without_invoice: "Cargá el número de factura del gasto en el embarque y tocá Reintentar.",
        before_start: "Si la fecha está mal, corregila en el documento. Si es correcta, no lleva asiento y no hay nada que hacer.",
        nota_unsupported: "Completá esos datos en la nota y tocá Reintentar.",
        not_generated: "Tocá Reintentar para generarlo.",
        error: "Avisá a soporte con el nombre del documento.",
      },
      notaFields: {
        credit_debit: "crédito o débito",
        flow_direction: "dirección (damos o recibimos)",
        contact_role: "rol del contacto",
      },
      groups: {
        contact_without_account: "Contacto «{name}» sin número de cuenta contable",
        bank_without_account: "Cuenta bancaria «{name}» sin número de cuenta contable",
        expense_type_without_code: "Tipo de gasto «{type}» sin código contable",
      },
    },
  },

  // Email module translations
  emails: {
    title: "Emails",
    subtitle: "Gestión de emails automatizados y notificaciones",
    templates: "Plantillas",
    triggers: "Disparadores",
    logs: "Historial",
    configuration: "Configuración",

    // Emails escritos en código (solo lectura)
    codeEmails: "Emails",
    codeEmailsIntro:
      "Estos son los emails que el sistema manda solo, escritos en código: cuándo salen, a quién le llegan y qué dicen vive en el código, así que acá se ven pero no se editan; lo que sí se puede es apagar los que no se usan. El mismo aviso que sale cuando te mencionan en un ticket de soporte, por ejemplo, es uno de estos.",
    noCodeEmails: "Todavía no hay emails escritos en código",
    codeEmailWhen: "Cuándo sale",
    codeEmailRecipients: "A quién le llega",
    codeEmailLastSent: "Último envío",
    codeEmailSentCount: "{count} enviado(s)",
    codeEmailNeverSent: "Nunca salió",
    codeEmailNeverSentHint: "Este aviso todavía no salió en esta empresa.",
    codeEmailLastSentEmail: "El último que salió",
    codeEmailSample: "Cómo se ve el email",
    codeEmailSampleHint: "Ejemplo con datos inventados, para ver cómo queda armado el email.",
    codeEmailHistoryName: "Nombre en el historial",
    codeEmailSource: "Archivo",
    view: "Ver",
    codeEmailAlways: "Siempre",
    codeEmailNoFixedRecipients: "nadie",
    codeEmailEditFixedRecipients: "Editar destinatarios fijos",
    codeEmailFixedRecipientsTitle: "Destinatarios fijos",
    codeEmailFixedRecipientsHint:
      "A estas casillas les llega este email cada vez que sale, además de las personas a las que le toca según el registro.",
    codeEmailAddRecipient: "Agregar",
    codeEmailInvalidEmails: "Estas direcciones no son válidas: {emails}",
    codeEmailFixedRecipientsSaved: "Destinatarios fijos guardados",
    codeEmailEnabled: "Activo",
    codeEmailEnabledHint: "Destildalo para que este email deje de salir en esta empresa.",
    codeEmailDisabledBadge: "Apagado",
    codeEmailEnabledSaved: "Email encendido",
    codeEmailDisabledSaved: "Email apagado: no se va a enviar",
    codeEmailHistoryTitle: "Emails enviados",
    codeEmailHistoryTotal: "{count} en total",
    otherGroup: "Otros",

    // Templates
    createTemplate: "Crear Plantilla",
    editTemplate: "Editar Plantilla",
    searchTemplates: "Buscar plantillas...",
    noTemplates: "No hay plantillas",
    noTemplatesHint: "Crea tu primera plantilla de email para comenzar",
    name: "Nombre",
    subject: "Asunto",
    content: "Contenido",
    description: "Descripción",
    model: "Modelo",
    noModel: "Sin modelo",
    modelHint: "Selecciona un modelo para usar shortcodes dinámicos",
    subjectHint: "Puedes usar shortcodes como {{client.name}}",
    contentHint:
      "Escribe el contenido del email. Usa {{campo}} para datos dinámicos",
    contentPlainOrHtml: "Texto plano o HTML",
    templateLanguage: "Idioma del template",
    templateLanguageHint: "El asunto y cuerpo de arriba son para este idioma.",
    translations: "Traducciones",
    translationsHint:
      "Añade versiones en otros idiomas. Puedes modificar el texto pero mantén los shortcodes ({{ ... }}) igual que en el template principal.",
    addLanguage: "Añadir",
    removeTranslation: "Quitar",
    loadShortcodes: "Cargar Shortcodes",

    senderName: "Nombre del remitente",
    replyTo: "Responder a",
    senderUseDefaultHint:
      "Déjalo vacío para usar el remitente por defecto de Configuración.",
    sendInLanguage: "Enviar en idioma",
    addMoreLanguagesHint:
      "Para añadir más idiomas, edita esta plantilla en Emails > Plantillas.",
    noLanguagesConfiguredHint:
      "Esta plantilla no tiene idiomas configurados. Ve a Emails > Plantillas, edita la plantilla, asigna el idioma del template y añade traducciones.",
    exportTemplatesHint:
      "Solo se muestran plantillas sin modelo de documento (un listado o reporte no tiene un documento único para shortcodes).",
    noExportTemplatesHint:
      "No hay plantillas sin modelo. Crea una plantilla sin asignar modelo en Emails > Plantillas para usarla aquí.",
    smartEmailSendModeTitle: "¿Cómo se envían los emails?",
    smartEmailSendModeIntro:
      "Elegí cómo sale el email cuando alguien aprieta «Enviar por email» en un documento o un listado.",
    smartEmailModeClientTitle: "Desde mi Outlook (u otro programa de correo)",
    smartEmailModeClientDescription:
      "El sistema arma el email completo (destinatarios, asunto, texto en el idioma elegido y el PDF o Excel adjunto) y lo baja como borrador. Al abrirlo se abre en tu Outlook listo para enviar desde tu casilla: solo apretás «Enviar».",
    smartEmailModeClientPro1: "No pide claves, permisos ni cambios en el dominio de tu empresa.",
    smartEmailModeClientPro2: "El email sale desde tu casilla y queda en tus Enviados, como siempre.",
    smartEmailModeClientCon: "No se manda solo desde el sistema: es un click más en Outlook.",
    smartEmailModeServerTitle: "Directo desde el sistema",
    smartEmailModeServerDescription:
      "El email sale desde nuestro servidor de envíos con el remitente que indiques abajo, sin abrir tu correo.",
    smartEmailModeServerReq:
      "Para que salga con una casilla de tu empresa, quien administra tu dominio tiene que cargar unos registros DNS (DKIM y verificación) que aparecen acá mismo, listos para copiar. Sin eso, los emails caen en spam o los rechazan.",
    smartEmailModeServerCon:
      "El email no queda en los Enviados de tu casilla. Para tener copia, agregate como destinatario.",
    smartEmailSenderEmail: "Remitente (email)",
    smartEmailSenderName: "Remitente (nombre)",
    smartEmailSenderHint:
      "Vacío = sale desde la casilla general del sistema. Al cargar una casilla propia aparecen abajo los registros DNS de tu dominio.",
    smartEmailSenderInvalid: "El email del remitente no es válido.",
    smartEmailDnsTitle: "Registros DNS para",
    smartEmailDnsIntro:
      "Pasale estos registros a quien administra tu dominio (o cargalos vos en tu proveedor: GoDaddy, Cloudflare, Route 53, Nic.ar…). Copiá cada host y valor tal cual. Cuando estén cargados, apretá «Verificar».",
    smartEmailDnsType: "Tipo",
    smartEmailDnsHost: "Host / Nombre",
    smartEmailDnsValue: "Valor",
    smartEmailDnsRecordOk: "Registro verificado",
    smartEmailDnsRecordPending: "Todavía no se encontró",
    smartEmailDnsAuthenticated: "Dominio verificado",
    smartEmailDnsPending: "Falta cargar los registros",
    smartEmailDnsVerify: "Verificar",
    smartEmailDnsVerifyHint: "Los cambios de DNS pueden tardar unas horas en verse.",
    smartEmailDnsNotYet: "Todavía no se ven todos los registros. Si recién los cargaste, probá de nuevo en un rato.",
    smartEmailDnsCopied: "Copiado",
    smartEmailDraftDownloaded: "Borrador listo",
    smartEmailDraftDownloadedText:
      "Se bajó el email como borrador. Abrilo: se abre en tu Outlook con todo cargado y solo tenés que apretar «Enviar».",
    smartEmailOpenInMailClient: "Abrir en mi correo",
    enableSmartEmail: "Activar Smart Email",
    enableSmartEmailHint:
      "Permitir enviar documentos (PDF) y exportaciones de listados/reportes (Excel) por email con un clic.",
    pdfInPageLanguageHint:
      "El PDF está en el idioma actual de la página. El asunto y el cuerpo del email se envían en el idioma seleccionado.",
    pdfInSelectedLanguageHint: "El PDF está en el idioma seleccionado.",
    pdfLanguage: "Idioma del PDF",
    regeneratingPdf: "Regenerando PDF en el idioma seleccionado...",
    pdfRegenerateError: "No se pudo generar el PDF en el idioma seleccionado.",
    isActive: "Activo",
    private: "Privado",
    privateTemplateHint:
      "Solo tú puedes ver, editar y usar esta plantilla. No aparecerá en el listado ni en Enviar por email para otros usuarios.",

    templateCreated: "Plantilla creada exitosamente",
    templateUpdated: "Plantilla actualizada exitosamente",
    templateDeleted: "Plantilla eliminada exitosamente",
    confirmDelete: "¿Eliminar la plantilla '{name}'?",

    // Triggers
    createTrigger: "Crear Disparador",
    editTrigger: "Editar Disparador",
    noTriggers: "No hay disparadores",
    noTriggersHint: "Crea un disparador para automatizar el envío de emails",
    template: "Plantilla",
    selectTemplate: "Seleccionar plantilla",
    triggerType: "Tipo de disparador",
    triggerConfig: "Configuración",
    eventTrigger: "Por evento",
    scheduleTrigger: "Programado",
    manualTrigger: "Manual",
    executions: "Ejecuciones",
    allTypes: "Todos los tipos",

    // Event config
    eventConfig: "Configuración del evento",
    eventType: "Tipo de evento",
    selectEvent: "Seleccionar evento",
    afterInsert: "Después de crear",
    afterSave: "Después de guardar",
    afterUpdate: "Después de actualizar",
    afterDelete: "Después de eliminar",
    afterAppliedtoChange: "Después de cambiar appliedto",
    eventModel: "Modelo",
    selectModel: "Seleccionar modelo",
    eventConditions: "Condiciones (JSON)",
    eventConditionsHint: '{"paid": {"$changedTo": true}}',
    eventConditionsExample: 'Ejemplo: {"paid": true} (en update solo si el campo cambió) o {"paid": {"$changedTo": true}}',
    invalidConditions: "Las condiciones no son JSON válido",

    // Schedule config
    scheduleConfig: "Configuración del horario",
    scheduleType: "Frecuencia",
    selectSchedule: "Seleccionar frecuencia",
    once: "Una vez",
    daily: "Diariamente",
    weekly: "Semanalmente",
    monthly: "Mensualmente",
    scheduleTime: "Hora",
    scheduleDate: "Fecha",
    dayOfWeek: "Día de la semana",
    dayOfMonth: "Día del mes",
    sunday: "Domingo",
    monday: "Lunes",
    tuesday: "Martes",
    wednesday: "Miércoles",
    thursday: "Jueves",
    friday: "Viernes",
    saturday: "Sábado",

    // Recipient config
    recipientConfig: "Configuración de destinatarios",

    recipientField: "Campo del modelo",
    recipientFieldHint:
      "Expandí el árbol y hacé clic en una ruta de email o usuario para agregarla o quitarla.",
    recipientFieldMaxDepthHint:
      "Máximo {depth} niveles de referencias (misma profundidad que expanded).",
    recipientPathsRejected:
      "Rutas fuera del límite de profundidad ({depth}): {paths}",
    recipientFieldTypeEmail: "Email",
    recipientFieldTypeUser: "Usuario",
    recipientFieldsSelected: "Destinatarios seleccionados",
    recipientFieldsSelectedEmpty: "Ninguno. Expandí el árbol y hacé clic en una ruta.",
    recipientExampleItem: "Registro de ejemplo",
    recipientExampleItemSelected: "Ejemplo: {label}",
    recipientExampleItemEmpty: "Este registro no tiene datos para previsualizar valores.",
    recipientExampleItemLoadError: "No se pudo cargar el registro de ejemplo.",
    modelForRecipientFields: "Modelo para campos de email",
    selectModelForEmailFields:
      "Selecciona el modelo del evento o el modelo de la plantilla para ver los campos.",
    expandGroup: "Expandir grupo",
    collapseGroup: "Contraer grupo",
    noEmailFieldsFound:
      "No se encontraron campos de email para este modelo.",
    noMatchingEmailFields: "Ningún campo coincide con la búsqueda.",
    noShortcodeFields: "No hay shortcodes. Cargá datos de ejemplo primero.",

    previewWithItem: "Vista con registro",
    previewWithItemTitle: "Vista previa del email",
    previewWithItemHint:
      "Buscá un registro de {model} y renderizá la plantilla con datos reales (mismo motor que al enviar).",
    previewSearchItem: "Registro",
    previewSearchItemPlaceholder: "Buscar por nombre, número o texto…",
    previewNoItemsFound: "No se encontraron registros.",
    previewRendering: "Generando vista previa…",
    previewSelectItemHint: "Seleccioná un registro para ver la vista previa.",
    previewSearchError: "No se pudo buscar registros.",
    previewRenderError: "No se pudo generar la vista previa.",
    previewWithItemMissingSource:
      "Seleccioná un modelo o reporte y agregá contenido primero.",
    previewRecipientsTitle: "Destinatarios",
    previewRecipientsNoTemplate:
      "Guardá la plantilla para ver destinatarios según sus triggers.",
    previewRecipientsNoTriggers: "No hay triggers activos con esta plantilla.",
    previewRecipientsNone:
      "Sin destinatarios para este registro con la configuración actual.",
    previewRecipientsByTrigger: "Por trigger",
    previewRecipientsConditionsNotMet: "No se cumplen las condiciones para este registro",
    previewRecipientsConditionsNotMetShort: "condiciones no cumplidas",

    recipientUsers: "Usuarios del sistema",
    emailField: "Campo de email",
    fixedEmails: "Emails fijos",
    separateByComma: "Separar con comas",
    selectUsers: "Seleccionar usuarios",
    selectUsersHint:
      "Selecciona uno o más usuarios del sistema para recibir los emails",

    triggerCreated: "Disparador creado exitosamente",
    triggerUpdated: "Disparador actualizado exitosamente",
    triggerDeleted: "Disparador eliminado exitosamente",
    triggerActivated: "Disparador activado",
    triggerDeactivated: "Disparador desactivado",
    confirmDeleteTrigger: "¿Eliminar el disparador '{name}'?",

    // Data source config
    dataSourceConfig: "Fuente de datos",

    dataSource: "Fuente de datos",

    useReport: "Usar reporte",

    selectReport: "Seleccionar reporte",
    reportHint: "Los datos del reporte se usarán para el template del email",

    // Logs
    searchLogs: "Buscar en historial...",
    noLogs: "No hay registros",
    noLogsHint: "Los emails enviados y en cola aparecerán aquí",
    logSourceItem: "Ítem origen",
    date: "Fecha",
    to: "Para",
    from: "De",
    trigger: "Disparador",
    status: "Estado",
    actions: "Acciones",
    viewDetails: "Ver detalles",
    retry: "Reintentar",
    retrySuccess: "Email reenviado correctamente",
    retryFailed: "No se pudo reintentar el envío del email",
    emailDetails: "Detalles del email",
    logBodyNotStored:
      "Usá «Vista previa del email» para renderizar el mensaje con la plantilla actual.",
    previewEmailBody: "Vista previa del email",
    previewEmailBodyLoading: "Cargando vista previa…",
    previewEmailBodyPreview:
      "Vista previa renderizada al vuelo con la plantilla y el registro actual.",
    previewEmailBodyDeleteSnapshot:
      "Vista previa con datos guardados antes de eliminar la línea.",
    previewEmailBodyUnavailable: "Vista previa no disponible para este registro.",
    previewEmailBodyEndpointMissing:
      "No se encontró el endpoint de vista previa. Reiniciá el backend con el módulo email actualizado.",
    queuedBodyPreview: "Vista previa no disponible hasta que se envíe el correo.",
    showing: "Mostrando",
    of: "de",
    allStatuses: "Todos los estados",
    sent: "Enviado",
    pending: "Pendiente",
    queued: "En cola",
    queuedRetry: "Reintentando envío",
    sending: "Enviando",
    failed: "Fallido",
    bounced: "Rebotado",
    opened: "Abierto",
    clicked: "Click",
    error: "Error",

    // Config
    brevoConfig: "Configuración de Brevo",
    brevoApiKey: "API Key de Brevo",
    apiKeyConfigured: " (configurada)",
    enterApiKey: "Ingresa tu API Key de Brevo",
    brevoApiKeyHint: "Obtén tu API Key en ",
    testConnection: "Probar conexión",
    connectionSuccess: "Conexión exitosa",
    connectionFailed: "Error de conexión",
    account: "Cuenta",
    plan: "Plan",
    enabled: "Habilitado",
    disabled: "Deshabilitado",

    senderSettings: "Configuración del remitente",
    defaultSenderEmail: "Email del remitente",
    defaultSenderName: "Nombre del remitente",
    defaultReplyTo: "Responder a",

    generalSettings: "Configuración general",
    enableEmailSending: "Habilitar envío de emails",
    enableEmailSendingHint:
      "Activa esta opción para permitir el envío de emails",
    testMode: "Modo de prueba",
    testModeHint:
      "En modo prueba, todos los emails se envían al email de prueba",
    testEmail: "Email de prueba",
    testEmailPlaceholder: "test@example.com",
    testEmailHint:
      "Todos los emails se enviarán a esta dirección en modo prueba",

    rateLimits: "Límites de envío",
    maxEmailsPerHour: "Máx. emails por hora",
    maxEmailsPerDay: "Máx. emails por día",
    currentUsage: "Uso actual",
    hour: "hora",
    day: "día",

    sendTestEmail: "Enviar email de prueba",
    testRecipient: "Destinatario de prueba",
    enterEmail: "Ingresa un email",
    sendTest: "Enviar prueba",
    testEmailSent: "Email de prueba enviado exitosamente",

    saveConfiguration: "Guardar Configuración",
    configSaved: "Configuración guardada exitosamente",
    senderRequired: "Email y nombre del remitente son requeridos",
    requiredFields: "Por favor completa todos los campos requeridos",
    errorLoading: "Error al cargar datos",
    errorSaving: "Error al guardar",
    errorDeleting: "Error al eliminar",

    errorToggling: "Error al cambiar estado",

    // Scheduled triggers
    nextExecution: "Próxima ejecución",
    runNow: "Ejecutar ahora",
    runTriggerNow: "Ejecutar disparador",
    confirmRunTrigger: "¿Deseas ejecutar el disparador '{name}' ahora?",
    triggerExecuted: "Disparador ejecutado exitosamente",
    triggerExecutionFailed: "La ejecución del disparador falló parcialmente",
    errorRunningTrigger: "Error al ejecutar el disparador",
  },

  // Calendar Sync
  notificationPrefs: {
    all: "Todos",
    title: "Mis notificaciones",
    intro: "Elegí qué avisos te llegan a vos. No cambia nada para el resto de los usuarios.",
    mobileApp: "App móvil",
    email: "Email",
    emailNote: "Si apagás un email, el aviso al teléfono te sigue llegando mientras lo tengas prendido arriba.",
    noEmails: "No hay emails automáticos activos en esta empresa.",
    deviceEnable: "Activar en este dispositivo",
    deviceDisable: "Desactivar en este dispositivo",
    device: {
      on: "Las notificaciones están activadas en este dispositivo.",
      off: "Las notificaciones no están activadas en este dispositivo.",
      "needs-install": "En iPhone las notificaciones funcionan solo con la app instalada en la pantalla de inicio.",
      unsupported: "Este navegador no admite notificaciones. Activalas desde la app del teléfono.",
    },
    groups: {
      Pagos: "Pagos",
      Cobros: "Cobros",
      Soporte: "Soporte",
      Novedades: "Novedades",
      other: "Otros avisos",
    },
    pushOnly: {
      "agent-chat": {
        name: "Respuestas del Agente IA",
        description: "Cuando el Agente IA termina de responderte en el chat.",
      },
      "agent-proposals": {
        name: "Propuestas del día del Agente IA",
        description: "De lunes a viernes a las 9, lo que el asistente te propone para arrancar el día.",
      },
      "other-emails": {
        name: "Otros emails",
        description: "Cualquier otro email del sistema que te llegue (disparadores, envíos manuales…).",
      },
    },
  },

  calendarSync: {
    syncWithGoogleCalendar: "Sincronizar con Google Calendar",
    syncCalendar: "Sincronizar Calendario",
    calendarSynchronization: "Sincronización de Calendario",
    syncDescription:
      "Sincroniza tus eventos con Google Calendar, Outlook o cualquier aplicación de calendario que soporte feeds iCal.",
    yourCalendarFeedUrl: "Tu URL de Calendario",
    copyUrl: "Copiar URL",
    urlCopied: "URL copiada al portapapeles",
    created: "Creado",
    lastSync: "Última sincronización",
    syncCount: "Sincronizaciones",
    howToAddToGoogleCalendar: "¿Cómo agregar a Google Calendar?",
    copyTheUrl: "Copiar la URL",
    copyUrlDescription:
      "Haz clic en el botón de copiar arriba para copiar tu URL personal de calendario.",
    openGoogleCalendar: "Abrir Google Calendar",
    goTo: "Ir a",
    addCalendarByUrl: "Agregar calendario por URL",
    addCalendarByUrlDescription:
      'En la barra lateral izquierda, haz clic en el + junto a "Otros calendarios". Selecciona "Desde URL"',
    pasteTheUrl: "Pegar la URL",
    pasteUrlDescription:
      'Pega la URL copiada y haz clic en "Agregar calendario"',
    done: "¡Listo!",
    doneDescription:
      "Tus eventos aparecerán en Google Calendar. Puede tardar unos minutos para la primera sincronización.",
    note: "Nota",
    syncNote:
      "Google Calendar típicamente actualiza calendarios externos cada 12-24 horas. Puedes forzar una actualización eliminando y volviendo a agregar el calendario.",
    eventsTimeframeNote:
      "Se mostrarán los eventos de 30 días en adelante. Aquellos más antiguos que 30 días irán desapareciendo de tu calendario cuando se cumpla ese plazo, eso hace que la carga de sincronización no acumule eventos viejos provocando una tardanza al cargar.",
    otherCalendarApps: "Otras aplicaciones de calendario",
    outlookInstructions:
      "Configuración → Calendario → Calendarios compartidos → Suscribirse desde web",
    appleCalendarInstructions: "Archivo → Nueva suscripción a calendario",
    thunderbirdInstructions: "Nuevo calendario → En la red → iCalendar (ICS)",
    regenerateUrl: "Regenerar URL",
    regenerateWarning:
      "Usa esto si tu URL fue comprometida. La URL anterior dejará de funcionar.",
    regenerateUrlConfirm: "¿Regenerar URL?",
    regenerateUrlWarning:
      "La URL actual dejará de funcionar. Deberás actualizar la URL en todas tus aplicaciones de calendario.",
    yesRegenerate: "Sí, regenerar",
    urlRegenerated: "URL regenerada exitosamente",
    errorLoadingConfig: "Error al cargar configuración de sincronización",
    errorRegeneratingUrl: "Error al regenerar URL",
    close: "Cerrar",
    regenerating: "Regenerando...",
  },

  // Instance Builder
  instanceBuilder: {
    title: "Instance Builder",
    subtitle:
      "Describe qué aplicación necesitas y la IA generará la configuración",
    describeApp: "Describe tu aplicación",
    placeholder:
      "Ej: Necesito un sistema para gestionar una inmobiliaria con propiedades, clientes, contratos y pagos...",
    orChooseExample: "O elige un ejemplo:",
    generate: "Generar configuración",
    generating: "Generando...",
    waitMessage:
      "La IA está procesando tu solicitud. Esto puede tardar hasta 2 minutos...",
    modifyConfig: "Modificar configuración",
    generatedConfig: "Configuración generada",
    simpleView: "Vista simple",
    viewJson: "Ver JSON",
    lists: "Listados",
    models: "Modelos",
    fields: "campos",
    values: "valores",
    startOver: "Empezar de nuevo",
    previewChanges: "Vista previa de cambios",
    applyConfig: "Aplicar configuración",
    applying: "Aplicando...",
    configApplied: "¡Configuración aplicada!",
    modelsCreated: "Modelos creados",
    listsCreated: "Listas creadas",
    viewModels: "Ver modelos",
    createMore: "Crear más",
    newModels: "Modelos nuevos",
    newLists: "Listas nuevas",
    none: "Ninguno",
    overwriteExisting: "Sobrescribir modelos/listas existentes",
    cancel: "Cancelar",
    confirmApply: "Confirmar y aplicar",
    chatPlaceholder: "Ej: Agrega un campo de teléfono al modelo Cliente...",
    configGenerated:
      "He generado una configuración con {models} modelos y {lists} listas. ¿Quieres hacer algún cambio?",
    changesAdded:
      "He agregado los cambios a la configuración. Puedes verlos en el panel de la derecha.",
    modified:
      "He modificado {target}. Los cambios están reflejados en la configuración.",
    deleted: "He eliminado {target} de la configuración.",
    notUnderstood:
      "No entendí bien qué cambio quieres hacer. ¿Puedes ser más específico?",
    chatError:
      "Hubo un error al procesar tu mensaje. Por favor, intenta de nuevo.",
    // Suggestions
    suggestions: {
      realEstate: "Inmobiliaria",
      realEstateDesc:
        "Sistema de gestión inmobiliaria con propiedades, propietarios, clientes interesados, contratos de alquiler y venta, y seguimiento de pagos",
      gym: "Gimnasio",
      gymDesc:
        "Sistema para gimnasio con clientes, membresías, clases, instructores, y registro de asistencia",
      veterinary: "Veterinaria",
      veterinaryDesc:
        "Sistema para clínica veterinaria con mascotas, dueños, historial médico, vacunas, citas y tratamientos",
      restaurant: "Restaurante",
      restaurantDesc:
        "Sistema para restaurante con mesas, reservas, pedidos, menú con platos y categorías, y facturación",
      school: "Escuela",
      schoolDesc:
        "Sistema escolar con estudiantes, profesores, materias, calificaciones, asistencia y comunicados",
      ecommerce: "E-commerce",
      ecommerceDesc:
        "Tienda online con productos, categorías, clientes, pedidos, carrito y métodos de pago",
    },
  },

  // Support Module Translations
  "Ticket Type": "Tipo de Ticket",
  Deploy: "Deployar",
  Deployed: "Deployado",
  "Deploy feature to main": "Deployar feature a main",
  "This will merge only this feature branch into main":
    "Esto mergeará solo esta rama feature a main",
  "Feature merged to main": "Feature mergeada a main",
  "Feature branch": "Rama feature",
  "Categorize ticket": "Categorizar ticket",
  "Open in new tab": "Abrir en nueva pestaña",
  "Branch status": "Estado de la rama",
  "Ready for test": "Listo para probar",
  Ready: "Ready",
  "Resolved all": "Resolver todas",
  "Move all Ready tickets to Resolved": "Pasar todos los tickets Ready a Resolved",
  "Move {count} Ready tickets to Resolved?":
    "¿Seguro que querés pasar los {count} tickets Ready a Resolved?",
  "{count} of them have no feature assigned":
    "{count} de ellos no tienen feature asociado.",
  "{resolved} resolved, {failed} failed":
    "{resolved} resueltos, {failed} con error",
  "Task without feature": "Tarea sin feature",
  "Closing task without feature warning":
    "Estás a punto de cerrar una tarea que no tiene feature asociado, ¿estás seguro? Esto puede hacer que no encuentres tu trabajo más adelante.",
  "Task done directly on main branch":
    "Esta tarea se hizo directamente en rama main, no tiene feature creado",
  "Moving...": "Moviendo…",
  "Change status of selected": "Cambiar estado de seleccionados",
  "Apply status": "Aplicar estado",
  "Move {count} tickets to {status}?": "¿Pasar {count} tickets a {status}?",
  "None of the selected tickets can change to {status}":
    "Ningún ticket seleccionado se puede pasar a {status}",
  "{updated} updated, {failed} failed": "{updated} actualizados, {failed} con error",
  "Check the box to continue": "Marcá la casilla para poder continuar",
  "Merged to main": "Mergeado a main",
  "Deploy failed": "Deploy falló",
  "Open test link": "Abrir enlace de prueba",
  Features: "Features",
  "Features in test": "Features en test",
  "Waiting in test": "Tickets esperando en test",
  "No tickets waiting in test": "No hay tickets esperando en test",
  "Error loading tickets waiting in test":
    "Error al cargar tickets esperando en test",
  "Assign feature": "Asignar feature",
  "Assign a feature first": "Asigná una feature primero",
  "No feature": "Sin feature",
  "Feature assigned to ticket": "Feature asignada al ticket",
  "Error assigning feature": "Error al asignar feature",
  "No related ticket": "Sin ticket relacionado",
  Ticket: "Ticket",
  "No pending features in test": "No hay features pendientes en test",
  "No commits": "Sin commits",
  "Error loading pending features": "Error al cargar features pendientes",
  "Create test version": "Crear versión test",
  "Update test": "Actualizar test",
  "Create test version confirm":
    "Se creará la base de datos {db} como copia completa de producción. Puede tardar varios minutos.",
  "Update test confirm":
    "Se reemplazará {db} con una copia completa de producción. Los datos actuales de test se sobrescribirán. Puede tardar varios minutos.",
  "Test environment created": "Versión test creada",
  "Test environment updated": "Versión test actualizada",
  "Error syncing test environment": "Error al sincronizar la versión test",

  // Support tickets UI (pantalla forzada a español)
  "Technical support": "Soporte técnico",
  "Support Tickets": "Tickets de soporte",
  "View and manage your support tickets":
    "Ver y gestionar tus tickets de soporte",
  "Create Ticket": "Crear ticket",
  "Create Support Ticket": "Crear ticket de soporte",
  "Create Your First Ticket": "Crear tu primer ticket",
  "Back to tickets": "Volver a tickets",
  Bugs: "Bugs",
  Developments: "Desarrollos",
  Pending: "Pendiente",
  "In Progress": "En progreso",
  Resolved: "Resuelto",
  Cancelled: "Cancelado",
  Priority: "Prioridad",
  High: "Alta",
  Medium: "Media",
  Low: "Baja",
  "High - I cannot continue working without this":
    "Alta — no puedo seguir trabajando sin esto",
  "Medium - It's serious but I can continue":
    "Media — es serio pero puedo continuar",
  "Low - It's not serious": "Baja — no es grave",
  "Drag and drop to change order; the first 3 are priority.":
    "Arrastrá y soltá para cambiar el orden; los primeros 3 son prioridad.",
  "Tickets are sorted by priority (High first, then Medium, then Low)":
    "Los tickets se ordenan por prioridad (Alta, luego Media, luego Baja)",
  Manage: "Gestionar",
  "Manage Ticket": "Gestionar ticket",
  "Edit Ticket": "Editar ticket",
  "Delete Ticket": "Eliminar ticket",
  "Admin Notes": "Notas de admin",
  "Admin Notes / Comments": "Notas / comentarios de admin",
  "Add your comments or notes about this ticket. These will be visible to the user when the ticket is resolved.":
    "Agregá comentarios o notas sobre este ticket. Serán visibles para el usuario cuando el ticket se resuelva.",
  "These comments will be visible to the user when the ticket is resolved":
    "Estos comentarios serán visibles para el usuario cuando el ticket se resuelva",
  "These comments will be visible to the user when the ticket status is changed to 'Resolved'":
    "Estos comentarios serán visibles para el usuario cuando el estado del ticket pase a Resuelto",
  "These comments will be visible to the user when the ticket status is changed to 'Resolved'.":
    "Estos comentarios serán visibles para el usuario cuando el estado del ticket pase a Resuelto.",
  "When status is changed to 'Resolved', the ticket will be marked as completed.":
    "Cuando el estado pase a Resuelto, el ticket se marcará como completado.",
  "Development Information": "Información de desarrollo",
  "Hours Worked": "Horas trabajadas",
  Estimación: "Estimación",
  "Enter estimated hours": "Ingresá las horas estimadas",
  "Enter hours worked": "Ingresá las horas trabajadas",
  "Enter the development price": "Ingresá el precio del desarrollo",
  "Enter the estimated time to fix this bug":
    "Ingresá el tiempo estimado para corregir este bug",
  "Leave empty to show 'Not yet estimated' to the client":
    "Dejá vacío para mostrar «Aún no estimado» al cliente",
  "Leave empty to show 'To be estimated' to the client":
    "Dejá vacío para mostrar «A estimar» al cliente",
  "To be estimated": "A estimar",
  "Created Date": "Fecha de creación",
  "You can edit the creation date for development tracking purposes":
    "Podés editar la fecha de creación para el seguimiento de desarrollo",
  Link: "Enlace",
  "URL where the issue occurred": "URL donde ocurrió el problema",
  "View Link": "Ver enlace",
  "View Details": "Ver detalle",
  Screenshot: "Captura",
  Screenshots: "Capturas",
  "You can upload multiple screenshots": "Podés subir varias capturas",
  "POR FAVOR, TODAS LAS CAPTURAS DE PANTALLA DEBEN VERSE LA URL DE DONDE ES ESA CAPTURA PARA PODER ENTENDER DE QUE PANTALLA SE ESTA HABLANDO":
    "Por favor, en todas las capturas debe verse la URL de la pantalla para poder entender de qué pantalla se habla",
  "No tickets found": "No se encontraron tickets",
  "No tickets with status {status}": "No hay tickets con estado {status}",
  "You haven't created any tickets yet": "Todavía no creaste ningún ticket",
  "Load More": "Cargar más",
  "Loading...": "Cargando…",
  "Saving...": "Guardando…",
  "Sending...": "Enviando…",
  "Uploading...": "Subiendo…",
  Today: "Hoy",
  Yesterday: "Ayer",
  "Ticket Resolved": "Ticket resuelto",
  "The ticket has been marked as resolved.": "El ticket se marcó como resuelto.",
  "Ticket updated successfully": "Ticket actualizado correctamente",
  "Tickets updated successfully": "Tickets actualizados correctamente",
  "Ticket deleted successfully": "Ticket eliminado correctamente",
  "Ticket not found": "Ticket no encontrado",
  "Order saved": "Orden guardado",
  "Error loading tickets": "Error al cargar tickets",
  "Error loading ticket": "Error al cargar el ticket",
  "Error updating ticket": "Error al actualizar el ticket",
  "Error deleting ticket": "Error al eliminar el ticket",
  "Error saving order": "Error al guardar el orden",
  "Error uploading screenshot": "Error al subir la captura",
  "An error occurred while selecting records.":
    "Ocurrió un error al seleccionar registros.",
  "Are you sure you want to delete this ticket? This action cannot be undone.":
    "¿Estás seguro de que querés eliminar este ticket? Esta acción no se puede deshacer.",
  "Yes, delete": "Sí, eliminar",
  OK: "OK",
  Error: "Error",

  Bug: "Bug",
  Development: "Desarrollo",
  "Report an error or issue": "Reportar un error o problema",
  "Request a new feature or development":
    "Solicitar una nueva funcionalidad o desarrollo",
  Important: "Importante",
  "Developments are governed by the terms of service":
    "Los desarrollos se rigen mediante las condiciones del servicio",
  "View Terms of Service": "Ver Condiciones de Servicio",
  "View Terms": "Ver Condiciones",
  "Terms of Service": "Condiciones de Servicio",
  "Please read and understand our terms of service":
    "Por favor lea y comprenda nuestras condiciones de servicio",
  "No terms of service available": "No hay condiciones de servicio disponibles",
  "The terms of service have not been configured yet":
    "Las condiciones de servicio aún no han sido configuradas",
  "Error loading terms of service":
    "Error al cargar las condiciones de servicio",

  // Month names
  January: "Enero",
  February: "Febrero",
  March: "Marzo",
  April: "Abril",
  May: "Mayo",
  June: "Junio",
  July: "Julio",
  August: "Agosto",
  September: "Septiembre",
  October: "Octubre",
  November: "Noviembre",
  December: "Diciembre",

  // Development translations
  "No completed developments found":
    "No se encontraron desarrollos completados",
  "There are no completed developments yet":
    "Aún no hay desarrollos completados",
  Completed: "Completado",
  "Completed Date": "Fecha de Completación",
  "Support completed date hint":
    "Se usa en resúmenes mensuales y listas de completados. Al marcar como Resuelto, déjelo vacío para usar la hora actual; indique una fecha para registrar o corregir la fecha de cierre.",
  hours: "horas",
  "Ticket resolution": "Resolución del ticket",
  Topics: "Temas",
  "Topic completed": "Tema completado",
  "Topic title": "Título del tema",
  "Topic title is required": "El título del tema es obligatorio",
  "Create topic": "Crear tema",
  "Error creating topic": "Error al crear el tema",
  "Topic created": "Tema creado",
  "Delete topic": "Eliminar tema",
  "Delete topic confirm": "¿Eliminar este tema y sus respuestas?",
  "Error deleting topic": "Error al eliminar el tema",
  "Error updating topic": "Error al actualizar el tema",
  "Reply to this topic...": "Responder a este tema...",
  "Leave a comment on this ticket": "Dejar un comentario en este ticket",
  "Send comment": "Enviar",
  "Close all topics": "Cerrar todos los temas",
  "Close all topics confirm": "¿Marcar como completados los {n} temas abiertos?",
  "Closed topics count": "{n} cerrados",
  "Reply to comment": "Responder a este comentario",
  "Reply to this comment...": "Responder a este comentario...",
  "Create task": "Crear tarea",
  "Create ticket": "Crear ticket",
  "This topic is handled in this task": "Este tema es tratado en esta tarea",
  "This task comes from a topic in": "Esta tarea proviene de un tema en",
  "This task comes from a comment in": "Esta tarea proviene de un comentario en",
  "View source comment": "Ver comentario origen",
  "View source topic": "Ver tema origen",
  "Ticket created from comment": "Ticket creado desde el comentario",
  "Error creating ticket from comment": "Error al crear el ticket desde el comentario",
  "Are you sure you want to create a task based on this comment?":
    "¿Estás seguro de que quieres crear una tarea a partir de este comentario?",
  "Task created from topic": "Tarea creada desde el tema",
  "Error creating task from topic": "Error al crear la tarea desde el tema",
  "Resolved tickets cannot receive comments":
    "Este ticket ya está resuelto. No se pueden añadir más comentarios.",
  "Creating...": "Creando...",
  "See more": "Ver más",
  "See less": "Ver menos",

  Replies: "Respuestas",
  Comments: "Comentarios",
  "Reply to this conversation": "Responder a esta conversación",
  "Write your reply...": "Escribe tu respuesta...",
  "Send reply": "Enviar respuesta",
  "Reply sent": "Respuesta enviada",
  "Change ticket status?": "¿Cambiar el estado del ticket?",
  // Soporte: un admin comenta a nombre de otro usuario (onBehalfOf)
  "Comment as…": "Comentar como…",
  "Myself": "Yo mismo",
  "Choose the new status for this ticket.": "Elegí el nuevo estado del ticket.",
  "Current status": "Estado actual",
  "Choose a status": "Elegí un estado",
  "Not started yet": "Todavía sin empezar",
  "In development — emails the ticket participants": "En desarrollo — avisa a los participantes del ticket",
  "Waiting for the user's answer — daily reminder": "Esperando la respuesta del usuario — recordatorio diario",
  "Ready to test — emails the ticket participants": "Listo para probar — avisa a los participantes del ticket",
  "Done and deployed — emails the ticket participants": "Terminado y desplegado — avisa a los participantes del ticket",
  "Resolved — closes the ticket, no more comments": "Resuelto — cierra el ticket y no acepta más comentarios",
  "Change status": "Cambiar el estado",
  "Keep current status": "Mantener el estado actual",
  "Error sending reply": "Error al enviar la respuesta",
  Images: "Imágenes",
  Image: "Imagen",
  "Add images": "Añadir imágenes",
  "Error uploading image": "Error al subir la imagen",
  "Image added": "Imagen añadida",
  "Only image files are allowed": "Solo se permiten archivos de imagen",
  "Only images PDF or Excel are allowed":
    "Solo se permiten imágenes, vídeos, PDF o Excel.",
  "Support ticket attachments hint":
    "Puedes subir varios archivos: imágenes, vídeos, PDF o Excel (.xls, .xlsx). Máximo 20 MB por archivo.",
  "Support ticket attachments hint short":
    "Imágenes, vídeos, PDF o Excel — máx. 20 MB por archivo.",
  "Support attachment type not allowed":
    "El archivo {name} no es un tipo permitido (imágenes, vídeos, PDF o Excel).",
  "Document upload type not allowed":
    "Tipo de archivo no permitido. Use PDF, Word (DOC, DOCX) o Excel (XLS, XLSX).",
  "Request entity too large": "Cuerpo de la petición demasiado grande",
  "File {name} is too large. Maximum size is {mb}MB":
    "El archivo {name} es demasiado grande. El tamaño máximo es {mb} MB.",
  "Waiting for answer": "Esperando respuesta",
  "Pending questions": "Preguntas pendientes",
  "Developer weekly activity": "Actividad semanal desarrolladores",
  "Meetings": "Reuniones",
  "Notices and support language": "Idioma de avisos y soporte",
  "App language": "Idioma de la aplicación",
  "Same as notices and support": "Igual que el de avisos y soporte",
  "Menu, buttons, fields and columns: everything except notices and support.": "Menú, botones, campos y columnas: todo salvo avisos y soporte.",
  "Notification email": "Email para avisos",
  "Job title": "Cargo",
  "Shown under the name in the document signature.": "Se imprime debajo del nombre en la firma de los documentos.",
  "Notices by email arrive here. Empty = your login email.": "Los avisos por email te llegan acá. Vacío = el email con el que entrás.",
  "Alerts, notifications, validations and technical support.": "Alertas, notificaciones, validaciones y soporte técnico.",
  "Do you want to move this": "¿Quieres enviar a la papelera este registro de",
  "to the trash? You can recover it later.": "(podrás recuperarlo más tarde)?",
  "Delete permanently": "Eliminar definitivamente",
  "Yes, move to trash": "Sí, enviar a la papelera",
  "Yes, permanently delete": "Sí, eliminar definitivamente",
  record: "registro",
  "Tutorials": "Instructivos",
  "Tutorial": "Instructivo",
  "Request a new tutorial": "Solicitar instructivo nuevo",
  "Requested tutorials": "Instructivos solicitados",
  "There are no tutorials yet.": "Todavía no hay instructivos.",
  "Export to PDF": "Exportar a PDF",
  "Other": "Otros",
  "Book a meeting": "Agendar una reunión",
  "Your plan includes {count} one-hour meetings per month. Unused meetings do not carry over.": "Tu plan incluye {count} reuniones de una hora por mes. Las que no uses no se acumulan.",
  "{left} of {limit} left": "te quedan {left} de {limit}",
  "The meetings calendar is temporarily unavailable. Please try again later.": "La agenda de reuniones no está disponible en este momento. Probá de nuevo más tarde.",
  "Meeting booking is not available yet.": "Todavía no se pueden agendar reuniones.",
  "Connect Google Calendar in the agenda settings below.": "Conectá Google Calendar en la configuración de la agenda, más abajo.",
  "Times shown in your local time ({tz})": "Horarios en tu hora local ({tz})",
  "There are no free times in the next {days} days.": "No hay horarios libres en los próximos {days} días.",
  "No meetings left that month": "Ya usaste las reuniones de ese mes",
  "What do you want to talk about? (optional)": "¿De qué querés hablar? (opcional)",
  "Invite users": "Invitar usuarios",
  "You are invited automatically. Google Calendar sends the invitation with the Meet link.": "Vos quedás invitado automáticamente. Google Calendar manda la invitación con el link de Meet.",
  "Search users": "Buscar usuarios",
  "No users found": "No se encontraron usuarios",
  "Another email": "Otro email",
  "Confirm meeting": "Confirmar reunión",
  "Your meetings": "Tus reuniones",
  "You have not booked any meetings yet.": "Todavía no agendaste ninguna reunión.",
  "Booked by {name}": "Agendada por {name}",
  "Join": "Entrar",
  "Upcoming meetings, all clients": "Próximas reuniones de todos los clientes",
  "No upcoming meetings.": "No hay reuniones próximas.",
  "Agenda settings": "Configuración de la agenda",
  "Google Calendar": "Google Calendar",
  "Google Calendar is not configured on the server (GOOGLE_CALENDAR_CLIENT_ID / SECRET / REDIRECT_URI).": "Google Calendar no está configurado en el servidor (GOOGLE_CALENDAR_CLIENT_ID / SECRET / REDIRECT_URI).",
  "Reconnect required": "Hay que reconectar",
  "Connected": "Conectado",
  "Reconnect": "Reconectar",
  "Disconnect": "Desconectar",
  "Connect Google Calendar": "Conectar Google Calendar",
  "Free times are your default hours minus whatever is busy in that calendar, including meetings booked from other clients.": "Los horarios libres son tus horarios por defecto menos lo que esté ocupado en ese calendario, incluidas las reuniones que agendaron otros clientes.",
  "Default availability": "Disponibilidad por defecto",
  "Time zone of these hours": "Zona horaria de estos horarios",
  "Meetings last one hour. Each client sees these times converted to their own time zone.": "Las reuniones duran una hora. Cada cliente ve estos horarios convertidos a su propia zona horaria.",
  "Your browser is in {tz}.": "Tu navegador está en {tz}.",
  "Add hours": "Agregar horario",
  "Save availability": "Guardar disponibilidad",
  "Google Calendar connected": "Google Calendar conectado",
  "Could not connect Google Calendar": "No se pudo conectar Google Calendar",
  "Allow access to the calendar on the Google screen and try again.": "En la pantalla de Google, permití el acceso al calendario y probá de nuevo.",
  "Done": "Realizada",
  "Scheduled": "Agendada",
  "Cancelled (counted)": "Cancelada (cuenta en el mes)",
  "Invalid email": "Email inválido",
  "Meeting booked. The invitation was sent by email.": "Reunión agendada. La invitación llegó por email.",
  "Could not book the meeting": "No se pudo agendar la reunión",
  "Cancel the meeting?": "¿Cancelar la reunión?",
  "Less than {hours} hours remain: the meeting will still count for this month.": "Faltan menos de {hours} horas: la reunión va a contar igual en el cupo del mes.",
  "Guests will be notified by email.": "Los invitados reciben el aviso por email.",
  "Cancel meeting": "Cancelar reunión",
  "Back": "Volver",
  "Form columns": "Columnas del formulario",
  "Columns": "Columnas",
  "col.": "col.",
  "Automatic": "Automático",
  "Share with other users": "Compartir con otros usuarios",
  "Layouts from other users": "Diseños de otros usuarios",
  "No shared layouts yet": "Nadie compartió un diseño todavía",
  "Adjust column widths": "Ajustar ancho de columnas",
  "Column width": "Ancho de columnas",
  "Fill the whole width": "Ocupar todo el ancho",
  "Show earlier days": "Ver días anteriores",
  "Show all": "Mostrar todo",
  "Meeting cancelled": "Reunión cancelada",
  "Availability saved": "Disponibilidad guardada",
  "Disconnect Google Calendar?": "¿Desconectar Google Calendar?",
  "Clients will not be able to book meetings until a calendar is connected again.": "Los clientes no van a poder agendar reuniones hasta que se vuelva a conectar un calendario.",
  "Week navigation": "Navegación por semana",
  "This week": "Esta semana",
  "Next week": "Semana próxima",
  Later: "Más adelante",
  "No support programmers configured": "No hay desarrolladores configurados",
  "Configure board programmers to track weekly activity":
    "Configurá los programadores del tablero en ajustes de tickets para ver la actividad semanal.",
  "No activity this week": "Sin actividad esta semana",
  "Status changes": "Cambios de estado",
  Tickets: "Tickets",
  "Error loading developer weekly activity": "Error al cargar la actividad semanal",
  "No pending questions": "No hay preguntas pendientes",
  "Pending questions scope": "Ámbito de preguntas pendientes",
  "From others": "De otros",
  "No pending questions help others":
    "No hay preguntas de otros usuarios sin respuesta en tickets «Esperando respuesta» (temas abiertos).",
  "No pending questions help all":
    "No hay preguntas sin respuesta en tickets «Esperando respuesta» (temas abiertos).",
  "View ticket": "Ver ticket",
  "Initial message": "Mensaje inicial",
  "Topic comment": "Comentario en tema",
  "Group by": "Agrupar por",
  "By week": "Por semana",
  "By month": "Por mes",
  "By day": "Por día",
  "Delete comment": "Eliminar comentario",
  "Are you sure you want to delete this comment? This action cannot be undone.":
    "¿Estás seguro de que quieres eliminar este comentario? Esta acción no se puede deshacer.",
  "Comment updated": "Comentario actualizado",
  "Comment deleted": "Comentario eliminado",
  "Error updating comment": "Error al actualizar el comentario",
  "Error deleting comment": "Error al eliminar el comentario",

  // Translation module
  translations: {
    title: "Traducciones",
    subtitle:
      "Override de textos por admin (todos los clientes) o por este cliente (dbName).",
    priorityHelp:
      "Prioridad: 1) Override de este cliente (dbName), 2) Override admin (todos), 3) Archivos .js del front.",
    seeInAppHint:
      "Al guardar, las traducciones se aplican en esta sesión. Si no las ves en otra pestaña o en otra sesión, recarga la página (F5); no hace falta cerrar sesión.",
    forAllClients: "Para todos los clientes (admin)",

    locale: "Idioma",
    key: "Clave",
    value: "Valor",
    addOverride: "Agregar override",

    save: "Guardar",

    loading: "Cargando...",

    confirmDelete: "¿Eliminar el override",

    searchKeyPlaceholder: "Buscar por clave o texto...",

    keyPlaceholder: "ej: client o tutorial.welcome.title",
    noKeysMatch: "No hay claves o no coinciden con la búsqueda",

    originalValue: "Valor original",
    yourOverride: "Tu traducción / override",
    removeOverride: "Quitar override",
    overridePlaceholder: "Escriba para sobreescribir",
    bulkReplace: "Reemplazo masivo",
    bulkReplaceHelp:
      "Reemplace una palabra o frase en todas las claves que la contengan. Se crearán o actualizarán overrides con el texto ya reemplazado. El campo «Buscar» también filtra la lista (incluidas claves que solo tienen traducción en otro idioma), así que puedes usarlo solo para localizar claves.",
    replaceSearch: "Buscar texto",
    replaceSearchPlaceholder: "ej: cliente",
    replaceWith: "Reemplazar por",
    replaceWithPlaceholder: "ej: comprador",
    bulkReplaceNoMatch: "Ninguna clave contiene ese texto.",
    bulkReplacePreview:
      '{count} clave(s) contienen "{search}". Se actualizarán con el reemplazo.',
    applyReplace: "Aplicar reemplazo",
    applying: "Aplicando",
    bulkReplaceConfirm:
      '¿Aplicar reemplazo en {count} clave(s)? "{search}" → "{replacement}"',
    empty: "(vacío)",
    done: "Hecho",
    bulkReplaceDone: "Se aplicó el reemplazo en {count} clave(s).",

    replaceResult: "Resultado:",
    caseSensitive: "Sensible a mayúsculas",
    wholeWord: "Palabra completa",
    showingOnlyReplaceMatches:
      'Mostrando solo las {count} clave(s) que contienen "{search}" (las que se reemplazarán).',
  },

  shippingExpenses: {
    copyToShipping: "Copiar a shipping",
    copyToShippingTitle: "Copiar gastos a shipping",
    copyToShippingIntro:
      "Los gastos seleccionados se copiarán sin pagos a uno o más shippings. {count} gasto(s) seleccionado(s).",
    copyToShippingSuccess:
      "{count} copia(s) de gasto creada(s) en {shippingCount} shipping(s).",
    copyToShippingError: "No se pudieron copiar los gastos.",
  },

  findTeu: {
    // Desactivación automática al terminar el embarque (el cobro depende solo de que esté activo)
    autoStopInfo:
      "Cada tracking se desactiva solo cuando el embarque termina: cuando todos los contenedores llegan al puerto de destino, cuando la naviera los da por finalizados o cuando la ETA venció hace más de {days} días sin novedades. Desde ese momento deja de cobrarse.",
    autoStopBadge: "Se desactivó solo",
    autoStopReason_arrived: "Todos los contenedores llegaron a destino{port} el {date}.",
    autoStopReason_completed: "La naviera dio por finalizados todos los contenedores{port}.",
    autoStopReason_eta_overdue: "La ETA ({date}) venció hace más de {days} días y la naviera no informó la llegada.",
    autoStopDisabledBadge: "No se desactiva solo",
    autoStopDisabledTitle: "Lo reactivaron a mano: sigue activo, y cobrándose, hasta que alguien lo detenga.",
    autoStoppedUseReactivate:
      "Este tracking se desactivó solo porque el embarque terminó. Si lo quieres seguir mirando, reactívalo desde la pestaña de detenidos.",
    reactivate: "Reactivar",
    reactivateTitle: "¿Reactivar el seguimiento de {number}?",
    reactivateText:
      "Al reactivarlo a mano, este tracking ya no se va a desactivar solo cuando termine el embarque: va a seguir activo, y cobrándose, hasta que lo detengas.",
    reactivateConfirm: "Sí, reactivar",
    reactivatedTitle: "Tracking reactivado",
    reactivatedText: "Recuerda detenerlo cuando ya no lo necesites.",
    containerTracking: "Seguimiento de contenedores",
    modelMappingTitle: "Mapeo automático por modelo",
    modelMappingIntro:
      "Una o más fuentes (campo + tipo) por modelo, en orden de prioridad. Al iniciar un tracking se prueban en ese orden hasta que Exportai acepte una. Nada corre hasta que la regla se guarda; al guardar, según el modo elegido arranca solo, pregunta o queda a mano.",
    startFromItem: "Iniciar desde ítem",
    startFromItemTitle: "Iniciar tracking desde un ítem",
    startFromItemIntro:
      "Elegí un modelo con mapeo automático, buscá el ítem e iniciá el tracking desde acá.",
    startFromItemNoModels:
      "Todavía no hay modelos con mapeo automático. Configurá uno en la sección de abajo primero.",
    startFromItemSearch: "Buscar",
    startFromItemSearchPlaceholder: "Nombre o texto…",
    startFromItemSearchBtn: "Buscar",
    startFromItemSkipped: "No se inició el tracking (sin número válido o ya activo).",
    startFromItemScacNone: "sin naviera",
    startFromItemScacNoneHint:
      "El ítem no tiene naviera: cargá el campo de naviera configurado para poder iniciar el seguimiento.",
    startFromItemNoNumberBlocked: "El ítem no tiene número de seguimiento.",
    startFromItemNoScacBlocked:
      "Booking y BL necesitan la naviera: cargala en el ítem para poder iniciar el seguimiento.",
    modelMappingAdminNoteTitle: "Antes de empezar: el campo de la naviera",
    modelMappingAdminNoteBadge: "solo admin",
    modelMappingAdminNoteBody1:
      "La lista «Exportai — Naviera (SCAC)» se crea sola al activar el módulo, pero el campo no. Para poder elegir la naviera hay que crear un campo de tipo lista (normalmente «scaccode») que apunte a esa lista.",
    modelMappingAdminNoteBody2:
      "Lo habitual es que ese campo viva en la ficha de la naviera —un modelo tipo contacto— y que el modelo que se trackea la referencie (ej.: shipping_line.scaccode). También puede ir directo en el modelo que se trackea. Sin ese campo, en el paso 3 solo aparecen campos de texto sueltos.",
    modelMappingSavedTitle: "Modelos con mapeo de seguimiento",
    modelMappingNone:
      "Todavía ningún modelo inicia seguimientos automáticamente. Agregá uno acá abajo.",
    modelMappingRowSources: "fuentes:",
    modelMappingRowScac: "naviera:",
    modelMappingRowScacAuto: "se detecta sola",
    onSaveModeLabel: "Al guardar:",
    onSaveModeAuto: "Automático",
    onSaveModeAsk: "Preguntar",
    onSaveModeManual: "Manual",
    onSaveModeAutoHelp: "Cada vez que se guarda un ítem con número de seguimiento, el tracking arranca solo.",
    onSaveModeAskHelp: "Al guardar un ítem con número de seguimiento y sin tracking activo, aparece un aviso preguntando si se quiere activar.",
    onSaveModeManualHelp: "Guardar no hace nada: el tracking se inicia a mano, con «Iniciar desde ítem» o el inicio masivo.",
    askOnSaveTitle: "¿Activar el seguimiento?",
    askOnSaveText: "Este ítem tiene el número {number} ({type}) y todavía no tiene seguimiento activo. ¿Querés activarlo ahora?",
    askOnSaveConfirm: "Sí, activar",
    askOnSaveCancel: "Ahora no",
    askOnSaveStarting: "Iniciando seguimiento…",
    modelMappingEditRow: "Editar",
    modelMappingEditorTitleNew: "Agregar un modelo",
    modelMappingEditorTitleEdit: "Editando «{model}»",
    modelMappingStepModel: "1. Modelo",
    modelMappingStepSources: "2. Fuentes de seguimiento (orden de prioridad)",
    modelMappingSourcesHint:
      "Ej.: 1) contenedor, 2) booking, 3) BL. Si el ítem solo tiene BL, se usará esa fila aunque las anteriores estén vacías.",
    modelMappingAddSource: "Añadir fuente",
    modelMappingSelectModel: "Modelo",
    modelMappingPickModel: "Elegir modelo…",
    modelMappingPickTrackingField: "Elegir campo…",
    modelMappingStepScac: "3. Naviera (SCAC)",
    modelMappingScacQuestion: "¿De dónde sale la naviera?",
    modelMappingScacModeNone: "No enviarla: Exportai detecta la naviera",
    modelMappingScacModeDirect: "Un campo de este modelo",
    modelMappingScacModeReference: "Un campo de un modelo referenciado",
    modelMappingScacGroupList: "Campos de la lista de navieras (SCAC)",
    modelMappingScacGroupOther: "Otros campos de texto",
    modelMappingScacPickDirect: "Elegir campo…",
    modelMappingScacPickReference: "Elegir referencia…",
    modelMappingScacPickNested: "Campo de naviera dentro de la referencia…",
    modelMappingScacPathPreview: "Se guarda como:",
    modelMappingScacIncomplete:
      "Elegí el campo: así como está, la regla se guardaría sin naviera.",
    modelMappingScacAutodetect:
      "Sin campo de naviera, Exportai la detecta, o se manda el primer campo de texto que parezca un SCAC. Elegir el campo es más rápido y más seguro.",
    modelMappingApply: "Guardar y activar",
    modelMappingUnsaved:
      "Todavía sin guardar: esta regla no corre hasta apretar «Guardar y activar».",
    modelMappingFieldsHint:
      "Para booking o BL la naviera es opcional, pero un campo de lista «Naviera (SCAC)» es más rápido y confiable que dejar que se detecte.",
    modelMappingApplied:
      "Mapeo guardado. Se usará la configuración elegida del modelo.",
    viewTrackingFromField: "Ver seguimiento Exportai",
    modelMappingResultRows: "mapeos",
    modelMappingResultButton: "Mapeo → ítem",
    modelMappingResultModalTitle: "Actualizar ítem cuando cambie el tracking",
    modelMappingResultModalHelp:
      "Define qué rutas del resultado Exportai copian a campos del modelo. Se aplican al sincronizar (cron) y al obtener datos nuevos de la API. Si aquí no hay filas, se usa el mapeo global del detalle del seguimiento (legado).",
    modelMappingPickPath: "Elegir ruta…",
    modelMappingAddRow: "Añadir fila",
    modelMappingResultSaved:
      "Mapeo guardado. Los ítems vinculados se actualizarán cuando haya cambios en el seguimiento.",
    bulkStartTracking: "Iniciar tracking",
    bulkStartTrackingTitle: "Iniciar tracking Exportai en lote",
    bulkStartTrackingIntro:
      "Cada ítem seleccionado se procesa en paralelo usando el mapeo automático configurado para este modelo.",
    bulkStartItem: "Ítem",
    bulkStartDetail: "Detalle",
    bulkStartLaunch: "Iniciar",
    bulkStartRunning: "Procesando…",
    bulkStartSummary: "Finalizado: {started} iniciados, {skipped} omitidos, {errors} con error.",
    bulkStartStatusPending: "Pendiente",
    bulkStartStatusRunning: "Procesando",
    bulkStartStatusStarted: "Iniciado",
    bulkStartStatusSkipped: "Omitido",
    bulkStartStatusError: "Error",
    bulkStartStartedOk: "Tracking iniciado",
    bulkStartAlreadyActive: "Tracking ya activo",
    bulkStartSkipNoCandidates: "Sin número de seguimiento en los campos configurados",
    bulkStartSkipNoApiKey: "API key de Exportai no configurada",
    bulkStartSkipNoRule: "Sin mapeo Exportai para este modelo",
    addTracking: "Añadir seguimiento",
    startNewTracking: "Iniciar nuevo seguimiento",
    trackingType: "Tipo de seguimiento",
    bookingNumber: "Número de booking",
    containerNumber: "Número de contenedor",
    billOfLading: "Conocimiento de embarque",
    scacCode: "Código SCAC",
    scacPlaceholder: "ej. MSCU, MAEU",
    scacHelp: "Opcional: el sistema puede detectar la naviera automáticamente. Si la conoce, elíjala para ir más rápido.",
    scacSelectCarrier: "Seleccionar naviera...",
    scacAutoDetect: "Detectar naviera automáticamente",
    scacOther: "Otra (escribir código)",
    scacRequired: "SCAC requerido",
    scacRequiredHelp:
      "Selecciona la naviera o escribe el código SCAC para booking/BL.",
    bookingLabel: "Booking",
    containerLabel: "Contenedor",
    blLabel: "B/L",
    trackingNumber: "Número de seguimiento",
    searchInDatabase: "Buscar en base de datos",
    start: "Iniciar",
    supportedCarriers: "Navieras soportadas",
    supportedCarriersDescription:
      "Realizamos seguimiento de contenedores de las siguientes navieras y empresas de leasing:",
    loading: "Cargando...",
    loadingTrackingInfo: "Cargando información de seguimiento...",
    tryAgain: "Reintentar",
    origin: "Origen",
    destination: "Destino",
    status: "Estado",
    linkedItems: "Ítems vinculados",
    shippingColumn: "N° de shipping",
    openLinkedShipping: "Abrir el shipping",
    lastUpdated: "Última actualización",
    actions: "Acciones",
    editLinkedItems: "Editar ítems vinculados",
    na: "N/D",

    noActiveTrackings: "Sin seguimientos activos",
    noActiveTrackingsHint:
      'Inicia un seguimiento haciendo clic en "Añadir seguimiento" arriba.',
    trackingDetails: "Detalles del seguimiento",
    close: "Cerrar",

    type: "Tipo",
    carrierScac: "Naviera (SCAC)",
    lastUpdatedLabel: "Última actualización",
    carrierDataAsOf: "Último cambio informado por la naviera",
    hintsTitle: "Qué revisar, en este orden:",
    hint_check_number_typo: "Que el número esté bien copiado del documento de la naviera. Un dígito de más o de menos es la causa más común.",
    hint_booking_too_new: "Si el booking es muy reciente, puede no estar todavía en el sistema. En ese caso el número está bien y hay que reintentar en uno o dos días.",
    hint_check_carrier_field: "Que la naviera (SCAC) del envío sea la correcta para ese número.",
    hint_try_without_scac: "Probar dejando la naviera vacía: el proveedor intenta detectarla solo.",
    hint_wait_and_retry: "Es un problema temporal del proveedor o de la naviera. Reintentar en unos minutos.",
    hint_check_api_key: "Es un problema de la cuenta o de la API key, no del envío. Revisar la configuración del módulo.",
    milestoneColumn: "Próximo hito",
    milestoneNext: "{date} {action} {port}",
    milestoneOverdue: "vencido hace {days} d: {action} {port}",
    milestoneEtaOverdue: "ETA vencida hace {days} d",
    milestoneLastActual: "Último hecho confirmado: {date} {action} {port}",
    milestoneHint: "Mientras el próximo hito esté en el futuro, no tener novedades es lo esperable. La naviera solo informa cuando algo pasa.",
    syncErrorBadge: "error {code}",
    syncErrorTooltip: "El último intento de sincronización falló con error {code}: {text}. Por eso el dato de la naviera no avanza. Corrija la configuración (por ejemplo la naviera/SCAC) y use Refrescar para verificar.",
    pendingValueNow: "ahora",
    pendingValueWouldBe: "quedaría",
    updateHistoryArrowLegend: "En cada línea, el valor de la izquierda es el anterior y el de la derecha el nuevo.",
    carrierDataAsOfColumn: "Último cambio",
    carrierDataAsOfTooltip: "Fecha del último cambio que informó la naviera. Exportai consulta cada 6 a 48 h según la etapa del viaje, pero genera datos nuevos solo cuando algo cambió: una fecha vieja significa que no hubo novedades, no que no se haya consultado.",
    carrierDataAgeHours: "hace {hours} h",
    refreshFromCarrier: "Refrescar",
    refreshFromCarrierTitle: "Consultar Exportai ahora, sin esperar al cron diario. Devuelve la última foto que Exportai tiene de la naviera.",
    refreshNoChangesTitle: "Sin cambios",
    refreshNoChangesText: "Exportai no tiene datos más nuevos. Su dato de la naviera sigue siendo del {ts}.",
    refreshChangesTitle: "Datos actualizados",
    refreshChangesText: "{summary}. Los cambios quedan pendientes de su validación.",
    refreshErrorTitle: "No se pudo refrescar",
    refreshRefetchAsked: "Se pidió a la naviera que vuelva a informar. El dato definitivo puede llegar unos segundos después; volvé a abrir el seguimiento para verlo.",
    completed: "Completado",
    inTransit: "En tránsito",
    terminal: "Terminal",
    portOfLoading: "Puerto de carga (POL)",
    portOfDischarge: "Puerto de descarga (POD)",
    etd: "ETD",
    eta: "ETA",
    eventsTimeline: "Cronología de eventos",
    eventsTimelineHint:
      "Hitos reales vs previstos, ubicaciones, buques y modos de transporte.",
    bookingDetails: "Reserva",
    containerQty: "Contenedores",
    bookingReference: "Referencia",
    containersOnBooking: "{count} contenedores con historial de eventos abajo",
    updateHistoryTypeColumn: "Tipo",
    updateHistoryTypeTracking: "Datos de seguimiento",
    updateHistoryTypeMapping: "Mapeo a ítem",

    updateHistorySummary: "Resumen",
    updateHistoryDetailAction: "Detalle",
    updateHistoryShowDetails: "Ver cambios",
    updateHistoryHideDetails: "Ocultar",
    updateHistoryDetectedChanges: "Cambios detectados en esta actualización",
    updateHistoryNoSummary: "(sin resumen)",
    event: "Evento",

    vessel: "Buque",
    voyage: "Viaje",
    mode: "Modo",
    code: "Código",
    searchItemForTracking: "Buscar ítem para seguimiento",
    loadingConfig: "Cargando configuración...",
    noReportConfigured:
      "No hay reporte configurado para el buscador. Configura uno en <strong>Módulos del sistema</strong> → <strong>Configuración del buscador de tracking</strong>.",
    filterResults: "Filtrar resultados...",
    loadingReport: "Cargando reporte...",
    noItemsOrNoMatch: "No hay ítems o ninguno coincide con el filtro.",
    chooseNumberForTracking: "Elige el número a usar para el seguimiento:",
    backToList: "Volver a la lista",
    linkedItemsTitle: "Ítems vinculados",
    noLinkedItems: "Ningún ítem vinculado.",
    remove: "Quitar",

    save: "Guardar",
    errorStartingTracking: "Error al iniciar seguimiento",
    trackingStartedTitle: "Seguimiento iniciado",
    trackingStartedSuccess: "El seguimiento se ha iniciado correctamente.",
    ok: "Aceptar",
    confirmStopTitle: "¿Estás seguro?",
    confirmStopText: "¿Deseas dejar de seguir {number}?",
    yesStop: "Sí, detener",
    stopAll: "Detener todos",
    stoppingAll: "Deteniendo…",
    confirmStopAllTitle: "¿Detener todos los seguimientos?",
    confirmStopAllText: "¿Deseas detener los {count} seguimientos activos?",
    yesStopAll: "Sí, detener todos",
    allTrackingsStoppedSuccess: "Se detuvieron {count} seguimientos.",
    autoApplyActivate: "Activar actualización automática",
    autoApplyDeactivate: "Desactivar actualización automática",
    autoApplyOffTitle: "Aplicar solos los cambios del tracking en los ítems vinculados, sin validar uno por uno",
    autoApplyOnTitle: "Los cambios del tracking se aplican solos en los ítems vinculados",
    autoApplyConfirmOnTitle: "¿Activar la actualización automática?",
    autoApplyConfirmOnText: "Los cambios que traiga el tracking se aplicarán solos en los ítems vinculados, sin pasar por «Cambios pendientes». Los cambios pendientes de ahora se aplican en este momento.",
    autoApplyConfirmOffTitle: "¿Desactivar la actualización automática?",
    autoApplyConfirmOffText: "Los cambios del tracking volverán a quedar en «Cambios pendientes» para validarlos a mano.",
    autoApplyOnSuccessTitle: "Actualización automática activada",
    autoApplyOnSuccessText: "Se aplicaron los cambios pendientes en {n} ítem(s).",
    autoApplyOffSuccessTitle: "Actualización automática desactivada",
    autoApplyOffSuccessText: "Los próximos cambios quedarán pendientes de validación.",
    autoApplyError: "Error al cambiar la actualización automática.",
    cancel: "Cancelar",
    trackingStopped: "Seguimiento detenido",
    trackingStoppedSuccess: "El seguimiento se ha detenido correctamente.",
    errorStoppingTracking: "Error al detener el seguimiento",
    searchNotConfiguredTitle: "Buscador no configurado",
    searchNotConfiguredHtml:
      "Para buscar ítems en la base de datos debes configurar un reporte en <strong>Módulos del sistema</strong> → <strong>Configuración del buscador de tracking</strong>.",
    understood: "Entendido",
    placeholderBooking: "Ingresa el número de booking",
    placeholderContainer: "Ingresa el número de contenedor",
    placeholderBl: "Ingresa el número de conocimiento de embarque",
    placeholderTracking: "Ingresa el número de seguimiento",
    failedLoadTrackingDetails: "Error al cargar los detalles del seguimiento",
    tabActive: "Activos",
    tabStopped: "Detenidos",
    tabCost: "Costo",
    stoppedAt: "Detenido el",
    noStoppedTrackings: "Sin seguimientos detenidos",
    noStoppedTrackingsHint: "Los seguimientos que detengas aparecerán aquí.",
    costPerMonthSummary: "Costo por mes",
    costPerMonthExplanation:
      "Se usa la fecha de alta y de baja. Un seguimiento se cobra en un mes solo si estuvo activo al menos 24 horas en ese mes (ej.: creado el 15 y detenido el 20 sí cuenta; creado el 30 y detenido el 1 no).",
    month: "Mes",
    activeCount: "Seguimientos ese mes",
    totalCost: "Total",
    noCostData: "Sin datos de costos.",
    costPerTracking: "Costo por seguimiento",
    priceAtLaunch: "Precio al lanzar",
    monthlyCost: "Costo mensual",
    active: "Activo",
    stopped: "Detenido",
    activeFromTo: "activo",

    mappingColumn: "Mapeo",
    mappingNone: "—",
    mappingOneField: "1 campo",
    mappingFields: "{n} campos",
    mappingTitle: "Mapeo resultado tracking → ítem ligado",
    mappingHelp:
      "Define qué campos del resultado del tracking se copiarán a los campos del ítem vinculado (para futura actualización automática).",
    trackingPath: "Campo resultado (ruta)",
    modelName: "Modelo",
    itemField: "Campo del ítem",
    itemFieldNone: "— Ninguno —",

    savedSuccess: "Guardado correctamente.",
    mappingNoLinkedItem:
      "Este seguimiento no tiene ítem vinculado. Vincula un ítem para definir el mapeo (se aplicará a todos los ítems del mismo modelo).",

    trackingValue: "Valor del tracking",
    valueToApply: "De > A",
    saveMapping: "Guardar mapeo",
    updateItemNow: "Actualizar ítem ahora",
    updateItemNowNoMapping:
      "Asigna al menos un campo del ítem en la tabla para poder actualizar.",
    updateItemNowSuccess:
      "El ítem vinculado se ha actualizado con los datos del tracking.",
    updateItemNowError: "Error al actualizar el ítem.",
    updateItemNowConfirmItems: "Ítems que se actualizarán:",
    updateItemNowConfirmFields: "Campos que se aplicarán:",
    updateItemNowConfirm: "Aceptar y actualizar",

    updateHistoryTitle: "Historial de actualizaciones",
    updateHistoryEmpty:
      "Aún no se ha aplicado ninguna actualización por mapeo en este seguimiento.",
    updateHistoryAt: "Fecha y hora",
    updateHistorySource: "Origen",
    updateHistorySourceManual: "Manual",
    updateHistorySourceWebhook: "Automático",
    updateHistorySourceCron: "Cron (programado)",
    updateHistorySourceAutoApply: "Actualización automática",
    updateHistoryItem: "Ítem",

    pendingChangesLabel: "Cambios pendientes",
    pendingChangesTitle: "Cambios pendientes en ítems vinculados",
    pendingChangesDetected: "Cambios detectados pendientes de aplicar:",
    pendingChangesItemsToUpdate: "Se actualizarán {n} ítem(s) vinculados",
    pendingChangesApply: "Aplicar cambios pendientes",
    pendingChangesApplySuccess:
      "Se actualizaron correctamente {n} ítem(s) vinculados.",
    pendingChangesApplyError: "Error al aplicar los cambios pendientes.",
    pendingChangesLoadError: "Error al cargar los cambios pendientes.",
    pendingChangesNone: "No hay cambios pendientes por aplicar.",
    pendingChangesDiscard: "Descartar cambios",
    pendingChangesDiscardConfirmTitle: "¿Descartar cambios pendientes?",
    pendingChangesDiscardConfirmText:
      "El aviso de cambios pendientes desaparecerá. Los ítems vinculados no se actualizarán. Si los datos del tracking cambian más adelante, pueden volver a aparecer.",
    pendingChangesDiscardSuccess: "Cambios pendientes descartados.",
    pendingChangesDiscardError: "Error al descartar los cambios pendientes.",
  },

  excelMapping: {
    title: "Mapeo Excel",
    subtitle: "Mapea celdas de Excel a campos del modelo e importa datos",
    menuItem: "Mapeo Excel",
    myMappings: "Mis mapeos",
    createMapping: "Crear mapeo",
    importData: "Importar datos",
    loading: "Cargando...",
    noMappings: "Aún no hay mapeos",
    noMappingsHint:
      "Crea un mapeo para vincular celdas de Excel a un modelo y luego importar datos.",
    name: "Nombre",
    targetModel: "Modelo destino",
    mode: "Modo",
    modeSingle: "Único",
    modeRows: "Filas",
    actions: "Acciones",
    step1Title: "1. Seleccionar modelo destino",
    step1Hint: "Elige el modelo donde se crearán los datos importados.",
    model: "Modelo",
    selectModel: "— Seleccionar modelo —",
    importMode: "Modo de importación",
    modeSingleHelp:
      "Un registro: asigna cada celda a un campo (un registro por hoja)",
    modeRowsHelp:
      "Varias filas: cada fila = un registro, mapea columnas a campos",
    next: "Siguiente",
    step2Title: "2. Subir plantilla Excel",
    step2Hint:
      "Sube un archivo Excel. Mostraremos sus celdas para que asignes cada una a un campo del modelo.",
    parsing: "Leyendo Excel...",
    sheet: "Hoja",
    noField: "—",
    cellMapHint: "Asigna un campo del modelo a cada celda que tenga datos.",
    groupArrayTitle: "Mapear filas a grupo (array)",
    groupArrayHint:
      "Si tu Excel tiene una tabla (varias filas) que debe ser un campo tipo array (ej. ítems de línea), indica el rango de filas y mapea cada columna al subcampo del grupo.",
    groupArrayStartRow: "Fila inicial de datos (0 = primera)",
    groupArrayEndRow: "Fila final (opcional; vacío = hasta el final)",
    groupArrayColumnHint: "Asigna cada columna a un subcampo del grupo:",
    subFields: "subcampos",
    optional: "Opcional",
    headerRow: "Índice de fila de encabezado",
    columnMapHint:
      "Mapea columnas (por índice) a campos. Fila 0 = primera fila.",
    back: "Atrás",
    step3Title: "3. Nombre y guardar",
    description: "Descripción",
    namePlaceholder: "ej. Plantilla clientes",
    saveMapping: "Guardar mapeo",
    saved: "Guardado",
    savedHint: "Mapeo guardado. Puedes usarlo para importar datos.",
    error: "Error",
    parseError: "No se pudo leer el archivo Excel",
    selectMapping: "Seleccionar mapeo",
    selectMappingOption: "— Seleccionar un mapeo —",
    excelFile: "Archivo Excel",
    previewing: "Vista previa...",
    preview: "Vista previa",
    records: "registros",
    showingFirst20: "Se muestran las primeras 20 filas.",
    total: "total",
    importNow: "Importar ahora",
    noPreviewRecords:
      "No hay registros para previsualizar. Revisa el mapeo y el archivo.",
    previewError: "No se pudo generar la vista previa",
    importDone: "Importación completada",
    importDoneText: "Creado(s) {n} registro(s).",
    importError: "Error al importar",
    importErrorUnknown: "No se pudo crear el registro.",
    importErrorsCount: "{n} error(es).",
    deleteConfirm: "¿Eliminar mapeo?",
    deleteConfirmText: "Esta acción no se puede deshacer.",
    delete: "Eliminar",
    deleted: "Eliminado",
    savedMappingsHint:
      "Mapeos guardados: la próxima vez solo elige uno y sube tu archivo Excel—no hace falta mapear de nuevo.",
    editMapping: "Editar mapeo",
    editingMapping: "Editando mapeo",
    step2HintEdit:
      "Vuelve a subir la plantilla Excel para ver y editar los mapeos de celdas/columnas.",
    updateMapping: "Actualizar mapeo",
    updated: "Actualizado",
    updatedHint: "Mapeo actualizado. Puedes usarlo para importar datos.",
    importWithThisMapping: "Importar con este mapeo (solo subir archivo)",
    importOnlyUploadHint:
      "El mapeo ya está guardado. Selecciónalo y sube un Excel con el mismo formato—no hace falta mapear de nuevo.",
    saveMappingHint:
      "Guarda este mapeo una vez; después solo tendrás que seleccionarlo y subir tu archivo Excel para importar.",
  },

  inmobiliaria: {
    menuItem: "Inmobiliaria",
    sourcesTab: "Fuentes",
    searchesTab: "Búsquedas",
    resultsTab: "Resultados",
    addSource: "Agregar fuente",
    addSearch: "Crear búsqueda",
    active: "Activa",
    inactive: "Inactiva",
    noSources: "Todavía no hay fuentes. Agregá URLs de sitios o portales.",
    noSearches: "Todavía no hay búsquedas.",
    noResults: "Sin resultados aún.",
    noActiveSources: "No hay fuentes activas.",
    queryLabel: "Consulta (texto libre)",
    queryPlaceholder: "Ej.: 3 ambientes en Palermo hasta USD 200.000",
    cronEnable: "Búsqueda periódica",
    cronDisable: "Desactivar periódica",
    cronOn: "Cron activo",
    cronDaily: "Una vez por día",
    cronWeekly: "Una vez por semana",
    cronModalTitle: "Búsqueda periódica",
    cronIntervalLabel: "Frecuencia",
    cronModalHint:
      "La búsqueda se ejecutará sola con las fuentes activas según esta frecuencia.",
    cronSave: "Guardar",
    runNow: "Buscar ahora",
    viewResults: "Ver resultados",
    status: "Estado",
    allSearches: "Todas las búsquedas",
    selectSourcesHint:
      "Elegí las fuentes a usar (por defecto todas las activas).",
    maxResultsLabel: "Cantidad de avisos",
    maxResultsHint:
      "Oráculo busca en todas las fuentes elegidas y devuelve los que mejor coincidan, priorizando los más nuevos.",
    runQueued:
      "Búsqueda encolada ({n} fuente(s), hasta {max} avisos). Oráculo procesará en breve.",
    confirmDelete: "¿Eliminar?",
    colTitle: "Aviso",
    colSource: "Fuente",
    colOperation: "Operación",
    colCity: "Ciudad",
    colBedrooms: "Dorm.",
    colSqm: "m²",
    colPrice: "Precio",
    colLink: "Link",
    opSale: "Venta",
    opRent: "Alquiler",
    filterAll: "Todas",
    filterMin: "Mín.",
    filterPriceMin: "Precio mín.",
    filterPriceMax: "Precio máx.",
    filterClear: "Limpiar filtros",
    searchInProgress: "Búsqueda en curso…",
    searchBusyHint: "Esperá a que termine la búsqueda en curso",
  },

  jurisprudencia: {
    menuItem: "Jurisprudencia",
    browsePageTitle: "Jurisprudencia",

    agentChatCardLabel: "Asistente de jurisprudencia",

    agentChatPlaceholder: "Escribí tu mensaje y presioná Enviar…",
    agentChatHistoryAnalyzeHint:
      "Estás viendo resultados guardados del historial. Podés pedirme que los analice (por ejemplo: «analizá si son pertinentes») y marcaré en verde los que encajen con lo que buscás, sin repetir la búsqueda en el SAIJ.",
    agentOpeningGreetingLoading: "Cargando...",

    agentChatSend: "Enviar",
    agentChatClear: "Reiniciar conversación",
    agentChatLoading: "Pensando…",
    agentTemaSuggestIntro:
      "Sugerencias del tesauro SAIJ (tocá una para enviarla al asistente):",
    searchDoneTitle: "Búsqueda lista (asistente)",

    newAgentChat: "Nueva conversación asistida",
    searchHistoryTitle: "Historial de consultas acordadas",
    searchHistoryToggle: "Ver historial ({n})",
    searchHistoryViewResults: "Ver resultados",
    searchHistoryNoResultsStored:
      "Esta entrada no tiene resultados guardados (búsquedas anteriores). Podés usar «Repetir búsqueda».",
    searchHistoryLegacyBadge: "Sin copia guardada",
    searchHistorySourceQuick: "Rápida",
    searchHistorySourceDemanda: "Desde escrito",
    searchHistorySourceAgent: "Asistente",
    searchHistoryDelete: "Borrar",
    searchHistoryDeleteTitle: "Borrar del historial",
    searchHistoryDeleteConfirm:
      "Se eliminará esta búsqueda guardada y sus resultados. ¿Continuar?",
    searchHistoryRerun: "Repetir búsqueda",
    searchRerunDoneHint:
      "Se repitió la búsqueda guardada en tu historial. Resultados actualizados abajo.",
    browseQuickAiSummary: "Búsqueda rápida",

    browseQuickAiResultsHint:
      "Búsqueda rápida: listado de fallos del índice (sin análisis de pertinencia hasta que lo pidas).",

    browseAiPlaceholder:
      "Ej.: fallos de la CSJN sobre daño moral en accidentes de tránsito en los últimos años",
    browseAiButton: "Buscar con IA",

    adminSaijApiDebugTitle: "Depuración petición SAIJ (solo administradores)",
    adminSaijApiDebugIntro:
      "Incluye el parámetro q en wire, la cadena de facetas f, la URL GET a resultados.jsp y, si hubo fallback, el POST a /busqueda (campos y cuerpo application/x-www-form-urlencoded).",

    browseColTitle: "Título",
    browseColJurisdiction: "Jurisdicción",
    browseColTribunal: "Tribunal / órgano",
    browseColDate: "Fecha",
    browseColTipoFallo: "Tipo de fallo",

    browseColSnippet: "Extracto",

    browseColLink: "Enlace",

    pageTitle: "Jurisprudencia",
    pageIntro:
      "Este módulo es el asistente del sistema frente al Sistema Argentino de Información Jurídica (SAIJ): legislación, fallos, sumarios, dictámenes y doctrina. La integración directa con búsqueda automática está hoy centrada en jurisprudencia nacional; desde un Escrito (MEV, modelo técnico «Demanda») podés generar esa búsqueda asistida por IA a partir del texto del documento.",
    pageHintDemanda:
      "En la vista de un registro «Escrito», usá el botón de búsqueda relacionada en el SAIJ: se abre un chat con el mismo asistente que en Jurisprudencia; el texto del escrito va en contexto y podés afinar antes de lanzar la búsqueda.",

    searchRelated: "Buscar jurisprudencia relacionada (SAIJ)",
    modalTitle: "Búsqueda de jurisprudencia relacionada",
    escritoJurisModalIntro:
      "Charlá con el asistente como en Jurisprudencia: el texto de tu escrito ya está en contexto. Cuando acuerden la búsqueda, el asistente la ejecuta en el SAIJ y los resultados aparecen abajo.",
    escritoJurisShortContextHint:
      "Hay poco texto cargado del escrito; igual podés orientar al asistente con tus mensajes.",
    escritoJurisGreetingLoading: "Preparando el asistente…",
    escritoJurisFallbackGreeting:
      "Hola. Ya tengo el escrito cargado: contame qué jurisprudencia querés buscar o qué aspectos te interesan más.",
    loading: "Buscando…",

    aiRelevantBadge: "Pertinente (IA)",
    stopAgentTurn: "Detener",
    turnStoppedByUser:
      "Detuviste la operación. Los resultados que ya estaban en pantalla no se borrán: podés marcar enlaces y guardar, o reintentar más tarde.",
    chatErrorNetworkOrSaij:
      "No pudimos completar la operación (fallo de red o el sitio del SAIJ no respondió bien). Suele deberse a saturación o lentitud del buscador oficial saij.gob.ar, no a un fallo permanente del sistema. Probá de nuevo en unos minutos, en horario de menor carga, o con «Detener» y una búsqueda más corta.",
    chatErrorTimeoutSaij:
      "Se agotó el tiempo de espera. Cuando el SAIJ está muy lento, la consulta o el análisis pueden cortarse por límite de tiempo; no significa que tu escrito o tu pedido estén mal. Reintentá más tarde, probá de noche, o acotá la cantidad de resultados.",

    progress: {},
    error: "No se pudo completar la búsqueda.",

    emptyDemandPopupTitle: "Escrito sin texto para analizar",
    emptyDemandPopupText:
      "No hay texto útil en «Contenido» ni en los apartados de redacción, o no está guardado en el servidor. Cargá o guardá el escrito e intentá de nuevo.",
    emptyDemandPlantillaTitle: "Sin texto para analizar",
    emptyDemandPlantillaText:
      "Elegiste una plantilla pero no hay texto en los apartados de redacción ni un texto plano del registro con contenido útil, o no pudimos cargar la plantilla. Guardá el registro (así se actualiza el texto plano), verificá que la plantilla tenga cuerpo, o completá «Contenido» u otro apartado y volvé a intentar.",

    hint: "Fallos del índice público del SAIJ. Si pedís análisis, el servidor descarga un fragmento del texto desde la URL de cada resultado y la IA lo usa junto al título y al extracto (sigue siendo un recorte; leé el fallo completo en el sitio oficial). Verificá cada cita en saij.gob.ar antes de usarla en un escrito.",
    whyThisResult: "Por qué aparece este resultado",
    noRelevantAfterGather:
      "Tras dos pasadas en el SAIJ, la IA no halló suficientes documentos que considere claramente alineados con tu pedido (objetivo hasta {asked} pertinentes; obtenidos {got}). Probá reformular en el chat o usar la búsqueda manual.",
    relevanceGatherSummary:
      "Se listan {n} resultado(s) que la IA considera pertinentes (tope: {target}; puede haber menos).",
    saijSumarioId: "N.º sumario SAIJ",
    aiNotes: "Notas:",
    queriesUsed: "Consultas sugeridas por IA",
    noResults: "No se encontraron documentos para esas consultas.",
    openDoc: "Ver en SAIJ",
    selectAllWithUrl: "Marcar todas (con enlace)",
    selectNone: "Desmarcar todas",
    selectRowsHint:
      "Marcá los resultados cuyo enlace querés guardar en el registro. Se agregan al campo «Referencias de jurisprudencia» sin duplicar URLs.",
    noUrlForRow: "Sin URL en SAIJ para este resultado.",
    saveToDemanda: "Guardar enlaces en el escrito",
    saving: "Guardando…",
    saveOk: "Se agregaron {n} enlace(s) a referencias de jurisprudencia.",
    saveError:
      "No se pudieron guardar los enlaces. ¿Tenés permiso para editar Escrito (demanda.manage)?",
    dashboardShortcutTitle: "Jurisprudencia",
    dashboardShortcutBody:
      "Buscá fallos y sumarios con palabras clave, un asistente que afina tema y alcance, o filtros detallados. Revisá el historial y repetí una consulta cuando la necesites.",
    dashboardShortcutCta: "Abrir Jurisprudencia",
  },

  mev: {
    dashboardShortcutTitle: "MEV — Causas",
    dashboardShortcutBody:
      "Consultá causas judiciales con el asistente, una búsqueda rápida en una sola frase o filtros manuales por tribunal y criterios. Los resultados se muestran en tabla y podés volver a búsquedas anteriores desde el historial.",
    dashboardShortcutCta: "Abrir MEV",
    browsePageTitle: "Mesa de Entradas Virtual (SCBA)",
    browseNavAria: "Secciones de la pantalla MEV",
    browseNavAssistant: "Asistente de búsqueda MEV",
    browseNavQuick: "Búsqueda rápida",
    browseNavAmbito: "Cambiar ámbito MEV",

    browseNavAmbitoActiveTitle:
      "Hay un ámbito MEV elegido. Abrí esta pestaña para ver el resumen o cambiarlo.",
    browseNavHistory: "Ver historial",
    browseNavHistoryEmpty: "Todavía no hay consultas en el historial.",
    browseNavAmbitoNotReady:
      "Todavía no configuraste el acceso al MEV. Usá la pestaña «Asistente de búsqueda MEV» y seguí los pasos del chat.",
    browseNavAmbitoChangeAction: "Cambiar ámbito (reiniciar asistente)",
    browseNavAmbitoFootnote:
      "Vas a volver a elegir tribunal, departamento y fueros como en el portal. La conversación del asistente se reinicia.",
    browseNavQuickNeedAmbito:
      "Primero completá el ámbito MEV con el asistente (pestaña «Asistente de búsqueda MEV»); después podés usar la búsqueda rápida.",

    browseAiPlaceholder:
      "Ej.: causas con carátula pérez en la Cámara Primera Civil Presidencia del último mes",

    searchHistoryViewResults: "Ver resultados",
    searchHistoryNoResultsStored: "No hay causas guardadas para esta entrada.",
    searchHistoryLegacyBadge: "Sin copia guardada",
    searchHistorySourceQuick: "Rápida",
    searchHistorySourceManual: "Manual",
    searchHistorySourceAgent: "Asistente",
    searchHistorySourceDefault: "Listado (config.)",
    gridColAmbito: "Ámbito MEV",
    gridColDepartamento: "Depto. judicial",
    gridAmbitoSCJ: "Suprema Corte (SCJ)",
    gridAmbitoLPC: "Casación penal (LPC)",
    gridAmbitoPZ: "Justicia de Paz (PZ)",
    gridAmbitoCC: "Departamento judicial (CC)",
    gridFueroFamilia: "Fuero familia",
    gridFueroPenal: "Fuero penal",
    gridDeptoCode: "Depto. {code}",
    searchHistoryDelete: "Borrar",
    searchHistoryDeleteTitle: "Borrar del historial",
    searchHistoryDeleteConfirm:
      "Se eliminará esta entrada del historial. ¿Continuar?",
    searchHistoryRerun: "Repetir búsqueda",
    searchDoneTitle: "Búsqueda lista",
    newAgentChat: "Nuevo chat con el asistente",

    agentChatIntro:
      "Te ayudo a elegir tribunal (Suprema, Casación, Paz, Departamento), fueros, organismo y criterio de búsqueda. Por defecto mostramos hasta 30 causas en la grilla (podés pedir más, hasta 200, en la conversación). Cuando tenga todo, ejecuto la consulta en el portal.",
    agentCardIntroSetup:
      "Primero configuramos el acceso al MEV como en el portal: tocá las opciones que te propongo. Cuando valide el usuario, te preguntaré si guardamos esto en el navegador para la próxima vez.",
    agentAmbitoSearchModeQuestion:
      "En esta pantalla del MEV tenés el buscador general por tribunales y carátula, y también tus listas guardadas. ¿Cómo querés que configuremos el acceso desde acá?",
    agentAmbitoSearchModeGeneral:
      "Búsqueda general (por tribunales y carátula)",
    agentAmbitoSearchModeMisListas: "Dentro de una lista guardada (Mis sets)",
    agentAmbitoSetListQuestion: "¿Con cuál lista seguimos?",
    agentSaveAmbitoQuestion:
      "¿Guardamos esta configuración de acceso en este navegador? La próxima vez podrás usar la búsqueda rápida con el mismo ámbito y el asistente hará menos preguntas al iniciar.",
    agentSaveAmbitoQuestionWithSavedList:
      "¿Guardamos en este navegador el acceso al MEV y la lista que elegiste («{list}»)? La próxima vez entrás con el mismo ámbito y esa lista; podés filtrar por carátula en el listado o pedirlo en el asistente.",
    agentSaveAmbitoQuestionWithSavedListNoLabel:
      "¿Guardamos en este navegador el acceso al MEV con la lista elegida? La próxima vez entrás con el mismo ámbito y lista; podés filtrar por carátula en el listado o pedirlo en el asistente.",
    agentSaveAmbitoYes: "Sí, guardar",
    agentSaveAmbitoNo: "No, solo esta vez",
    agentSaveAmbitoThanks:
      "Listo, quedó guardada en este navegador: la próxima vez verás la búsqueda rápida con el mismo ámbito. ¿Qué estás buscando? Decime en este chat (carátula, organismo, tipo de causa, etc.) y seguimos desde acá.",
    agentSaveAmbitoThanksWithSavedList:
      "Listo: quedó guardado el ámbito y la lista. La próxima vez abrís directo acá; podés filtrar por carátula dentro del listado o escribir en el chat. ¿Qué buscás?",
    agentNoSaveAmbitoAck:
      "Entendido: solo para esta sesión; si cerrás la pestaña, volverás a configurar el ámbito. ¿Qué estás buscando? Escribilo en este chat y seguimos.",
    agentChatPlaceholder:
      "Ej.: causas con carátula García en La Plata, juzgado laboral, solo en letra",
    agentChatSend: "Enviar",
    agentChatClear: "Reiniciar conversación",
    agentChatLoading: "Pensando…",
    agentChatAbortTurn: "Detener búsqueda",
    quickSearchAbort: "Frenar búsqueda",
    quickSearchLabel: "Búsqueda rápida (un mensaje)",
    quickSearchHint:
      "Como máximo 30 causas. Para ver más filas usá el asistente y decí cuántas querés (hasta 200).",
    initialSetupHint:
      "Cargando organismos para filtros manuales y el prompt de IA. No se consulta el listado de la MEV hasta que busques o uses el botón de listado por configuración.",

    loadingListHint: "Obteniendo causas desde la MEV…",
    progress: {},
    agentOpeningGreetingLoading: "Cargando...",
    personalCredsToggleHide: "Ocultar",
    personalCredsToggleShow: "Mostrar",
    personalCredsTitle: "Tu acceso al portal MEV",
    personalCredsIntro:
      "Podés usar tu propio usuario y contraseña de la MEV (mev.scba.gov.ar).",
    personalCredsBadgeOn: "Credenciales personales activas",
    personalCredsBadgeOff: "Usando solo la cuenta del módulo",
    personalCredsUsuarioMasked: "Usuario guardado",
    personalCredsPasswordMasked: "Contraseña",
    personalCredsUsuario: "Usuario MEV",
    personalCredsUsuarioPhUpdate: "Dejá en blanco para no cambiar el usuario",
    personalCredsPassword: "Contraseña MEV",
    personalCredsPasswordPhNew: "Contraseña",
    personalCredsPasswordPhUpdate: "Nueva contraseña (opcional)",
    personalCredsSave: "Guardar",
    personalCredsDelete: "Quitar mi conexión",
    personalCredsDeleteTitle: "Quitar credenciales personales",
    personalCredsDeleteText:
      "Las consultas MEV volverán a usar únicamente la cuenta configurada en el módulo del sistema (si existe).",
    personalCredsDeleteConfirm: "Quitar",
    personalCredsFootnote:
      "La contraseña se guarda cifrada en el servidor: no se puede recuperar ni ver desde esta pantalla. Solo se muestran las dos primeras letras del usuario y puntos en la clave.",
    personalCredsMissingTitle: "Faltan datos",
    personalCredsMissingText: "Indicá usuario y contraseña MEV para guardar.",
    personalCredsSaved: "Credenciales guardadas",
    personalCredsSavedImportText:
      "Tu conexión con la MEV quedó lista. Si querés, ahora mismo podés importar todas las causas desde «My Sets».",
    personalCredsSavedImportButton: "Importar",
    personalCredsSavedLaterButton: "Ahora no",
    personalCredsDeleted: "Listo: se quitaron tus credenciales personales",
    importFromMySets: "Importar causas desde mis sets",
    importFromMySetsLoading: "Leyendo sets y trayendo causas desde la MEV…",
    importFromMySetsConfirm:
      "Se va a leer tu listado de sets en la MEV e importar las causas encontradas. Cada causa se guardará con el nombre del set en el campo type. Este proceso puede tardar según la cantidad de causas que tengas en My Sets.",
    importFromMySetsStep1: "Ingresar al portal MEV con tu usuario.",
    importFromMySetsStep2: "Leer todos los sets de «My Sets» y sus causas.",
    importFromMySetsStep3:
      "Importar cada causa al sistema y asignar su tipo según el set.",
    importFromMySetsMayTakeMinutes: "Esto puede llevar algunos minutos.",
    importFromMySetsWorkingTitle: "Importando causas desde My Sets…",
    importFromMySetsProgress1: "Conectando con MEV y abriendo My Sets…",
    importFromMySetsProgress2: "Leyendo sets y listando causas…",
    importFromMySetsProgress3: "Importando causas al sistema…",
    importFromMySetsProgress4: "Asignando tipo de causa según el set…",
    importFromMySetsProgressCount:
      "Importadas {imported}, con error {failed}. Procesadas {processed} de {total}…",
    importFromMySetsCancel: "Cancelar importación",
    importFromMySetsCancelledTitle: "Importación cancelada",
    importFromMySetsCancelledText:
      "Se canceló la importación desde My Sets. Podés volver a iniciarla cuando quieras.",
    importFromMySetsConfirmButton: "Importar ahora",
    importFromMySetsDoneTitle: "Importación finalizada",
    importFromMySetsNeedLoginTitle: "Primero iniciá sesión en la MEV",
    importFromMySetsNeedLoginText:
      "Para importar causas desde «My Sets» primero guardá tu usuario y contraseña de la MEV en esta misma pantalla.",
    importFromMySetsError: "No se pudo importar desde tus sets",
    personalCredsError: "No se pudo completar la operación",
  },
  aiAboutMe: {
    title: "Lo que la IA sabe de vos",
    open: "Ver todo lo que sabe de vos",
    teaserEmpty: "Te está conociendo",
    teaserBusiest: "fuerte el {day}",
    teaserDays: "{n} días",
    seeMore: "Ver más",
    configure: "Configurar tu IA",
    loading: "Mirando cómo trabajás…",
    empty: "Todavía te está conociendo: a medida que uses el sistema, acá vas a ver cómo trabajás y en qué te puede ayudar.",
    lead: "Aprendió de {days} días tuyos de trabajo: tocaste {records} registros, cargaste {created} y actualizaste {edited}.",
    start: "Solés arrancar",
    end: "Solés terminar",
    busiestDay: "Tu día más cargado",
    busiestHour: "Tu hora pico",
    heatmapTitle: "Cuándo trabajás",
    heatCell: "{day} a las {hour}: {n}",
    modelsTitle: "Con qué trabajás",
    created: "Altas: {n}",
    edited: "Cambios: {n}",
    looked: "Consultas: {n}",
    actions: "Acciones: {n}",
    reportsTitle: "Reportes que mirás",
    reportOpened: "Abierto: {n}",
    habitsTitle: "Lo que hacés siempre",
    daily: "Casi todos los días, a eso de las {hour}, {what}.",
    weekly: "Los {day}, a eso de las {hour}, {what}.",
    sequence: "Cuando cargás un registro de {from}, en la hora siguiente solés cargar uno de {to}.",
    what: {
      create: "cargás registros nuevos de {model}",
      edit: "actualizás registros de {model}",
      look: "revisás {model}",
    },
    whatReport: "abrís el reporte «{name}»",
    whatAction: "{action} de {model}",
    evidenceDays: "{n} de {of} días",
    evidenceWeeks: "{n} de {of} semanas",
    evidenceTimes: "{n} de {of} veces",
    actionNames: {
      email_send: "mandás emails",
      email_trigger_run: "mandás emails",
      pdf_generate: "generás PDF",
      document_print: "imprimís documentos",
      document_excel: "exportás a Excel",
      list_excel_export: "exportás a Excel",
      model_action: "usás botones de acción",
      record_delete: "borrás registros",
      record_delete_permanent: "borrás registros",
      record_bulk_archive: "archivás registros",
      record_restore: "restaurás registros",
      record_bulk_delete: "borrás registros",
      record_bulk_unarchive: "desarchivás registros",
      record_bulk_restore: "restaurás registros",
      record_apply_collect: "aplicás cobros",
      file_upload: "subís archivos",
      copy_shipping_expenses: "copiás gastos",
      other: "usás acciones",
    },
    weekdays: { 1: "lunes", 2: "martes", 3: "miércoles", 4: "jueves", 5: "viernes", 6: "sábado", 7: "domingo" },
    weekdaysPlural: { 1: "lunes", 2: "martes", 3: "miércoles", 4: "jueves", 5: "viernes", 6: "sábados", 7: "domingos" },
    weekdaysShort: { 1: "lu", 2: "ma", 3: "mi", 4: "ju", 5: "vi", 6: "sá", 7: "do" },
    cta: "Todo esto lo puede hacer tu asistente por vos: pedíselo en el chat como se lo pedirías a un compañero.",
    ctaButton: "Pedíselo al asistente",
    footer: "Sale de lo que hiciste en el sistema en los últimos {days} días y se actualiza solo. Solo lo ves vos.",
  },
  aiHub: {
    shortcutExample: "Por ejemplo: cuando te digo “pasame el reporte” un lunes a la mañana, quiero el resumen de los cobros pendientes de esta semana.",
    noChatHintAdmin: "Tocá una para ir a esa pantalla. Con el chat activado, el asistente la hace por vos (Funciones del sistema → Inteligencia artificial).",
    noChatHintUser: "Tocá una para ir a esa pantalla. Con el chat activado, el asistente la hace por vos: pedíselo a un administrador.",
    peekAll: "Configurá tu IA",
    todayHint: "Tocá una para que el asistente la haga en el chat.",
    topButton: "Inteligencia artificial",
    title: "Inteligencia artificial",
    subtitle: "Lo que la IA te propone, lo que aprendió y cómo querés que trabaje con vos.",
    openChat: "Abrir el chat",
    unavailable: "La IA no está activada para tu usuario.",
    todayTitle: "Hoy te propone",
    todayEmpty: "Por hoy no tiene nada para proponerte.",
    adviceOff: "Los consejos diarios están apagados en esta empresa.",
    includedFree: "Incluido (gratis)",
    promptTitle: "Instrucciones del asistente",
    promptHelp: "Lo que el asistente sabe de la empresa y cómo tiene que trabajar. Vale para todos los usuarios. Cuidado: es el cerebro de tu IA. Escribí acá solo cosas de la empresa, no preferencias personales ni cómo querés que te hable a vos: para eso están los atajos y los consejos personalizados.",
    promptOriginalBadge: "Original",
    promptCustomBadge: "Editadas",
    promptEditedBy: "por {name} el {date}",
    promptOriginalChanged: "Las instrucciones originales se actualizaron después de que las editaron y pueden traer reglas nuevas. Revisalas o volvé al original.",
    promptReset: "Volver al original",
    promptResetConfirm: "¿Volver a las instrucciones originales? Se pierde lo que editaron.",
    promptAdminOnly: "Solo un administrador puede cambiarlas.",
    promptUnavailable: "El asistente todavía no está habilitado para esta empresa.",
    customHelp: "Decile qué querés que vigile por vos. Cada mañana lo revisa solo, sin que se lo pidas, y te deja lo que encontró en «Hoy te propone». Por ejemplo: «avisame de los envíos que llegan esta semana sin documentos».",
    shortcutsTitle: "Atajos",
    shortcutsHelp: "Tus palabras para cuando le escribís en el chat: le explicás una vez qué querés decir con una frase y la entiende cada vez que la usás. No hace nada por su cuenta.",
    shortcutAdd: "Agregar",
    shortcutDeleteConfirm: "¿Borrar este atajo?",
    knowledgeTitle: "Lo que aprendió",
    knowledgeAdd: "Enseñarle algo",
    knowledgeTermExample: "Término (por ejemplo: apropiar)",
    knowledgeContentExample: "Qué quiere decir en la empresa",
    modelTitle: "Modelo de IA",
    modelPerMessage: "{usd} por mensaje",
    modelHelp: "Es el modelo que piensa y responde en el chat. Cambia cuánto entiende y cuánto cuesta cada mensaje, no lo que sabe de la empresa: eso está en las instrucciones del asistente.",
    modelTipsTitle: "Cómo elegir",
    modelTipCapableTitle: "Más capaz:",
    modelTipCapable: "entiende mejor los pedidos largos o ambiguos y las cargas de varios pasos, y lee PDF escaneados y fotos. Cada mensaje cuesta más.",
    modelTipCheapTitle: "Más barato:",
    modelTipCheap: "alcanza para consultas simples, como «cuántos envíos llegan esta semana». DeepSeek lee los PDF con texto, pero no los escaneados ni las imágenes.",
    modelTipSavingTitle: "Modo ahorro:",
    modelTipSaving: "el agente trae menos datos en cada paso y cada mensaje sale alrededor de un 20 % más barato. Si notás respuestas peores, desactivalo.",
    modelTipBilling: "El precio por mensaje es aproximado: se cobra lo que se usa. El cambio vale para toda la empresa desde el próximo mensaje.",
    modelTipAdvice: "Los consejos diarios y los personalizados usan su propio modelo: no cambian con esto.",
    chatOffAdmin: "Necesita el chat activado: activalo acá",
    chatOffUser: "Necesita el chat activado: pedíselo a un administrador",
  },
  aiSection: {
    title: "Inteligencia artificial",
    included: "Incluido",
    chatTitle: "Chatear con tu asistente IA",
    chatDescription:
      "Pedile al asistente lo que necesites y lo hace en el sistema: buscar, crear o modificar registros, leer PDF e imágenes. Antes de guardar algo te muestra qué va a cargar y espera tu confirmación. Está en la burbuja abajo a la derecha y en /chat; también atiende el chat de soporte.",
    adviceTitle: "Consejos diarios de tu asistente",
    adviceDescription:
      "Cada mañana, al saludar a cada usuario, tu asistente analiza su actividad y su historial y le deja los consejos que encuentre para arrancar el día: lo que tiene pendiente, lo que quedó a medias y los reportes que suele revisar.",
    adviceNoChat:
      "Sin el chat activado, los consejos se ven igual y llevan a la pantalla correspondiente; para que el asistente haga el trabajo hace falta el chat.",
    customTitle: "Consejos personalizados",
    customDescription:
      "Cada usuario le dice al asistente qué quiere que vigile por él, por ejemplo «avisame de los envíos que llegan esta semana sin documentos». Cada mañana el asistente lo revisa solo, sin que se lo pidan, y le deja el resultado como un consejo más.",
    customFree: "{count} por usuario, gratis.",
    customExtraLabel: "Permitir más consejos personalizados por usuario",
    customExtraHint:
      "Desde el tercero de cada usuario, se cobra por uso: tokens con el mismo margen que el chat.",
    customUsageMonth: "Consejos personalizados este mes",
    customUsageFree: "incluidos: {count} armados",
    customUsagePaid: "pagos: {count} armados = ${amount}",
    customManage: "Mis consejos personalizados",
    customUnavailable: "Los consejos personalizados todavía no están disponibles para tu empresa.",
    customNoDeepseek: "Para armar los consejos personalizados falta la API key de DeepSeek en Ajustes.",
    widgetsTitle: "Widgets IA",
    widgetsDescription: "Widgets del dashboard que te acercan información y preguntas pensadas para tu empresa.",
    widgetsQuestions: "Dudas: preguntas puntuales sobre cómo trabajan, para ajustar el sistema a su forma de trabajo.",
  },
  telegramAiBilling: {
      title: "Agente IA",
      description:
        "Asistente con acciones en el sistema: el chat del Agente IA (la burbuja abajo a la derecha y /chat) y el chat de soporte. Sin este módulo, el chat de soporte solo atiende dudas técnicas.",
      botSetupTitle: "Configurar el bot",
      botSetupHint:
        "Creá el bot manualmente en @BotFather (/newbot), copiá el token y pegalo abajo. Luego registrá el webhook.",
      modelTitle: "Modelo de IA",
      modelDefault: "por defecto",
      modelColModel: "Modelo",
      modelColTypical: "Precio por mensaje",
      modelTypicalReal: "real, {count} mensajes",
      modelTypicalEstimate: "estimado",
      modelSavingLabel: "Modo ahorro",
      modelSavingHint: "El agente trae menos datos en cada paso y lee los PDF como texto: cada mensaje sale alrededor de un 20 % más barato. Si notás respuestas peores, desactivalo.",
      modelHint: "Precio aproximado de un mensaje al agente. Los modelos más capaces entienden mejor pedidos complejos; los más baratos alcanzan para consultas simples. DeepSeek lee los PDF con texto (no los escaneados) y no ve imágenes. El cambio rige desde el próximo mensaje.",
      modelSaved: "Modelo guardado",
      modelPerMessage: "por mensaje",
      usageToday: "Consumo hoy",
      usageTodayHint: "Tokens del Agente IA (todos los canales) contabilizados hoy.",
      usageMonth: "Mes en curso",
      usageMonthHint:
        "Tras la prueba, se factura el consumo mensual de tokens del Agente IA según el uso registrado.",
      usageMonthByChannel: "Desglose por canal",
      channelSupport: "chat interno",
      channelTelegram: "Telegram",
      usageEstimated: "estimado",
      tokens: "tokens",
      trialNoCharge: "prueba gratis",
      payPerUse: "Pago por uso (tokens)",
      swalTrial: "Durante 7 días podés usar el Agente IA sin cargo por tokens.",
      swalPricing:
        "Después se factura cada mes según los tokens consumidos (entrada + salida del modelo).",
      activated: "Agente IA activado. Configurá Telegram y usuarios autorizados si aplica.",
      deactivated: "Agente IA desactivado en facturación.",
  },
  settings: {
    tabGeneral: "General",
    telegramParametersTab: "Parámetros de Telegram",
  },
  twoFactor: {
    title: "Google Authenticator",
    enabled: "Activo: al iniciar sesión se pide el código del teléfono.",
    disabled: "Inactivo: se entra solo con la contraseña.",
    activate: "Activar",
    deactivate: "Desactivar",
    confirm: "Confirmar",
    cancel: "Cancelar",
    stepInstall: "Instalá Google Authenticator en el teléfono.",
    stepScan: "En la app, tocá «+» y escaneá este código QR (o cargá la clave a mano).",
    stepConfirm: "Escribí el código de 6 dígitos que muestra la app.",
    manualKey: "Clave para cargar a mano",
    codePlaceholder: "Código de 6 dígitos",
    codeRequired: "Escribí el código de Google Authenticator.",
    invalidCode: "Código incorrecto.",
    loginHint: "Escribí el código de 6 dígitos de Google Authenticator.",
    backToPassword: "Volver",
    disableHint: "Para desactivarlo, escribí un código actual de la app.",
    enabledOk: "Google Authenticator activado",
    genericError: "No se pudo completar la operación.",
    adminReset: "Quitar 2FA",
    adminResetHint: "Para quien perdió el teléfono: después lo vuelve a activar desde Mi perfil.",
    adminResetConfirm: "{name} va a poder entrar solo con la contraseña hasta que vuelva a activar Google Authenticator.",
  },
  telegramAi: {
    menuItem: "Agente IA",
    title: "Agente IA",
    telegramParametersTitle: "Parámetros de Telegram",
    settingsBotManagedInBilling:
      "El bot de Telegram (@Exportaibot o uno propio) se configura en Facturación → Características del sistema → Agente IA.",
    botSectionTitle: "Bot de Telegram",
    botSectionHint:
      "Por defecto todos los clientes usan @Exportaibot. Podés usar tu propio bot (nombre y logo en BotFather) con «Cambiar bot».",
    platformBotBadge: "Bot plataforma",
    customBotBadge: "Bot propio",
    platformBotNotConfigured:
      "El bot @Exportaibot aún no tiene token en el servidor. Contactá soporte de la plataforma.",
    changeBot: "Cambiar bot",
    changeBotTitle: "Usar tu propio bot de Telegram",
    changeBotStepsHtml:
      "<ol class=\"text-start small mb-0 ps-3\"><li>Abrí <a href=\"https://t.me/BotFather\" target=\"_blank\" rel=\"noopener noreferrer\"><strong>@BotFather</strong></a> en Telegram.</li><li>Enviá <code>/newbot</code> y seguí los pasos (nombre y @ de tu bot).</li><li>Copiá el <strong>token</strong> que te da BotFather.</li><li>Pegalo abajo y confirmá.</li></ol>",
    changeBotTokenPlaceholder: "Pegá el token de BotFather",
    changeBotTokenRequired: "Ingresá el token del bot.",
    changeBotConfirm: "Guardar",
    changeBotSuccess: "Tu bot @{username} quedó activo en Telegram.",
    revertToPlatformBot: "Volver a @{username}",
    revertToPlatformBotTitle: "¿Volver al bot de plataforma?",
    revertToPlatformBotText:
      "Se quitará tu bot propio y volverás a usar @{username} para Telegram. Los usuarios autorizados de Telegram siguen aplicando.",
    revertToPlatformBotDone: "Volviste a @{username}.",
    customWebhookRegistered: "Webhook registrado:",
    webhookPublicBaseHintCustomBot:
      "Solo si usás bot propio y el API no es público: base HTTPS (ngrok) para registrar el webhook al guardar el token en Agente IA.",
    loading: "Cargando…",
    moduleInactive:
      "Activá el módulo «Agente IA» en Módulos del sistema para este tenant.",
    publicWebhookMissing:
      "No se pudo armar la URL pública del webhook (sin host). Pegá la base HTTPS del túnel en el campo opcional al registrar, o definí API_PUBLIC_URL / TELEGRAM_AI_PUBLIC_WEBHOOK_BASE en el servidor.",
    publicBaseFromRequest:
      "La URL del webhook usa el mismo host público del API que esta petición (como accede el front). Si Telegram no llega, definí API_PUBLIC_URL con la base HTTPS canónica del API.",
    enabled: "Asistente por Telegram activo",
    allowlistEmpty:
      "Sin usuarios autorizados de Telegram. Cada usuario debe cargar su @ en Mi perfil; después elegí usuarios acá.",
    allowlistEmptyBilling:
      "Sin usuarios autorizados de Telegram. El @ se carga en Mi perfil; la lista se administra en Facturación → Características del sistema → Agente IA (solo bot de Telegram, no el chat de soporte web).",
    allowedUserIds: "Usuarios autorizados de Telegram",
    allowedUsersPlaceholder: "Buscar por nombre o email…",
    allowedUsersHint:
      "Solo para el bot de Telegram: elegí quién puede escribirle al bot. No restringe el chat de soporte en la web. No podés repetir el mismo @ entre dos usuarios.",
    allowlistMissingTelegramHint:
      "Estos usuarios están autorizados pero no tienen usuario de Telegram en Mi perfil (no podrán usar el bot hasta cargarlo):",
    profileUsername: "Usuario de Telegram",
    profileUsernamePlaceholder: "usuario (sin @)",
    profileUsernameHint:
      "Tu @ de Telegram para que el bot te reconozca. Necesario para figurar en la lista de usuarios autorizados de Telegram.",
    noTelegramOnProfile: "sin usuario de Telegram en perfil",
    allowlistDuplicateTitle: "Mismo @ de Telegram",
    allowlistDuplicateText:
      "Dos o más usuarios elegidos comparten el mismo @ de Telegram ({usernames}). Cada autorizado debe tener un @ distinto en Mi perfil.",
    skippedNoTelegramProfile:
      "Algunos usuarios elegidos no tienen @ de Telegram en su perfil y no se sincronizaron",
    botToken: "Token del bot (BotFather)",
    botTokenKeep: "Dejá en blanco para conservar el token actual",
    webhookUrl: "URL del webhook",
    webhookUrlPreview: "Vista previa de la URL del webhook",
    webhookPublicBaseOptional: "Base pública HTTPS (opcional)",
    webhookPublicBasePlaceholder: "https://xxxx.ngrok-free.app",
    webhookPublicBaseHint:
      "P. ej. ngrok hacia tu API local (https, sin barra final). Guardá con «Guardar»; hace falta para habilitar «Registrar webhook» si el servidor no es público.",
    save: "Guardar",
    registerWebhook: "Registrar webhook en Telegram",
    registerWebhookNeedToken:
      "Configurá y guardá el token del bot antes de registrar el webhook.",
    registerWebhookNeedUrl:
      "Indicá una base HTTPS pública válida (campo opcional) o usá un API con URL pública; debe verse la vista previa del webhook.",
    saved: "Cambios guardados.",
    registerOk: "Webhook registrado.",
    myRules: "Mis reglas",
    myRulesHint:
      "Reglas que la IA aplica en el chat de soporte (y en Telegram si tenés Agente IA). También podés agregarlas con «Recuerda esto:» en el chat. Se comparten con todos los usuarios.",
    myRulesEmpty: "No hay reglas guardadas todavía.",
    myRulesAddLabel: "Nueva regla",
    myRulesAddPlaceholder: "Ej.: cuando digo MF quiero decir Masterfood",
    myRulesAddButton: "Agregar regla",
    myRulesSaved: "Regla guardada.",
    myRulesDeleted: "Regla eliminada.",
    myRulesDeleteTitle: "¿Eliminar esta regla?",
    myRulesDeleteText: "La IA dejará de usarla en mensajes futuros.",
    aiCaptureExportTitle: "Diagnóstico del asistente IA",
    aiCaptureExportHint:
      "Descargá un JSON con todas las rondas de la misma IA (chat de soporte en la web, Telegram y API externa) de los últimos {days} días de este tenant. Podés compartirlo con soporte o Cursor para revisar fallos.",
    aiCaptureExportTenant: "Tenant: {tenant}",
    aiCaptureExportCount: "Rondas guardadas en el período: {count}",
    aiCaptureExportButton: "Exportar diagnóstico JSON",
    aiCaptureExportDone: "Archivo descargado.",
  },
  outlook: {
    profileTitle: "Outlook",
    mailTitle: "Correo Outlook",
    mailboxOf: "Casilla de",
    myMailbox: "La mía",
    mailboxOfUser: "Casilla vinculada por el usuario:",
    readOnlyMailbox:
      "Estás mirando la casilla de otro usuario: se puede leer y analizar, pero responder sale de la casilla de su dueño.",
    connectedAs: "Conectado como",
    notConnected: "No hay cuenta Outlook vinculada.",
    connect: "Conectar Outlook",
    disconnect: "Desconectar",
    disconnectConfirm: "¿Desconectar tu cuenta Outlook?",
    unlink: "Desvincular cuenta",
    unlinkConfirm: "Se va a borrar el vínculo guardado con Outlook para que puedas conectar la cuenta de nuevo desde cero. ¿Continuar?",
    unreadableTokens: "Hay una cuenta Outlook vinculada, pero el sistema ya no puede usar sus credenciales. Desvinculala y volvé a conectarla.",
    sync: "Sincronizar",
    syncDone: "Sincronización: {created} nuevos, {updated} actualizados.",
    oauthNotConfigured: "Un administrador debe configurar Client ID, secret y redirect URI en Settings → Outlook.",
    loading: "Cargando…",
    clientId: "Client ID (Azure)",
    clientSecret: "Client secret",
    redirectUri: "Redirect URI",
    tenantId: "Tenant ID",
    settingsHint: "Registrá la app en Azure AD y usá la misma Redirect URI (p. ej. https://tu-dominio/outlook/oauth/callback).",
    saved: "Parámetros Outlook guardados.",
    oauthSuccess: "Outlook conectado correctamente.",
    oauthInvalid: "Callback OAuth inválido o expirado.",
    allTypes: "Todos",
    received: "Recibidos",
    sent: "Enviados",
    unreadOnly: "Solo no leídos",
    noEmails: "No hay correos sincronizados.",
    selectEmail: "Seleccioná un correo de la lista.",
    from: "De",
    to: "Para",
    tags: "Etiquetas",
    reply: "Responder",
    replyPlaceholder: "Escribí tu respuesta…",
    sendReply: "Enviar respuesta",
    replyAll: "Responder a todos",
    sentOk: "Enviado",
    tagsHint: "Definí palabras clave por etiqueta (lista email_tags). Se aplican al sincronizar o crear correos.",
    noTags: "Aún no hay etiquetas. Creá la primera arriba y después definí sus palabras clave.",
    addTag: "Añadir etiqueta",
    tagName: "Nombre de etiqueta",
    tagNamePlaceholder: "Ej. Urgente, Cliente X",
    keywordsPlaceholder: "palabra1, palabra2, …",
    proposedKeywords: "Propuestas",
    autoKeywords: "Auto keywords",
    notifyTelegram: "Avisar por Telegram al recibir correo con esta etiqueta",
    noProposals: "No hay propuestas (necesitás correos ya etiquetados).",
    acceptProposals: "Aceptar propuestas",
    tagsPanelTitle: "Etiquetas de correo Outlook",
    showingRange: "Mostrando {from}–{to} de {total}",
    newer: "Más nuevos",
    older: "Más viejos",
    analysisRobot: "Lo que detectó el análisis",
    analysisUnverified: "Detectado pero sin contrato al que ligarlo",
    analyzePage: "Analizar la página",
    analyzePageConfirm:
      "Se van a analizar {count} correos, uno por uno. Cada uno consulta a la IA y aplica lo que encuentre.",
    analyzePageAlready: "{count} de ellos ya estaban analizados: se vuelven a analizar con las reglas de ahora.",
    analyzePageProgress: "Analizando {done} de {total}…",
    analyzePageDone: "Analizados {done} de {total}. Fallaron {failed}.",
    analyzeStopping: "Cortando…",
    warnNoRecord: "Se detectó el hito, pero el contrato que menciona el correo no está cargado en el sistema.",
    warnNoRecordAmbiguous: "Se detectó el hito, pero hay {count} contratos posibles y ninguno se impone: quedó sin vincular.",
    warnNoShipment: "No se pudo ligar a ningún embarque del contrato {record}.",
    warnShipmentSuggested: "El embarque «{shipment}» quedó como sugerencia: hace falta confirmarlo a mano.",
    warnUnverified: "{tags}: no se pudo comprobar que el correo fuera con la parte que la etiqueta exige.",
    warningsTitle: "Por qué quedó a medias",
    searchPlaceholder: "Buscar correos…",
    searchClear: "Limpiar la búsqueda",
    firstPage: "Ir a la primera página",
    lastPage: "Ir a la última página",
    pageNumber: "Número de página",
    analysisRemoved: "Etiquetas que se quitaron",
    analysisRejected: "Descartadas por la IA",
    tagDirection: "Dirección del correo",
    tagDirectionAny: "Cualquiera (recibidos y enviados)",
    tagDirectionReceived: "Solo recibidos",
    tagDirectionSent: "Solo enviados",
    clearTagFilter: "Quitar filtro",
    tagCounterparty: "Parte que tiene que estar en el correo",
    tagCounterpartyAny: "Cualquier parte del registro",
    tagCounterpartyHint:
      "Exige que esa parte del contrato participe del correo, como remitente o como destinatario. Que el correo sea entrante o saliente lo decide «Dirección del correo», aparte. Sin contrato vinculado la etiqueta no se aplica.",
    openLinkedRecord: "Abrir el registro vinculado",
    openLinkedContact: "Abrir el contacto",
    closeEmail: "Cerrar y volver al listado",
    analyze: "Analizar",
    analyzeHint: "Busca a qué registro y contacto pertenece el correo, y lo etiqueta.",
    analysisRecord: "Vinculado a",
    analysisContact: "Contacto",
    analysisTags: "Etiquetas",
    analysisConfidence: "Confianza",
    analysisAttachments: "Adjuntos leídos",
    analysisShipment: "Envío",
    openLinkedShipment: "Abrir el embarque",
    confirmShipmentHint: "Embarque sugerido: click para confirmarlo",
    confirmShipmentTitle: "¿Es este el embarque?",
    confirmShipmentAction: "Sí, es este",
    analysisShipmentPending: "sin aplicar: {reason}",
    analysisAttachmentsNone: "no se pudo leer ninguno (¿es un escaneo?)",
    deleteTagTitle: "Eliminar etiqueta",
    deleteTagConfirm: "Se elimina «{tag}» y se quita de los correos que la tenían. No se puede deshacer.",
    deleteTagDone: "Quitada de {count} correo(s).",
    tabMail: "Correo",
    etd: "ETD",
    bookingNumber: "Booking",
    vessel: "Buque",
    extracted: "Datos del correo",
    tabKeywords: "Keywords",
    tagKeywordsTitle: "Palabras clave",
    tagFromAi: "lo decidió la IA por el contenido, sin palabra clave",
    tagWithoutKeywords: "Esta etiqueta todavía no tiene palabras clave: cargalas en el tab Keywords",
    keywordsTabHint:
      "Las palabras clave con las que el sistema reconoce de qué trata cada correo. Si ves un correo que debería haber quedado etiquetado y no lo quedó, agregá acá la palabra o la frase que lo delata: separalas con comas y guardá.",
    tabConfig: "Configuración",
    aiDescription: "Cuándo aplica (para la IA)",
    aiDescriptionPlaceholder: "Ej. el remitente confirma que el anticipo ya fue pagado",
    detection: {
      title: "Detección sobre los correos",
      hint: "Reglas con las que cada correo recibido se vincula a un registro y se etiqueta. Primero corren las reglas exactas; la IA sólo elige entre los candidatos que dejaron.",
      enabled: "Activar la detección",
      targetLegend: "Registro a vincular",
      targetModel: "Modelo",
      codeField: "Campo con el código",
      codePattern: "Patrón del código",
      numberField: "Campo con el número",
      numberPattern: "Patrón del número",
      referencePattern: "Patrón de la referencia (número con prefijo)",
      referencePatternHint:
        "Para cuando el correo nombra el contrato con un prefijo en vez del código completo, como «CT 6479». El grupo entre paréntesis es el número que se busca; vale igual que el código exacto.",
      patternHint: "Expresiones regulares. El código es la coincidencia fuerte (ej. 1157/00/26); el número suelto (ej. 1157) sólo cuenta como candidato dudoso y necesita confirmarse con el contacto o con el hilo.",
      signalsLegend: "Señales de apoyo",
      useThread: "Heredar el vínculo de otro correo del mismo hilo",
      useContactCrossCheck: "Cruzar el remitente/destinatario contra las partes del registro",
      contactRoleFields: "Campos con las partes (referencias a Contact)",
      noContactFields: "El modelo elegido no tiene campos que referencien a Contact.",
      aiLegend: "Capa de IA",
      aiEnabled: "Usar IA para elegir entre los candidatos y detectar etiquetas",
      maxAgeHours: "Antigüedad máxima que barre el cron (horas)",
      maxAgeHoursHint: "El cron solo analiza correos más nuevos que esto, así prenderlo no dispara el análisis de toda la casilla histórica. Los correos viejos se analizan a mano con el botón. 0 = sin límite.",
      autoApply: "Qué se aplica solo",
      autoApplyNever: "Nada: todo queda pendiente de validación",
      autoApplyHigh: "Sólo lo de confianza alta; el resto queda pendiente",
      autoApplyHint: "Lo que no se aplica solo queda como sugerencia para revisar a mano.",
    },
    hasAttachments: "Tiene adjuntos",
    openAttachment: "Abrir",
    downloadAttachment: "Descargar",
    noAttachmentsList: "No se encontraron adjuntos.",
  },
  Apropiar: "Apropiar",
  Apropiaciones: "Apropiaciones",
  "Cláusulas PDF": "Cláusulas PDF",
  Envíos: "Envíos",
  "Líneas de posición": "Líneas de posición",
  alisofContactPdfGaps: "A {name} le falta cargar en su ficha: {missing}. El PDF sale sin ese dato.",
  alisofContactPdfGapAddress: "dirección",
  alisofContactPdfGapTaxId: "Tax ID (RFC)",
  alisofEmpresaAdminRuleNotice:
    "El vendedor es de {country}: por la regla la empresa administradora sería {expected}, y este contrato tiene {current}. No se cambia solo — revisá si corresponde.",
  alisofApropiarNeedsSave: "Guardá el contrato antes de apropiar posiciones.",
  alisofApropiarNeedsPosicionId: "Guardá el contrato para que las posiciones tengan identificador antes de apropiar.",
  alisofApropiarSelectPositions: "Seleccioná al menos una posición.",
  alisofApropiarEnvioTitle: "Apropiar posiciones",
  alisofApropiarEnvioHint: "Completá los datos de la apropiación para {count} posición(es).",
  alisofEnvioGroupTitle: "Apropiación",
  alisofEnviosEmpty: "Las apropiaciones se crean al apropiar posiciones.",
  alisofEnvioLineasLabel: "Posiciones de la apropiación",
  alisofEnvioLineaSinPosicion: "Posición no encontrada",
  Invoices: "Facturas",
  alisofFacturaGroupTitle: "Factura",
  alisofFacturaCobrada: "Cobrada",
  alisofFacturaPendienteCobro: "Pendiente de cobro",
  alisofFacturasEmpty: "Las facturas se crean al facturar apropiaciones.",
  alisofInvoicePdf: "INVOICE PDF",
  alisofFacturaDescripcionHint: "Es el concepto: sale en la factura, arriba de los datos bancarios.",
  alisofFacturaSinContrato: "Factura sin contrato",
  alisofFacturaSinContratoHint: "Para asesoramientos y contratos cedidos: el cliente y el importe se cargan a mano.",
  alisofSelectPosicion: "Seleccionar posición {n}",
  alisofIncotermTooltip: "Incoterm pactado en el contrato (Precio base)",
  alisofApropiadaSinEnvioVinculado: "Apropiada (sin apropiación vinculada)",
  alisofApropiarCreated: "Apropiación creada",
  alisofApropiarNPositions: "Apropiar {count} positions",
  alisofAutoAppropriation: "Auto apropiación",
  alisofGroupPositions: "Group positions",
  alisofGroupPositionsConfirm:
    "Se crearán apropiaciones pendientes agrupando las posiciones disponibles por fecha de embarque. ¿Continuar?",
  alisofGroupPositionsNone: "No hay posiciones disponibles para agrupar.",
  alisofGroupPositionsDone: "{count} apropiación(es) pendiente(s) creada(s)",
  alisofPositionsInApropiacionesHint:
    "{count} posición(es) ya están en Apropiaciones; editá allí los datos de embarque.",
  alisofEnvioTabPendiente: "Pendiente",
  alisofEnvioTabCumplido: "Cumplido",
  alisofEnvioTabTodas: "Todas",
  alisofEnviosTabEmpty: "No hay apropiaciones en esta pestaña.",
  alisofEnvioEstadoPendiente: "Pendiente",
  alisofEnvioEstadoCumplido: "Cumplido",
  alisofMarkEnvioCumplido: "Marcar cumplido",
  alisofMarkEnvioCumplidoConfirm:
    "¿Marcar esta apropiación como cumplida? Las posiciones ligadas pasarán a Cumplido.",
  alisofMarkEnvioCumplidoConfirmN:
    "¿Marcar {count} apropiaciones como cumplidas? Las posiciones ligadas pasarán a Cumplido.",
  alisofMarkEnvioCumplidoDone: "Apropiación marcada como cumplida",
  alisofMarkEnvioCumplidoDoneN: "{count} apropiaciones marcadas como cumplidas",
  alisofCreateApropiacionError: "No se pudo crear la apropiación. Probá de nuevo.",
  alisofDeleteApropiacion: "Eliminar apropiación",
  alisofDeleteApropiacionTitle: "¿Eliminar esta apropiación?",
  alisofDeleteApropiacionText:
    "Las posiciones volverán a estar disponibles para seleccionar y apropiar de nuevo.",
  alisofDeleteApropiacionDone: "Apropiación eliminada",
  alisofDeleteApropiacionError: "No se pudo eliminar la apropiación. Probá de nuevo.",
  alisofApropiarExisting: "Ya existe una apropiación para esta posición",
  alisofVerApropiacion: "Ver apropiación",
  alisofVerApropiacionNum: "Apropiación {n}",
  alisofPosicionApropiada: "Apropiada",
  alisofHeroLinkedApropiaciones: "Apropiaciones ligadas",
  alisofApropiacionViaContrato: "Contrato",
  alisofApropiacionViaPosicion: "Posición",
  alisofFacturar: "Generar factura",
  "Encabezado PDF": "Encabezado PDF",
  alisofFacturarTitle: "Facturar apropiaciones",
  alisofFacturarHint: "Monto total de comisión de {count} apropiación(es) seleccionada(s).",
  alisofFacturarSelectApropiaciones: "Seleccioná al menos una apropiación.",
  alisofSelectApropiacion: "Seleccionar apropiación {n}",
  alisofFacturarCreated: "Factura registrada",
  alisofEnvioFacturada: "Facturada",
  alisofFacturarAlreadyFacturada: "Una o más apropiaciones ya fueron facturadas.",
  alisofFacturarNeedsCumplido:
    "Solo se pueden facturar apropiaciones en estado Cumplido. Marcá como cumplido antes de facturar.",
  alisofFacturarNeedsSave: "Guardá el contrato antes de facturar apropiaciones.",
  alisofCreateFacturaError: "No se pudo registrar la factura. Probá de nuevo.",
  alisofRegenerarDescripcion: "Regenerar desde apropiación",
  alisofFacturaTipoDeCambioRequerido: "Ingresá el tipo de cambio para facturas tipo A.",
  alisofFacturaTipoDeCambioBnaBillete: "BNA billete venta",
  alisofFacturaTipoDeCambioBnaRefresh: "Actualizar cotización",
  alisofFacturaTipoDeCambioBnaError: "No se pudo obtener la cotización del BNA.",
  alisofDeleteFacturaTitle: "Eliminar factura",
  alisofDeleteFacturaText:
    "¿Eliminar esta factura? Las apropiaciones que incluía podrán volver a facturarse.",
  alisofDeleteFacturaError: "No se pudo eliminar la factura. Probá de nuevo.",
  notaComercial: {
    noteForm: {
      sectionTitle: "Datos de la nota",
      modalTitle: "Nota comercial",
      contactRoleLabel: "Rol del contacto",
      contactRoleSupplierHint:
        "Del lado del proveedor el rol puede ser el tipo del gasto (Freight, Courrier…). El lado contable se deriva igual: todo rol que no sea Client es del proveedor.",
      contactRoleHint: "Es el rol con el que se guarda; si nace de una línea de gasto, toma el tipo de esa línea.",
      noteKindLabel: "Tipo de nota",
      assignmentLabel: "Aplicado a",
      assignmentTarget: "Destino",
      assignmentNone: "Sin referencia (directo al contacto)",
      assignmentShipping: "Aplicar a shipping",
      assignmentProform: "Aplicar a proforma",
      noCurrency: "Sin moneda",
      commentPlaceholder: "Comentario interno de la nota",
      descriptionPlaceholder: "Texto de DESCRIPTION en el PDF (p. ej. country of origin / destination)",
      validationTitle: "Faltan datos",
      validationContact: "Selecciona un contacto.",
      currencyMismatchTitle: "La moneda no coincide",
      currencyMismatch: "La nota está en una moneda distinta a la del gasto al que se aplica. Cargá la nota en la moneda del gasto o aplicala a otra operación.",
      missingFileTitle: "Nota sin adjunto",
      missingFileText: "Esta nota es de las que nos emite el contacto y no tiene archivo adjunto. El documento adjunto es lo que la respalda.",
      missingFileCancel: "Adjuntar",
      validationAmount: "El monto debe ser mayor a 0.",
      validationAppliedAmount: "Cada aplicación debe tener un monto mayor a 0.",
      appliedNothingPendingTitle: "Gasto ya pago",
      appliedNothingPendingFor:
        "Esta nota se abrió para {contact}, desde un gasto que ya está pago entero: no le queda saldo para descontarle la nota.",
      appliedNothingPendingOtherContact: "Si querés cargar una nota para otro contacto, hacelo desde el",
      appliedNothingPendingSimulatorLink: "simulador de notas comerciales",
      validationAppliedNothingPending:
        "Este gasto ya está pago entero: no le queda saldo para descontarle la nota, así que no se le puede aplicar.",
      validationAppliedExceeds: "La suma aplicada no puede superar el monto de la nota.",
      validationShipping: "Selecciona un shipping.",
      validationProform: "Selecciona una proforma.",
      numberLabel: "Número",
      numberLabelCredit: "Número (nota de crédito)",
      numberLabelDebit: "Número (nota de débito)",
      numberLabelReceived: "Número del emisor (opcional)",
      numberPlaceholder: "Ej. 2074/2026 (opcional)",
      numberPlaceholderReceived: "Número de la nota que nos enviaron",
      numberHint:
        "Podés dejarlo vacío y cargarlo después; el sistema puede asignar el siguiente número automático.",
      numberHintCredit:
        "Secuencia propia de crédito: usá Generate o dejalo vacío y se asigna al guardar (p. ej. 2074/2026).",
      numberHintDebit:
        "Secuencia propia de débito (independiente): usá Generate o dejalo vacío y se asigna al guardar.",
      numberHintReceived:
        "Al recibir una nota no generamos número: podés cargar el que figura en el documento del emisor.",
      numberGeneratedOnSaveCredit:
        "El número de la nota de crédito se asigna al guardar, con su propia secuencia.",
      numberGeneratedOnSaveDebit:
        "El número de la nota de débito se asigna al guardar, con su propia secuencia.",
      attachFileLabel: "Adjuntar archivo",
      attachFileHint: "Opcional: la nota tal como la recibimos, o cualquier respaldo.",
      remainingCreditAlert:
        "Queda un saldo de {amount} sin aplicar a un embarque. Podés usarlo en la siguiente orden editando la nota y aplicándolo ahí.",
      creditOnFullyCollectedShippingTitle: "No se puede guardar la nota",
      creditOnFullyCollectedShipping:
        "No se puede emitir una nota que reduce lo pendiente de un embarque donde ya se saldó todo: la nota descuenta de lo que falta y no queda nada de dónde descontar. Para reclamar un importe extra emitile una nota que aumente el pendiente. Las notas que nos emite la otra parte —un crédito del proveedor, un débito recibido del cliente— no se validan contra el saldo del embarque.",
      creditExceedsShippingPendingTitle: "Monto mayor al pendiente",
      creditExceedsShippingPending:
        "No se puede guardar una nota cuyo monto aplicado al embarque supera lo pendiente que reduce. Reducí el importe, o usá una nota que aumente el pendiente si querés reclamar la diferencia.",
      contactNotInOperationTitle: "La nota no es de esta operación",
      contactNotInOperation:
        "No se puede aplicar la nota a una operación en la que su contacto no participa. De un embarque participan su cliente, su proveedor y los contactos de sus gastos. Elegí otra operación, o emití la nota al contacto correcto.",
      kindClientCredit: "Credito nuestra al cliente",
      kindClientDebit: "Debito nosotros al cliente",
      kindSupplierCredit: "Credito de proveedor a nosotros",
      kindSupplierDebit: "Debito de proveedor a nosotros",
    },
    simulator: {
      title: "Notas comerciales",
      subtitle: "Alta simple + simulacion de impacto contable y financiero",
      simulateImpact: "Simular impacto",
      createNote: "Crear nota comercial",
      impactTitle: "Simulacion de impacto",
      lastSimulation: "Ultima simulacion: {time}",
      impactEmpty: 'Completa los datos y presiona "Simular impacto".',
      accountStatementCaption: "Cuenta corriente (Account Statement)",
      currentBalance: "Saldo final actual",
      simulatedDelta: "Delta simulado",
      projectedBalance: "Saldo final proyectado",
      accountingCaption: "Accounting",
      accountingCurrentTotal: "Total actual de asientos (filtro contacto)",
      accountingDelta: "Delta simulado del asiento",
      accountingProjected: "Total proyectado",
      ruleCaption: "Regla aplicada para esta simulacion",
      financeCaption: "Finance (sobre referencia aplicada)",
      collectedCurrent: "Collected actual",
      collectedProjected: "Collected proyectado",
      balanceCurrent: "Balance actual",
      balanceProjected: "Balance proyectado",
      invoiceCurrent: "Invoice actual",
      invoiceProjected: "Invoice proyectado",
      financeEmpty: "Sin referencia shipping/proforma: no se simulan totales de finance por operacion.",
      recentTitle: "Ultimas notas comerciales creadas",
      recentEmpty: "No hay notas recientes.",
      simulationFailed: "No se pudo simular el impacto.",
      createFailed: "No se pudo crear la nota.",
      createdTitle: "Nota comercial creada",
      createdNumber: "Numero",
      createdKind: "Tipo de nota",
      createdApplied: "Aplicado a operaciones",
      createdRemaining: "Sin aplicar",
      createdNumberPending: "Sin numero (la carga el emisor)",
      openNote: "Ver nota",
      editNote: "Editar nota",
      recentNumber: "Numero",
      recentActions: "Acciones",
    },
    pending: {
      badgeTitle: "Notas comerciales sin aplicar: {count} — saldo {amount}",
      badgeLine: "{name}: {amount}",
      badgeHint: "Click para ver el detalle",
      popupTitle: "Notas comerciales pendientes",
      popupSubtitle: "{count} nota(s) sin aplicar — saldo total {amount}",
      popupMore: "Y {count} más. Abrí el listado para verlas todas.",
      popupOpenList: "Ver todas",
      popupClose: "Cerrar",
      ofTotal: "de",
      kindCredit: "Crédito",
      kindDebit: "Débito",
    },
    pdf: {
      openButton: "PDF nota comercial",
      openTitle: "Abrir PDF de la nota comercial",
    },
    unapply: {
      iconTitle: "Quitar esta nota de la operación",
      confirmTitle: "¿Quitar la nota de la operación?",
      confirmText:
        "Se va a quitar «{note}» de {operation}. La nota no se borra: su saldo queda libre para aplicarla donde corresponda.",
      confirmButton: "Quitar",
      errorTitle: "No se pudo quitar la nota",
      errorGeneric: "No se pudo quitar la nota de la operación. Probá de nuevo.",
      thisShipping: "este embarque",
    },
    assign: {
      buttonClient: "Asignar nota del cliente",
      buttonSupplier: "Asignar nota del proveedor",
      tooltip: "Este contacto tiene {count} nota(s) con saldo. Aplicá una a esta operación en lugar de crear otra.",
    },
    offerOnCreate: {
      moduleConfigLabel: "Ofrecer notas comerciales al elegir cliente o proveedor",
      moduleConfigHelp:
        "Si está activo, al elegir el cliente de una Proforma o el proveedor de un embarque se proponen sus notas comerciales con saldo disponible (cualquier moneda). Corre al crear y también al cambiar el contacto de un registro existente; abrir un registro no dispara nada.",
      title: "Notas comerciales disponibles",
      subtitleClient:
        "Este cliente tiene notas comerciales con saldo. Podés aplicar una a la proforma.",
      subtitleSupplier:
        "Este proveedor nos dio notas comerciales con saldo. Podés aplicar una al embarque.",
      kindCredit: "Crédito",
      kindDebit: "Débito",
      totalAmount: "Monto total",
      availableBalance: "Saldo pendiente",
      applyAmount: "Monto a aplicar",
      skip: "Cancelar",
      confirm: "Confirmar",
      applyErrorTitle: "No se pudo aplicar la nota",
      applyErrorExceeds: "El monto supera el saldo disponible de la nota.",
      applyErrorGeneric: "La operación se creó, pero no se pudo vincular la nota comercial.",
    },
  },
  exchangeRates: {
    columns: {
      rate: "T. cambio",
      rateHint: "Tipo de cambio de la operación: tocá para ver la cotización oficial o fijar una propia",
      converted: "En {currency}",
      totalConverted: "Total en {currency}",
      systemCurrency: "Moneda del sistema",
      convertedHint: "Con el tipo de cambio de la operación: 1 {from} = {rate} {to}",
      mixed: "Varios",
      mixedHint: "Cada shipping tiene su tipo de cambio: se ve y se cambia en la fila de cada shipping o desde el shipping",
      sharedHint: "Es el tipo de cambio de varios shippings: se cambia en la fila de cada shipping o desde el shipping",
    },
    expenseChange: {
      title: "Cambio de moneda del gasto",
      question: "El gasto era de <strong>{amount} {from}</strong>. ¿Cómo lo querés guardar en {to}?",
      convert: "Convertir a {amount} {currency}",
      keep: "Mantener {amount} {currency}",
      rateHint: "Tipo de cambio de la operación: 1 {from} = {rate} {to}. «Mantener» es para cuando la moneda estaba mal cargada y el importe ya era en {to}.",
      hasPayments: "Este gasto ya tiene <strong>{applied} {from}</strong> en <strong>«Applied / requested»</strong> (pagos aplicados).<br><br>Se cambió la moneda a {currency}, pero <strong>«Amount»</strong> no se convierte: queda en <strong>{amount} {currency}</strong>, para que no quede distinto de lo aplicado en pagos.<br><br>Si el importe correcto en {currency} es otro, corregí «Amount» y los pagos que forman «Applied / requested».",
      missingRate: "No hay tipo de cambio para convertir: el importe se mantiene en {amount} {currency}.",
    },
    source: {
      bcra: "Oficial BCRA",
      frankfurter: "Oficial Frankfurter (BCE)",
      manual: "Personalizada",
      frozen: "Congelada",
      settings: "Cotización de Ajustes",
      missing: "Sin cotización",
    },
    modal: {
      title: "Tipo de cambio {from} → {to}",
      officialOf: "cotización del {date}",
      noOfficial: "No hay cotización oficial guardada para esta moneda.",
      operationRate: "Tipo de cambio de la operación ({from} → {to})",
      unlockHint: "Desbloquear para fijar una cotización propia para esta operación",
      lockHint: "Volver a bloquear sin cambios",
      customHint: "La cotización que cargues vale para toda la operación y no sigue a la oficial.",
      setBy: "Fijada por {name} el {date}",
      frozenHint: "La operación terminó (cobrada y pagada): quedó fija la oficial del {date}.",
      restoreOfficial: "Volver a la oficial",
      cancel: "Cancelar",
      save: "Guardar",
      saveError: "No se pudo guardar el tipo de cambio.",
    },
  },
};
